<template>
  <v-content>
    <template v-if="maintain">
      <div class="d-flex justify-center align-center">
        <span style="font-size: 50px;color: #ff6d81">{{ pageMessage }}</span>
      </div>
    </template>
    <template v-else>
      <v-container v-show="Details">
        <v-card style="border: 1px solid">
          <v-toolbar
              :color="appColor">
            <v-card-title class="headline mb-1">
              <span style="color:white"> สมัครเข้าร่วมงาน</span>
            </v-card-title>
          </v-toolbar>
          <v-list-item>
            <v-row>
              <v-col
                  cols="12">
                <v-expand-transition>
                  <v-card v-if="!Details_Cordi"
                          style="border: 1px solid"
                  >
                    <v-row
                        justify="center"
                        class="d-flex justify-center">
                      <v-col
                          cols="12"
                          md="12">
                        <v-card-title>
                          ตารางข้อมูลรายละเอียดงาน
                          <v-spacer></v-spacer>
                          <v-text-field
                              v-model="search"
                              append-icon="mdi-magnify"
                              label="ค้นหา รหัสแผน"
                              single-line
                              hide-details
                          ></v-text-field>
                        </v-card-title>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                          cols="12"
                          md="12"
                          class="d-flex justify-center"
                      >
                        <v-radio-group row v-model="TypeRequest" @change="ChooseTypeRequest">
                          <v-radio value="0" class="font-weight-bold" label="ทั้งหมด"></v-radio>
                          <v-radio value="1" class="font-weight-bold" label="งานตามสิทธิ์"></v-radio>
                          <v-radio value="2" class="font-weight-bold" label="งานที่เปิดรับสมัคร"></v-radio>
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-list v-if="TypeRequest == '2'">
                      <v-list-item class="d-flex justify-center">
                        <v-radio-group row v-model="TypeStatus" @change="ChooseTypeRequest">
                          <v-radio class="font-weight-bold" label="งานทั้งหมด" value="0"></v-radio>
                          <v-radio class="font-weight-bold" label="งานที่ยังเปิดรับสมัคร" value="1"></v-radio>
                        </v-radio-group>
                      </v-list-item>
                    </v-list>
                    <v-row
                        justify="center"
                        class="justify-center">
                      <v-col
                          cols="12"
                          md="12"
                      >

                        <!--                        @click:row="GetData"-->
                        <v-data-table
                            :headers="courseHeaders"
                            :items="projectDataToTable"
                            :search="search"
                            item-key="idx"
                            :single-expand="singleExpand"
                            :expanded.sync="expanded"
                            class="elevation-1"
                        >
                          <template v-slot:header.Project_code>
                            <v-label
                                fontSize="16px"
                                fontWeight="bold">
                              รหัสแผน
                            </v-label>
                          </template>
                          <template v-slot:header.full_Name>
                            <v-label
                                fontSize="16px"
                                fontWeight="bold">
                              งาน / กิจกรรม
                            </v-label>
                          </template>
                          <template v-slot:header.DateS_Reg>
                            <v-label
                                fontSize="16px"
                                fontWeight="bold">
                              วันที่เปิดรับสมัคร
                            </v-label>
                          </template>
                          <template v-slot:header.DateE_Reg>
                            <v-label
                                fontSize="16px"
                                fontWeight="bold">
                              วันที่สิ้นสุดการรับสมัคร
                            </v-label>
                          </template>
                          <template v-slot:header.Count_Reg>
                            <v-label
                                fontSize="16px"
                                fontWeight="bold">
                              จำนวนผู้สมัคร
                            </v-label>
                          </template>
                          <template v-slot:item.Project_Details="{ item }">
                            <v-btn
                                text
                                color="primary"
                                @click="showDetails(item)"
                                v-if="item.Status_Reg == '0'"
                            >
                              สมัครเข้าร่วม
                            </v-btn>
                          </template>
                          <template v-slot:item.full_Name="{ item }">
                            <div v-html="item.full_Name"></div>
                          </template>
                          <template v-slot:expanded-item="{ headers, item }">
                            <td :colspan="headers.length">
                              <div v-for="(file, idx) in item.files" v-bind:key="idx">
                                {{ item.files }}
                                <v-btn color="primary" text @click="ShowData(Openfile + file.File_path)">ไฟล์ :
                                  {{ file.File_name }}
                                </v-btn>
                              </div>
                            </td>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-expand-transition>
              </v-col>
            </v-row>
          </v-list-item>
          <v-card-text>
            <v-row class="d-flex justify-center">
              <v-col
                  cols="12"
                  md="12">
                <template v-if="Details_Cordi">

                  <v-list-item>
                    <v-btn
                        outlined
                        color="#FF5722"
                        @click="showDetails">
                      ย้อนกลับ
                    </v-btn>
                  </v-list-item>

                  <v-card class="justify-center pa-6 mt-7">
                    <v-card-title
                        color="primary"
                        style="background-color: burlywood"
                    >
                      <span style="color: blue;font-weight: bold">งาน : {{ project.full_Name2 }}</span>
                    </v-card-title>

                    <v-card-text class="mt-4">
                      <div align="center" v-if="GroupExamData.length > 0">
                        <h3 style="color:darkred;">
                          กลุ่มตัวอย่าง
                        </h3>
                      </div>
                      <div v-for="(Exam_i,idxEx) in GroupExamData" :key="idxEx" align="center">
                        <span style="font-weight: bold;color: #364eff">
                          *** {{ Exam_i.PosName }} อายุงาน : {{ Exam_i.WSYear }} ปี ถึง {{ Exam_i.WEYear }} ***
                        </span>
                      </div>
                      <div align="center" v-if="QoutaDepDataDump.length > 0" style="margin-top: 25px">
                        <h3 style="color:darkred;">
                          จำนวนโควตาหน่วยงานเข้าร่วม
                        </h3>
                      </div>
                      <div v-for="(DepQ,idx) in QoutaDepDataDump" :key="idx" align="center">
                        <span
                            v-if="DepQ.dep_type == '0' && depart.filter(dep_i => dep_i.dep_id == DepQ.dep_id).length > 0"
                            style="font-weight: bold;color: #364eff">
                          *** หน่วยงาน : {{ depart.filter(dep_i => dep_i.dep_id == DepQ.dep_id)[0].dep_name }} จำนวน : {{
                            DepQ.count
                          }} คน ***
                        </span>
                        <span v-else-if="depart.filter(dep_i => dep_i.dep_group_id == DepQ.dep_group_id).length > 0"
                              style="font-weight: bold;color: #364eff">
                          *** กลุ่มหน่วยงาน : {{
                            depart.filter(dep_i => dep_i.dep_group_id == DepQ.dep_group_id)[0].dep_name
                          }} จำนวน : {{ DepQ.count }} คน ***
                        </span>
                      </div>
                      <v-tabs
                          v-model="tab"
                          background-color="transparent"
                          color="basil"
                          show-arrows
                      >
                        <v-tabs-slider color="teal lighten-3"></v-tabs-slider>

                        <v-tab>
                          บุคลากรคณะแพทย์
                        </v-tab>
                      </v-tabs>

                      <v-tabs-items v-model="tab">
                        <v-tab-item>
                          <v-list-item>
                            <v-row class="d-flex justify-center">
                              <v-col
                                  class="d-flex justify-center"
                                  cols="12"
                                  md="6">
                                <v-radio-group v-model="TypeInsert" row>
                                  <v-radio class="font-weight-bold" label="ค้นหาโดยชื่อ / รหัสบุคลากร" value="1"></v-radio>
                                  <v-radio class="font-weight-bold" label="ค้นหาโดยตัวเลือก"
                                           value="2"></v-radio>
                                </v-radio-group>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item v-if="TypeInsert == '1'" style="margin-top: 25px">
                            <v-row class="d-flex justify-center">
                              <v-col
                                  cols="12"
                                  md="6">
                                <v-autocomplete
                                    v-if="project.Owner"
                                    v-model="staffSel"
                                    label="ค้นหาบุคลากร"
                                    :items="staffDataDump"
                                    item-text="customDetail"
                                    item-value="perid"
                                    hint="กด Enter เพื่อเป็นการเพิ่มข้อมูล"
                                    persistent-hint
                                    clearable
                                    outlined
                                    @keyup="checkKeyEnterOwner"
                                ></v-autocomplete>
                                <!--                              <v-autocomplete
                                                                  v-if="project.Owner"
                                                                  v-model="staffSel"
                                                                  label="ค้นหาบุคลากร"
                                                                  :items="staffDataDump"
                                                                  item-text="customDetail"
                                                                  item-value="perid"
                                                                  hint="กด Enter เพื่อเป็นการเพิ่มข้อมูล"
                                                                  persistent-hint
                                                                  clearable
                                                                  outlined
                                                                  @keyup="checkKeyEnter"
                                                              ></v-autocomplete>-->
                                <v-autocomplete
                                    v-else
                                    v-model="staffSel"
                                    label="ค้นหาบุคลากร"
                                    :items="staffDataDump"
                                    item-text="customDetail"
                                    item-value="perid"
                                    hint="กด Enter เพื่อเป็นการเพิ่มข้อมูล"
                                    persistent-hint
                                    clearable
                                    outlined
                                    @keyup="checkKeyEnter"
                                ></v-autocomplete>
                              </v-col>
                              <v-col
                                  cols="12"
                                  md="4">
                                <v-file-input
                                    v-model="filesP"
                                    color="deep-purple accent-4"
                                    counter
                                    label="แนบไฟล์ (ถ้ามี)"
                                    multiple
                                    placeholder="เลือกไฟล์"
                                    prepend-icon="mdi-paperclip"
                                    outlined
                                    :show-size="1000"
                                    @change="FileSelect"
                                >
                                  <template v-slot:selection="{ index, text }">
                                    <v-chip
                                        v-if="index < 5"
                                        color="deep-purple accent-4"
                                        dark
                                        label
                                        small
                                    >
                                      {{ text }}
                                    </v-chip>

                                    <span
                                        v-else-if="index === 5"
                                        class="overline grey--text text--darken-3 mx-2"
                                    >
                                +{{ files.length - 2 }} File(s)
                              </span>
                                  </template>
                                </v-file-input>
                              </v-col>
                              <v-col
                                  cols="8"
                                  md="2"
                                  class="d-flex justify-center">
                                <v-btn
                                    v-if="project.Owner"
                                    outlined
                                    color="primary"
                                    @click="ChooseEmpolyee_s_owner">
                                  เพิ่ม
                                </v-btn>
                                <v-btn
                                    v-else
                                    outlined
                                    color="primary"
                                    @click="ChooseEmpolyee_s">
                                  เพิ่ม
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item v-if="TypeInsert == '2'" style="margin-top: 25px">
                            <v-row class="d-flex justify-center">
                              <v-col
                                  cols="12"
                                  md="6">
                                <v-autocomplete
                                    v-model="departSel"
                                    label="เลือกหน่วยงาน"
                                    :items="departGroupDump"
                                    item-text="dep_name"
                                    item-value="dep_id"
                                    flat
                                    solo-inverted
                                    hide-details
                                    clearable
                                    clear-icon="mdi-close-circle-outline"
                                    @change="ChooseEmpolyee"
                                ></v-autocomplete>
                              </v-col>
                            </v-row>

                          </v-list-item>
                          <v-row v-if="TypeInsert == '2'">
                            <v-col
                                cols="12"
                                md="6">
                              <v-card-text>
                                <v-treeview
                                    :items="items"
                                    selected-color="indigo"
                                    expand-icon="mdi-chevron-down"
                                    off-icon="mdi-checkbox-blank-circle-outline"
                                    on-icon="mdi-checkbox-marked-circle-outline"
                                    indeterminate-icon="mdi-minus-circle-outline"
                                >
                                  <template v-slot:label="{ item }">
                                    <div class="d-flex justify-space-between">
                                    <span
                                        style="font-size: 16px;font-weight: bold;color: black;width: fit-content;margin-top: 22px">{{
                                        item.name
                                      }}</span>
                                      <v-switch
                                          inset
                                          :input-value="item.switch"
                                          @change="ChooseEmp(item)"
                                      ></v-switch>
                                    </div>
                                  </template>
                                </v-treeview>
                              </v-card-text>
                            </v-col>

                            <!--                                        <v-divider vertical></v-divider>-->

                            <v-col
                                cols="12"
                                md="6"
                            >
                              <v-card-text>
                                <div
                                    v-if="EmpData.length === 0"
                                    key="title"
                                    class="title font-weight-light grey--text pa-4 text-center"
                                >
                                  <span style="font-weight: bold;font-size: 18px">กรุณาเลือกรายชื่อบุคลากรที่ต้องการจะเข้าร่วม</span>
                                </div>

                                <v-scroll-x-transition
                                    group
                                    hide-on-leave
                                >
                                  <v-chip
                                      v-for="(selection, i) in EmpData"
                                      :key="i"
                                      color="grey"
                                      dark
                                      small
                                      class="ma-1"
                                  >
                                    <v-icon left small>mdi-account-circle</v-icon>
                                    {{ selection.name }}
                                  </v-chip>
                                </v-scroll-x-transition>
                              </v-card-text>
                            </v-col>
                          </v-row>
                          <v-divider v-if="TypeInsert == '2'"></v-divider>
                          <v-card-actions v-if="TypeInsert == '2'">
                            <v-btn
                                text
                                @click="EmpData = []"
                            >
                              Reset
                            </v-btn>

                            <v-spacer></v-spacer>

                            <v-btn
                                v-if="project.Owner"
                                class="white--text"
                                color="green darken-1"
                                depressed
                                @click="SaveToTable_owner"
                            >
                              Save
                              <v-icon right>mdi-content-save</v-icon>
                            </v-btn>
                            <v-btn
                                v-else
                                class="white--text"
                                color="green darken-1"
                                depressed
                                @click="SaveToTable"
                            >
                              Save
                              <v-icon right>mdi-content-save</v-icon>
                            </v-btn>
                          </v-card-actions>
                          <div align="center" style="margin-top: 30px">
                            <v-alert
                                dense
                                outlined
                                type="success"
                                dismissible
                                v-if="ShowAlertSuc"
                            >
                              <div v-html="MessageSuc"></div>
                            </v-alert>
                          </div>
                          <div align="center" style="margin-top: 30px">
                            <v-alert
                                dense
                                outlined
                                type="error"
                                dismissible
                                v-if="ShowAlertErr"
                            >
                              <div v-html="MessageError"></div>
                            </v-alert>
                          </div>
                          <v-list-item class="d-flex justify-center">
                            <v-alert
                                v-if="alertP"
                                prominent
                                type="error"
                            >
                              <v-row align="center" v-for="item in txtAlertP" :key="item.id">
                                <v-col class="d-flex grow">- {{ item.Detail }}</v-col>
                              </v-row>
                            </v-alert>
                          </v-list-item>
                          <v-list-item v-if="FilePerson.length > 0">
                            <template>
                              <v-row>
                                <v-col cols="12">
                                  <v-card>
                                    <v-card-title>
                                      ไฟล์ประกอบ
                                    </v-card-title>
                                    <v-container fluid>
                                      <v-row>
                                        <v-col
                                            v-for="(file_i, index) in FilePerson"
                                            :key="index"
                                            class="d-flex child-flex"
                                            cols="12"
                                            md="4"
                                        >
                                          <v-card flat tile class="d-flex">
                                            <v-img
                                                v-if="file_i.type == 'image'"
                                                :src="file_i.src"
                                                :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                                                aspect-ratio="1"
                                                class="grey lighten-2"
                                                max-width="100px"
                                                max-height="100px"
                                            >
                                              <template v-slot:placeholder>
                                                <v-row
                                                    class="fill-height ma-0"
                                                    align="center"
                                                    justify="center"
                                                >
                                                  <v-progress-circular
                                                      indeterminate
                                                      color="grey lighten-5"></v-progress-circular>
                                                </v-row>
                                              </template>
                                            </v-img>
                                            <v-img
                                                v-else-if="file_i.type == 'pdf'"
                                                src="../../assets/Image/pdf.png"
                                                :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                                                aspect-ratio="1"
                                                class="grey lighten-2"
                                                max-width="100px"
                                                max-height="100px"
                                            >
                                              <template v-slot:placeholder>
                                                <v-row
                                                    class="fill-height ma-0"
                                                    align="center"
                                                    justify="center"
                                                >
                                                  <v-progress-circular
                                                      indeterminate
                                                      color="grey lighten-5"></v-progress-circular>
                                                </v-row>
                                              </template>
                                            </v-img>
                                            <v-img
                                                v-else-if="file_i.type == 'rar' || file_i.type ==  'zip'"
                                                src="../../assets/Image/winzip.png"
                                                :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                                                aspect-ratio="1"
                                                class="grey lighten-2"
                                                max-width="100px"
                                                max-height="100px"
                                            >
                                              <template v-slot:placeholder>
                                                <v-row
                                                    class="fill-height ma-0"
                                                    align="center"
                                                    justify="center"
                                                >
                                                  <v-progress-circular
                                                      indeterminate
                                                      color="grey lighten-5"></v-progress-circular>
                                                </v-row>
                                              </template>
                                            </v-img>
                                            <v-img
                                                v-else-if="file_i.type == 'word'"
                                                src="../../assets/Image/word.jpg"
                                                :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                                                aspect-ratio="1"
                                                class="grey lighten-2"
                                            >
                                              <template v-slot:placeholder>
                                                <v-row
                                                    class="fill-height ma-0"
                                                    align="center"
                                                    justify="center"
                                                >
                                                  <v-progress-circular
                                                      indeterminate
                                                      color="grey lighten-5"></v-progress-circular>
                                                </v-row>
                                              </template>
                                            </v-img>
                                            <v-img
                                                v-else-if="file_i.type == 'ppt'"
                                                src="../../assets/Image/ppt.jpg"
                                                :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                                                aspect-ratio="1"
                                                class="grey lighten-2"
                                            >
                                              <template v-slot:placeholder>
                                                <v-row
                                                    class="fill-height ma-0"
                                                    align="center"
                                                    justify="center"
                                                >
                                                  <v-progress-circular
                                                      indeterminate
                                                      color="grey lighten-5"></v-progress-circular>
                                                </v-row>
                                              </template>
                                            </v-img>
                                            <v-card-actions>
                                              <template v-if="file_i.type == 'image' ||  file_i.type == 'pdf'">
                                                <v-btn text
                                                       @click="ShowData(file_i.src)">
                                                                                        <span style="color: indigo">
                                                                                            เรียกดู
                                                                                        </span>

                                                </v-btn>
                                              </template>
                                            </v-card-actions>
                                          </v-card>
                                        </v-col>
                                      </v-row>
                                    </v-container>
                                  </v-card>
                                </v-col>
                              </v-row>
                            </template>
                          </v-list-item>
                        </v-tab-item>
                      </v-tabs-items>
                    </v-card-text>
                  </v-card>

                  <v-card class="mt-7">
                    <v-toolbar
                        :color="appColor"
                        dark
                        flat
                    >
                      <v-toolbar-title>รายชื่อผู้เข้าร่วม
                        <span style="font-weight: bold;color: red">{{ JoinPerson.length }}</span> คน
                        <span v-if="project.Status_Count_Reg == '0'"> / {{ project.Count_Reg }} คน</span>
                        <span v-else> / ไม่จำกัด คน | </span>
                        ผู้สมัครเข้าร่วมใหม่ <span style="font-weight: bold;color: red">{{
                            RequestPerson.filter(item => item.status_req == '0').length
                          }}</span>
                        คน
                      </v-toolbar-title>
                    </v-toolbar>
                    <v-card-title>
                      <v-spacer></v-spacer>
                      <v-text-field
                          v-model="searchPerson"
                          append-icon="mdi-magnify"
                          label="Search"
                          single-line
                          hide-details
                          v-if="tab2 == '0'"
                      ></v-text-field>
                      <v-text-field
                          v-model="searchPersonApprove"
                          append-icon="mdi-magnify"
                          label="Search"
                          single-line
                          hide-details
                          v-else-if="tab2 == '1'"
                      ></v-text-field>
                      <v-text-field
                          v-model="searchPersonJoin"
                          append-icon="mdi-magnify"
                          label="Search"
                          single-line
                          hide-details
                          v-else
                      ></v-text-field>
                    </v-card-title>
                    <v-list>
                      <v-list-item>
                        <v-tabs
                            v-model="tab2"
                        >
                          <v-tab
                              key="requestProject"
                          >
                            รายชื่อผู้สมัคร (รอยืนยัน)
                          </v-tab>
                          <v-tab
                              key="ApproveRequest"
                              v-if="project.Owner"
                          >
                            คัดเลือกผู้สมัคร
                          </v-tab>
                          <v-tab
                              key="JoinProject"
                          >
                            รายชื่อผู้เข้าร่วม
                          </v-tab>
                        </v-tabs>
                      </v-list-item>
                      <v-tabs-items v-model="tab2">
                        <v-tab-item
                            key="requestProject"
                        >
                          <v-data-table
                              :headers="headersPerson2"
                              :items="RequestPerson"
                              :search="searchPerson"
                          >
                            <template v-slot:header.status_req>
                              สถานะ
                              <!--                            <v-btn text color="green" @click="RequestPerson.filter(item => item.RequestPerson = '1')">อนุมัติทั้งหมด</v-btn>-->
                              <!--                            <v-btn text color="red" @click="RequestPerson.filter(item => item.RequestPerson = '0')">ไม่อนุมัติทั้งหมด</v-btn>-->
                            </template>
                            <template v-slot:item.file="{item}">
                              <div align="center">
                                <v-btn text @click="ShowFile(item)" v-if="item.files.length > 0" color="primary">
                                  {{ item.files.length }} ไฟล์
                                </v-btn>
                              </div>
                            </template>
                            <template v-slot:item.action="{item}">
                              <v-btn
                                  v-if="item.status_active == '0' && item.Del"
                                  color="#F44336"
                                  outlined
                                  @click="Del_item(item)">
                                ลบ
                              </v-btn>
                            </template>
                            <template v-slot:item.status_req="{item}">
                              <v-chip color="primary" v-if="item.status_req == '0'">
                                รอพิจารณา
                              </v-chip>
                              <v-chip color="green" dark v-else-if="item.status_req == '1'">
                                อนุมัติ
                              </v-chip>
                              <v-chip color="red" dark v-else>
                                ไม่อนุมัติ
                              </v-chip>
                            </template>
                          </v-data-table>
                        </v-tab-item>
                        <v-tab-item
                            key="ApproveRequest"
                            v-if="project.Owner"
                        >
                          <template v-if="RequestPerson.length > 0">
                            <v-list-item>
                              <v-spacer></v-spacer>
                              <v-btn text color="green" class="darken-4 font-weight-bold" @click="approveType('1')">
                                อนุมัติ (ทั้งหมด)
                              </v-btn>
                            </v-list-item>
                            <v-list-item>
                              <v-spacer></v-spacer>
                              <v-btn text color="red" class="darken-4 font-weight-bold" @click="approveType('2')">
                                ยกเลิก (ทั้งหมด)
                              </v-btn>
                            </v-list-item>
                          </template>
                          <v-data-table
                              :headers="headersPerson2"
                              :items="RequestPerson"
                              :search="searchPersonApprove"
                          >
                            <template v-slot:item.file="{item}">
                              <div align="center">
                                <v-btn text @click="ShowFile(item)" v-if="item.files.length > 0" color="primary">
                                  {{ item.files.length }} ไฟล์
                                </v-btn>
                              </div>
                            </template>
                            <template v-slot:item.remark="{item}">
                              <v-text-field v-model="item.remark" label="เหตุผล"></v-text-field>
                            </template>
                            <template v-slot:item.status_req="{item}">
                              <v-radio-group row v-model="item.status_req">
                                <v-radio
                                    color="green"
                                    label="อนุมัติ"
                                    value="1"
                                ></v-radio>
                                <v-radio
                                    color="red"
                                    label="ไม่อนุมัติ"
                                    value="2"
                                ></v-radio>
                              </v-radio-group>
                            </template>
                          </v-data-table>
                          <div align="center">
                            <v-btn color="primary" @click="ChangeStatusReq" class="text-h4 darken-4 pa-6">บันทึก</v-btn>
                          </div>
                        </v-tab-item>
                        <v-tab-item
                            key="JoinProject"
                        >
                          <v-data-table
                              :headers="headersPerson"
                              :items="JoinPerson"
                              :search="searchPersonJoin"
                          >
                            <template v-slot:item.file="{item}">
                              <div align="center">
                                <v-btn text @click="ShowFile(item)" v-if="item.files.length > 0" color="primary">
                                  {{ item.files.length }} ไฟล์
                                </v-btn>
                              </div>
                            </template>
                            <template v-slot:item.type="{item}">
                                                            <span v-if="item.registerType_id == '0'"
                                                                  style="color: #ff6d81">
                                                                บุคลากรคณะแพทย์
                                                            </span>
                              <span v-if="item.registerType_id == '1'" style="color: #ff6d81">
                                                                นักศึกษาคณะแพทย์
                                                            </span>
                              <span v-if="item.registerType_id == '2'" style="color: blue">
                                                                บุคลากรคณะอื่น
                                                            </span>
                              <span v-if="item.registerType_id == '3'" style="color: blue">
                                                                นักศึกษาคณะอื่น
                                                            </span>
                              <span v-if="item.registerType_id == '4'" style="color: darkslateblue">
                                                                บุคคลภายนอก
                                                            </span>
                              <span v-if="item.registerType_id == '5'" style="color: darkslateblue">
                                                                นักศึกษาภายนอก
                                                            </span>
                            </template>
                          </v-data-table>
                        </v-tab-item>
                      </v-tabs-items>
                    </v-list>
                  </v-card>

                </template>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-container>
      <v-dialog
          v-model="dialogLoading"
          persistent
          width="300"
      >
        <v-card
            :color="appColor"
            dark
        >
          <v-card-text>
            Loading.....
            <v-progress-linear
                indeterminate
                color="white"
                class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="dialogFile"
          width="800"
      >
        <v-card v-if="personObj != null">
          <v-card-title
              color="primary"
              style="background-color: burlywood"

          >
          <span style="color: blue;font-weight: bold">ไฟล์ประกอบ คุณ : {{ personObj.full_Name }} ({{
              personObj.perid
            }})</span>
          </v-card-title>
          <v-card-text class="mt-4">
            <div align="center" v-for="(item,idx) in personObj.files" :key="idx">
              <span style="font-weight: bold;color: black">ไฟล์ที่ : {{ idx + 1 }} - {{ item.File_name }}</span>
              <template v-if="project.Owner">
                <v-btn text class="ml-3" color="primary" @click="downloadFiles(item)">ดาวน์โหลด</v-btn>
                <v-btn text color="primary" @click="ShowData(Openfile + item.File_path)" v-if="checkShowData(item)">
                  เรียกดู
                </v-btn>
              </template>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="red darken-1"
                text
                @click="dialogFile = false"
            >
              ปิด
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </v-content>
</template>

<script>
import axios from "axios";
import ConstData from "../../const/Const";
import {mapActions, mapGetters} from "vuex";
import Vue from 'vue'
import ALlFunc from "@/FuncGlobal/ALlFunc";
const queryString = require('query-string');

export default {
  name: "RequestJoinProject",
  data() {
    return {
      pageMessage: 'ปิดปรับปรุงระบบชั่วคราว',
      maintain: false,
      Openfile: ConstData.ConnectionHost + '/rest/files',
      dialogFile: false,
      personObj: null,
      alertP: false,
      txtAlertP: [],
      filesP: [],
      FilePerson: [],
      GroupExamData: [],
      departGroupDump: [],
      TypeStatus: '1',
      TypeRequest: '2',
      OwnerProject: false,
      ProjectQuotaDepCount: 0,
      staffDataDump: [],
      QoutaDepData: [],
      DepQuotaData: [],
      QoutaDepDataDump: [],
      dialogLoading: false,
      ShowAlertSuc: false,
      MessageSuc: '',
      ShowAlertErr: false,
      MessageError: '',
      phoneOther: '',
      CheckAdmin: false,
      CheckSubAdmin: false,
      projectDataToTable: [],
      projectDataToTableDump: [],
      projectDataToTableDump2: [],
      studentData: [],
      studentUniData: [],
      IdDepartStd: '',
      IdDepart: '',
      Idstudent: '',
      IdstudentUni: '',
      IdPersonal: '',
      personalMedData: [],
      AllDepartData: [],
      project: null,
      cardSel: '',
      staffSel: '',
      NameP: '',
      items: [],
      SurNameP: '',
      affiliation: '',
      position: '',
      idCard: '',
      NameStd: '',
      SurNameStd: '',
      affiliationStd: '',
      idCardStd: '',
      departSel: null,
      EmpData: [],
      TypeInsert: '0',
      open: [1, 2],
      isLoading: false,
      tree: [],
      types: [],
      Details: true,
      FileProject: [],
      alert: false,
      txtAlert: [],
      tab: null,
      tab2: null,
      Competency_code: '',
      UPercent: '',
      competencyHeader: [
        {text: 'Competency', value: 'Competency_des'},
        {text: 'เปอเซ็นต์', value: 'UPercent'}
      ],
      competency_DataForSubmit: [],
      expenseCostSum: 0,
      DepCost: '',
      expenseCost: '',
      moneyCost: '',
      expense_DataForSubmit: [],
      expense_p_DataForSubmit: [],
      CheckStep1: true,
      e1: 1,
      steps: 5,
      vertical: false,
      altLabels: false,
      editable: true,
      Details_Cordi: false,
      CheckFiles: false,
      full_name: '',
      phone: '',
      perid: '',
      peridCommittee: '',
      Committee_code: '',
      radioGroup: '0',
      radioGroup2: '0',
      files: [],
      Project_Choose: '',
      ProjectData: [],
      ChooseCourse: '',
      posiCondi: '',
      levelCondi: '',
      WSYear_Condi: '',
      WEYear_Condi: '',
      Course_Choose: '',
      DataCondi: [],
      courseCondi: [],
      Project_code: '',
      Project_name: '',
      Course_code: '',
      course_group: '',
      Project_type: '',
      WorkBy: '',
      Location: '',
      DateStart: '',
      DateEnd: '',
      CalHourse: '',
      CalCredit: '',
      PLACE: '',
      Province_id: '',
      Status: '',
      Remarks: '',
      ProjectLevel: '',
      App_doc_no: '',
      BudgetRequest: '',
      BudgetArrove: '',
      Project_group: '',
      D_Project: {
        Project_code: '',
        Project_name: '',
        Course_code: '',
        course_group: '',
        Project_type: '',
        WorkBy: '',
        Location: '',
        DateStart: '',
        DateEnd: '',
        CalHourse: '',
        CalCredit: '',
        PLACE: '',
        Province_id: '',
        Status: '',
        Remarks: '',
        ProjectLevel: '',
        App_doc_no: '',
        BudgetRequest: '',
        BudgetArrove: '',
        Project_group: '',
      },
      expanded: [],
      singleExpand: false,
      search: '',
      searchPerson: '',
      searchPerson2: '',
      searchPersonJoin: '',
      searchPersonApprove: '',
      headersPerson: [
        {text: 'ชื่อ - สกุล', value: 'full_Name'},
        {text: 'สังกัด', value: 'affiliation'},
        {text: 'ไฟล์', value: 'file'},
        {text: 'สถานะ', value: 'type'},
      ],
      headersPerson2: [
        {text: 'ชื่อ - สกุล', value: 'full_Name'},
        {text: 'สังกัด', value: 'dep_name'},
        {text: 'ไฟล์', value: 'file'},
        {text: 'สถานะ', value: 'status_req'},
        {text: 'เหตุผล', value: 'remark'},
        {text: '', value: 'action'}
      ],
      JoinPerson: [],
      RequestPerson: [],
      CoordinatorHeader: [
        {text: 'ชื่อ - สกุล', value: 'Name'},
        {text: 'ตำแหน่ง', value: 'position_com'},
        {text: 'เบอรโ์โทร', value: 'TEL'},
        {text: 'สถานะ', value: 'Committee_type'}
      ],
      Coordinator: [],
      courseHeadersCondi: [
        {text: 'หลักสูตร', value: 'Course_name'}
      ],
      courseDataCondi: [],
      dataHeadersCondi: [
        {text: 'ตำแหน่ง', value: 'PosName'},
        {text: 'ระดับ', value: 'Level'},
        {text: 'อายุงานเริ่มต้น', value: 'WSYear'},
        {text: 'อายุงานสิ้นสุด', value: 'WEYear'}
      ],
      dataDataCondi: [],
      projectNeed: false,
      picker: new Date().toISOString().substr(0, 10),
      landscape: false,
      reactive: false,
      fullWidth: false,
      showCurrent: true,
      month: false,
      multiple: false,
      readonly: false,
      disabled: false,
      enableEvents: false,
      PLACESelete: [
        {
          id: '0', detail: 'ภายในคณะ'
        },
        {
          id: '1', detail: 'ภายในมหาวิทยาลัย'
        },
        {
          id: '2', detail: 'ภายในจังหวัด'
        },
        {
          id: '3', detail: 'ภายในประเทศ'
        },
        {
          id: '4', detail: 'ต่างประเทศ'
        },
      ],
      WorkByData: [
        {
          id: 'D', detail: 'หน่วยงาน'
        },
        {
          id: 'F', detail: 'คณะ'
        },
        {
          id: 'U', detail: 'มหาวิทยาลัย'
        },
        {
          id: 'P', detail: 'ภายนอก'
        },
        {
          id: 'C', detail: 'ร่วมโครงการ'
        },
      ],
      Menu: [
        {
          'id': 1,
          'value': 'จัดโครงการ'
        },
        {
          'id': 2,
          'value': 'จัดการข้อมูลโครงการ'
        },
        {
          'id': 3,
          'value': 'ข้อมูลเบิกจ่ายเงินโครงการ'
        }],
      projectType: [
        {
          id: '0',
          details: 'อบรม'
        },
        {
          id: '1',
          details: 'ดูงาน'
        },
        {
          id: '2',
          details: 'ประชุม'
        },
        {
          id: '3',
          details: 'นำเสนองาน'
        }
      ],
      workBy: [
        'Depart',
        'Faculty',
        'University',
        'Public C',
        'Co-Project'
      ],
      CourseType: [
        'ทั่วไป',
        'เฉพาะตำแหน่ง'
      ],
      DataCourse: {
        Project_code: '',
        Course_code: '',
        Credit: ''
      },
      rules: {
        required: value => !!value || 'Required.',
        counterCourse: value => value.length <= 8 || 'Max 8 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        },
      },
      courseHeaders: [
        {text: 'รหัสแผน', value: 'Project_code'},
        {text: 'หลักสูตร', value: 'full_Name'},
        {text: '', value: 'Project_Details'}
      ],
    }
  },
  computed: {
    bg() {
      return this.background ? 'https://cdn.vuetifyjs.com/images/backgrounds/bg-2.jpg' : undefined
    },
    ...mapGetters({
      MeData: 'Staff/getMeData',
      levelData: 'Level/getLevel',
      projectData: 'Project/getProject',
      projectForApprove: 'Project/getProjectForApprove',
      committee_Posi: 'Project/getComitteeType',
      provinces_Data: 'Project/getProvince',
      expense_Data: 'Project/getExpense',
      Competency_Data: 'Project/getCompetency',
      projectGroup: 'Project/getProjectGroup',
      QuotaDepart: 'Project/getQuotaDepart',
      GroupExamProject: 'Project/getGroupExamProject',
      RequestProject: 'Project/getRequestProject',
      JoinProject: 'Project/getJoinProject',
      ProjectRound: 'Project/getProjectRound',
      PersonFiles: 'Project/getPersonFiles',
      staffData: 'Staff/getStaff',
      positions: 'Staff/getPosition',
      CardData: 'Staff/getCard',
      depart: 'Depart/getDepart',
      courseData: 'Course/getCourse',
      AllDepPermission: 'Permission/getAllDepUserPermission',
      DepPermission: 'Permission/getDepUserPermission',
      AllPermission: 'Permission/getAllUserPermission',
      Permission: 'Permission/getPermissionUser',
      Permission_Ms: 'Permission/getPermissionMs',
      Permission_Dep_User: 'Permission/getPermissionDepUser',
      Permission_Dep: 'Permission/getPermissionDep',
      Approve_Ms: 'Permission/getApproveMs',
      Approve: 'Permission/getApprove',
      IgnoreMenuPermiss: 'Permission/getIgnoreMenuPermiss',
      SubMenuPermiss: 'Permission/getSubMenuPermiss',
      IgnoreSubMenuPermiss: 'Permission/getIgnoreSubMenuPermiss',
      PermissionAdmin: 'Permission/getPermission',
      TypeProject: 'Project/getTypeProject',
      HeaderPage: 'Project/getHeaderPage',
      JoinProjectPage: 'Project/getManageProjectPage',
      appColor: 'Page/getColor',
      appHeaderName: 'Page/getHeaderName',
    })
  },
  methods: {
    ...mapActions({
      initMeData: 'Staff/initMeData',
      initlevelData: 'Level/initLevelData',
      initDepartData: 'Depart/initDepartData',
      initCourseData: 'Course/initCourseData',
      initProjectData: 'Project/initProjectData',
      initProjectDataForApprove: 'Project/initProjectDataForApprove',
      initComitteeData: 'Project/initComitteeData',
      initComitteeType: 'Project/initComitteeType',
      initProvincesData: 'Project/initProvincesData',
      initExpenseData: 'Project/initExpenseData',
      initCompetencyData: 'Competency/initCompetencyData',
      initProjectCompetencyData: 'Project/initCompetencyData',
      initProjectGroupData: 'Project/initProjectGroupData',
      initQuotaDepartRegister: 'Project/initQuotaDepartRegister',
      initRequestProject: 'Project/initRequestProject',
      initJoinProject: 'Project/initJoinProject',
      initGroupExamProject: 'Project/initGroupExamProject',
      getProjectRoundData: 'Project/getProjectRoundData',
      initProjectRoundData: 'Project/initProjectRoundData',
      initPersonFileData: 'Project/initPersonFileData',
      initStaffData: 'Staff/initStaffData',
      initPositionsData: 'Staff/initPositionsData',
      initCardData: 'Staff/initCardData',
      initPermissionDepUserAllData: 'Permission/initPermissionDepUserAllData',
      initPermissionDepUserData: 'Permission/initPermissionDepUserData',
      initPermissionUserData: 'Permission/initPermissionUserData',
      initPermissionMsData: 'Permission/initPermissionMsData',
      getPermissionUserData: 'Permission/getPermissionUserData',
      getPermissionDep: 'Permission/getPermissionDepData',
      initPermissionDepData: 'Permission/initPermissionDepData',
      getPermissionDepUserData: 'Permission/getPermissionDepUserData',
      getSubMenuPermissData: 'Permission/getSubMenuPermissData',
      getIgnoreSubMenuPermissData: 'Permission/getIgnoreSubMenuPermissData',
      initApproveMsData: 'Permission/initApproveMsData',
      initApproveData: 'Permission/initApproveData',
      getPermissionData: 'Permission/getPermissionData',
      initPermissionData: 'Permission/initPermissionData',
      changeHeaderPage: 'Project/changeHeaderPage',
      changeJoinProjectPage: 'Project/changeManageProjectPage',
    }),
    init: function () {
      this.initProjectRoundData().then(res => {
        if (res) {
          this.initProject()
        }
      }).catch(reason => {
        if (reason) {
          this.initProject()
        }
      })
    },
    async initProject() {
      this.projectDataToTable = []
      this.projectDataToTableDump = []
      this.staffDataDump = []
      var txtDateS = ''
      var txtDateE = ''
      var txtCount = ''
      var txtType = ''
      var departDump = []
      // if (this.projectData.length == 0) {
      //   this.initProjectDataForApprove({
      //     query: 'Approve/1/Approve_Treasury/1'
      //   }).then(res => {
      //     if (res) {
      //       if (this.projectForApprove.length > 0) {
      //         this.projectDataToTable = this.projectForApprove.filter(item => item.Status != '2')
      //       }
      //     }
      //   })
      // }

      if (this.staffData.length > 0) {
        this.staffData.map(item => {
          item.customDetail = item.full_Name + ' รหัส (' + item.perid + ')' + ' ' + item.dep_name
        })
      }

      if (this.projectForApprove.length > 0) {
        if (this.CheckAdmin) {
          this.getPermissionDep({
            perid: this.MeData[0].perid
          }).then(resDep => {
            if (resDep) {
              this.projectForApprove.map(Project => {
                Project.Project_name = Project.Project_name.replace(/&quot;/g, '"')
                if (Project.IsRoundStatus == '0') {
                  var DepData = this.Permission_Dep.filter(Dep => Project.Dep_Code == Dep.dep_id || Project.dep_id == Dep.dep_id)
                  txtDateS = ''
                  txtDateE = ''
                  txtCount = ''
                  txtType = Project.Approve == '1' ? '<span style="font-weight: bold;color: #FF80AB">(ผ่านการเสนอแผนขอตั้งงบประมาณประจำปี)</span>' : '<span style="font-weight: bold;color: #EA80FC">(ไม่ผ่านการเสนอแผนขอตั้งงบประมาณประจำปี)</span>'
                  if (DepData.length > 0) {
                    if (Project.DateS_Reg != null && Project.DateS_Reg != '0000-00-00') {
                      txtDateS = '<span style="font-weight: bold;color: #ff6d81">วันที่เปิดรับสมัคร ' + Vue.filter('DateToThai')(Project.DateS_Reg) + '</span>'
                    } else {
                      txtDateS = '<span style="font-weight: bold;color: #ff6d81">วันที่เปิดรับสมัคร - </span>'
                    }
                    if (Project.DateE_Reg != null && Project.DateE_Reg != '0000-00-00') {
                      txtDateE = '<span style="font-weight: bold;color: #ff6d81">วันที่ปิดรับสมัคร ' + Vue.filter('DateToThai')(Project.DateE_Reg) + '</span>'
                    } else {
                      txtDateE = '<span style="font-weight: bold;color: #ff6d81">วันที่ปิดรับสมัคร - </span>'
                    }
                    if (Project.Status_Count_Reg == '1') {
                      txtCount = '<span style="font-weight: bold;color: #42b983">จำนวนที่เปิดรับ ไม่จำกัด </span>'
                    } else {
                      if (Project.Count_Reg != null && Project.Count_Reg != '') {
                        txtCount = '<span style="font-weight: bold;color: #42b983">จำนวนที่เปิดรับ ' + Project.Count_Reg + '</span>'
                      } else {
                        txtCount = '<span style="font-weight: bold;color: #42b983">จำนวนที่เปิดรับ - </span>'
                      }
                    }

                    this.projectDataToTable.push({
                      ...Project,
                      idx: this.projectDataToTable.length,
                      Ref_id: this.projectDataToTable.length,
                      full_Name: '<span style="font-weight: bold;color: darkblue">' + Project.Project_name + '</span>' + ' <div>' + txtDateS + ' ' + txtDateE + '</div>' +
                          ' <div>' + txtCount + '</div>' +
                          ' <div>' + txtType + '</div>',
                      full_Name2: Project.Project_name,
                      Owner: true
                    })
                  }
                } else {
                  //
                  var RoundDump = this.ProjectRound.filter(roundI => roundI.Project_code == Project.Project_code)
                  if (RoundDump.length > 0) {
                    RoundDump.map(RoundI => {
                      DepData = this.Permission_Dep.filter(Dep => RoundI.Dep_Code == Dep.dep_id || RoundI.dep_id == Dep.dep_id)
                      txtDateS = ''
                      txtDateE = ''
                      txtCount = ''
                      txtType = Project.Approve == '1' ? '<span style="font-weight: bold;color: #FF80AB">(ผ่านการเสนอแผนขอตั้งงบประมาณประจำปี)</span>' : '<span style="font-weight: bold;color: #EA80FC">(ไม่ผ่านการเสนอแผนขอตั้งงบประมาณประจำปี)</span>'

                      if (DepData.length > 0) {
                        if (RoundI.DateS_Reg != null && RoundI.DateS_Reg != '0000-00-00') {
                          txtDateS = '<span style="font-weight: bold;color: #ff6d81">วันที่เปิดรับสมัคร ' + Vue.filter('DateToThai')(RoundI.DateS_Reg) + '</span>'
                        } else {
                          txtDateS = '<span style="font-weight: bold;color: #ff6d81">วันที่เปิดรับสมัคร - </span>'
                        }
                        if (RoundI.DateE_Reg != null && RoundI.DateE_Reg != '0000-00-00') {
                          txtDateE = '<span style="font-weight: bold;color: #ff6d81">วันที่ปิดรับสมัคร ' + Vue.filter('DateToThai')(RoundI.DateE_Reg) + '</span>'
                        } else {
                          txtDateE = '<span style="font-weight: bold;color: #ff6d81">วันที่ปิดรับสมัคร - </span>'
                        }
                        if (RoundI.Status_Count_Reg == '1') {
                          txtCount = '<span style="font-weight: bold;color: #42b983">จำนวนที่เปิดรับ ไม่จำกัด </span>'
                        } else {
                          if (RoundI.Count_Reg != null && RoundI.Count_Reg != '') {
                            txtCount = '<span style="font-weight: bold;color: #42b983">จำนวนที่เปิดรับ ' + RoundI.Count_Reg + '</span>'
                          } else {
                            txtCount = '<span style="font-weight: bold;color: #42b983">จำนวนที่เปิดรับ - </span>'
                          }
                        }

                        this.projectDataToTable.push({
                          ...RoundI,
                          idx: this.projectDataToTable.length,
                          Ref_id: RoundI.id,
                          full_Name: '<span style="font-weight: bold;color: darkblue">' + RoundI.Project_name + '</span>'
                              + '<span style="font-weight: bold;color: magenta;margin-left: 10px">( รุ่น ' + RoundI.Round + ' ' + RoundI.Round_name + ')</span>'
                              + ' <div>' + txtDateS + ' ' + txtDateE + '</div>' +
                              ' <div>' + txtCount + '</div>' +
                              ' <div>' + txtType + '</div>',
                          full_Name2: RoundI.Project_name + ' -> ( รุ่น ' + RoundI.Round + ' ' + RoundI.Round_name + ' )',
                          Owner: true
                        })
                      }
                    })
                  }
                }
              })

              this.Permission_Dep.map(Dep => {
                if (departDump.length > 0) {
                  if (departDump.filter(item => item.dep_id == Dep.dep_id).length == 0) {
                    departDump = departDump.concat(this.depart.filter(item => item.dep_id == Dep.dep_id))
                  }
                } else {
                  departDump = departDump.concat(this.depart.filter(item => item.dep_id == Dep.dep_id))
                }
              })

              // !***  เงื่อนไข filter บุคลากรให้เลือกเข้าร่วมโครงการ  ***!
              this.Permission_Dep.map(Dep => {
                this.staffDataDump = this.staffDataDump.concat(this.staffData.filter(staff_i => staff_i.dep_id == Dep.dep_id))
              })
              // /!***  -------------------------------- ***!/

              this.initQuotaDepartRegister().then(resQuotaDepReg => {
                if (resQuotaDepReg) {
                  if (departDump.length > 0) {
                    departDump.map((Dep, idxDep) => {
                      var QoutaDepDataDump = this.QuotaDepart.filter(item => item.dep_group_id == Dep.dep_group_id)
                      if (QoutaDepDataDump.length > 0) {
                        if (this.QoutaDepData.length > 0) {
                          if (this.QoutaDepData.filter(item => item.dep_group_id == Dep.dep_group_id).length == 0) {
                            this.QoutaDepData = this.QoutaDepData.concat(this.QuotaDepart);
                          }
                        } else {
                          this.QoutaDepData = this.QoutaDepData.concat(this.QuotaDepart);
                        }
                      }

                      if (idxDep == departDump.length - 1) {
                        if (this.QoutaDepData.length > 0) {
                          this.QoutaDepData.map(DepQ_i => {
                            if (DepQ_i.dep_type == '0') {
                              if (this.Permission_Dep.filter(item => item.dep_id == DepQ_i.dep_id).length > 0) {
                                this.projectForApprove.map(Project => {
                                  if (Project.Project_code == DepQ_i.Project_code) {
                                    if (Project.IsRoundStatus == '0') {
                                      txtDateS = ''
                                      txtDateE = ''
                                      txtCount = ''
                                      txtType = Project.Approve == '1' ? '<span style="font-weight: bold;color: #FF80AB">(ผ่านการเสนอแผนขอตั้งงบประมาณประจำปี)</span>' : '<span style="font-weight: bold;color: #EA80FC">(ไม่ผ่านการเสนอแผนขอตั้งงบประมาณประจำปี)</span>'
                                      if (Project.DateS_Reg != null && Project.DateS_Reg != '0000-00-00') {
                                        txtDateS = '<span style="font-weight: bold;color: #ff6d81">วันที่เปิดรับสมัคร ' + Vue.filter('DateToThai')(Project.DateS_Reg) + '</span>'
                                      } else {
                                        txtDateS = '<span style="font-weight: bold;color: #ff6d81">วันที่เปิดรับสมัคร - </span>'
                                      }
                                      if (Project.DateE_Reg != null && Project.DateE_Reg != '0000-00-00') {
                                        txtDateE = '<span style="font-weight: bold;color: #ff6d81">วันที่ปิดรับสมัคร ' + Vue.filter('DateToThai')(Project.DateE_Reg) + '</span>'
                                      } else {
                                        txtDateE = '<span style="font-weight: bold;color: #ff6d81">วันที่ปิดรับสมัคร - </span>'
                                      }
                                      if (Project.Status_Count_Reg == '1') {
                                        txtCount = '<span style="font-weight: bold;color: #42b983">จำนวนที่เปิดรับ ไม่จำกัด </span>'
                                      } else {
                                        if (Project.Count_Reg != null && Project.Count_Reg != '') {
                                          txtCount = '<span style="font-weight: bold;color: #42b983">จำนวนที่เปิดรับ ' + Project.Count_Reg + '</span>'
                                        } else {
                                          txtCount = '<span style="font-weight: bold;color: #42b983">จำนวนที่เปิดรับ - </span>'
                                        }
                                      }
                                      if (this.projectDataToTable.length > 0) {
                                        if (this.projectDataToTable.filter(project_i => project_i.Project_code == Project.Project_code).length == 0) {
                                          this.projectDataToTable.push({
                                            ...Project,
                                            idx: this.projectDataToTable.length,
                                            Ref_id: this.projectDataToTable.length,
                                            full_Name: '<span style="font-weight: bold;color: darkblue">' + Project.Project_name + '</span>' + ' <div>' + txtDateS + ' ' + txtDateE + '</div>' +
                                                ' <div>' + txtCount + '</div>' +
                                                ' <div>' + txtType + '</div>',
                                            full_Name2: Project.Project_name,
                                            Owner: false
                                          })
                                        }
                                      }
                                    } else {
                                      var RoundDump = this.ProjectRound.filter(roundI => roundI.Project_code == Project.Project_code)
                                      if (RoundDump.length > 0) {
                                        RoundDump.map(RoundI => {
                                          txtDateS = ''
                                          txtDateE = ''
                                          txtCount = ''
                                          txtType = Project.Approve == '1' ? '<span style="font-weight: bold;color: #FF80AB">(ผ่านการเสนอแผนขอตั้งงบประมาณประจำปี)</span>' : '<span style="font-weight: bold;color: #EA80FC">(ไม่ผ่านการเสนอแผนขอตั้งงบประมาณประจำปี)</span>'
                                          if (RoundI.DateS_Reg != null && RoundI.DateS_Reg != '0000-00-00') {
                                            txtDateS = '<span style="font-weight: bold;color: #ff6d81">วันที่เปิดรับสมัคร ' + Vue.filter('DateToThai')(RoundI.DateS_Reg) + '</span>'
                                          } else {
                                            txtDateS = '<span style="font-weight: bold;color: #ff6d81">วันที่เปิดรับสมัคร - </span>'
                                          }
                                          if (RoundI.DateE_Reg != null && RoundI.DateE_Reg != '0000-00-00') {
                                            txtDateE = '<span style="font-weight: bold;color: #ff6d81">วันที่ปิดรับสมัคร ' + Vue.filter('DateToThai')(RoundI.DateE_Reg) + '</span>'
                                          } else {
                                            txtDateE = '<span style="font-weight: bold;color: #ff6d81">วันที่ปิดรับสมัคร - </span>'
                                          }
                                          if (RoundI.Status_Count_Reg == '1') {
                                            txtCount = '<span style="font-weight: bold;color: #42b983">จำนวนที่เปิดรับ ไม่จำกัด </span>'
                                          } else {
                                            if (RoundI.Count_Reg != null && RoundI.Count_Reg != '') {
                                              txtCount = '<span style="font-weight: bold;color: #42b983">จำนวนที่เปิดรับ ' + RoundI.Count_Reg + '</span>'
                                            } else {
                                              txtCount = '<span style="font-weight: bold;color: #42b983">จำนวนที่เปิดรับ - </span>'
                                            }
                                          }
                                          if (this.projectDataToTable.length > 0) {
                                            if (this.projectDataToTable.filter(project_i => project_i.Project_code == RoundI.Project_code && RoundI.id == project_i.Ref_id).length == 0) {
                                              this.projectDataToTable.push({
                                                ...RoundI,
                                                idx: this.projectDataToTable.length,
                                                Ref_id: RoundI.id,
                                                full_Name: '<span style="font-weight: bold;color: darkblue">' + RoundI.Project_name + '</span>'
                                                    + '<span style="font-weight: bold;color: magenta;margin-left: 10px">( รุ่น ' + RoundI.Round + ' ' + RoundI.Round_name + ')</span>'
                                                    + ' <div>' + txtDateS + ' ' + txtDateE + '</div>' +
                                                    ' <div>' + txtCount + '</div>' +
                                                    ' <div>' + txtType + '</div>',
                                                full_Name2: RoundI.Project_name + ' -> ( รุ่น ' + RoundI.Round + ' ' + RoundI.Round_name + ' )',
                                                Owner: false
                                              })
                                            }
                                          } else {
                                            this.projectDataToTable.push({
                                              ...RoundI,
                                              idx: this.projectDataToTable.length,
                                              Ref_id: RoundI.id,
                                              full_Name: '<span style="font-weight: bold;color: darkblue">' + RoundI.Project_name + '</span>'
                                                  + '<span style="font-weight: bold;color: magenta;margin-left: 10px">( รุ่น ' + RoundI.Round + ' ' + RoundI.Round_name + ')</span>'
                                                  + ' <div>' + txtDateS + ' ' + txtDateE + '</div>' +
                                                  ' <div>' + txtCount + '</div>' +
                                                  ' <div>' + txtType + '</div>',
                                              full_Name2: RoundI.Project_name + ' -> ( รุ่น ' + RoundI.Round + ' ' + RoundI.Round_name + ' )',
                                              Owner: false
                                            })
                                          }
                                        })
                                      }
                                    }
                                  }
                                })
                              }
                            } else {
                              var DepGroupArr = this.depart.filter(Dep_i => Dep_i.dep_group_id == DepQ_i.dep_group_id)
                              if (DepGroupArr.length > 0) {
                                DepGroupArr.map(itemDep_arr => {
                                  if (this.Permission_Dep.filter(item => item.dep_id == itemDep_arr.dep_id).length > 0) {
                                    this.projectForApprove.map(Project => {
                                      if (Project.Project_code == DepQ_i.Project_code) {
                                        if (this.projectDataToTable.filter(p_ToTable => p_ToTable.Project_code == DepQ_i.Project_code).length == 0) {
                                          if (Project.IsRoundStatus == '0') {
                                            txtDateS = ''
                                            txtDateE = ''
                                            txtCount = ''
                                            txtType = Project.Approve == '1' ? '<span style="font-weight: bold;color: #FF80AB">(ผ่านการเสนอแผนขอตั้งงบประมาณประจำปี)</span>' : '<span style="font-weight: bold;color: #EA80FC">(ไม่ผ่านการเสนอแผนขอตั้งงบประมาณประจำปี)</span>'
                                            if (Project.DateS_Reg != null && Project.DateS_Reg != '0000-00-00') {
                                              txtDateS = '<span style="font-weight: bold;color: #ff6d81">วันที่เปิดรับสมัคร ' + Vue.filter('DateToThai')(Project.DateS_Reg) + '</span>'
                                            } else {
                                              txtDateS = '<span style="font-weight: bold;color: #ff6d81">วันที่เปิดรับสมัคร - </span>'
                                            }
                                            if (Project.DateE_Reg != null && Project.DateE_Reg != '0000-00-00') {
                                              txtDateE = '<span style="font-weight: bold;color: #ff6d81">วันที่ปิดรับสมัคร ' + Vue.filter('DateToThai')(Project.DateE_Reg) + '</span>'
                                            } else {
                                              txtDateE = '<span style="font-weight: bold;color: #ff6d81">วันที่ปิดรับสมัคร - </span>'
                                            }
                                            if (Project.Status_Count_Reg == '1') {
                                              txtCount = '<span style="font-weight: bold;color: #42b983">จำนวนที่เปิดรับ ไม่จำกัด </span>'
                                            } else {
                                              if (Project.Count_Reg != null && Project.Count_Reg != '') {
                                                txtCount = '<span style="font-weight: bold;color: #42b983">จำนวนที่เปิดรับ ' + Project.Count_Reg + '</span>'
                                              } else {
                                                txtCount = '<span style="font-weight: bold;color: #42b983">จำนวนที่เปิดรับ - </span>'
                                              }
                                            }
                                            if (this.projectDataToTable.length > 0) {
                                              if (this.projectDataToTable.filter(project_i => project_i.Project_code == Project.Project_code).length == 0) {
                                                this.projectDataToTable.push({
                                                  ...Project,
                                                  idx: this.projectDataToTable.length,
                                                  Ref_id: this.projectDataToTable.length,
                                                  full_Name: '<span style="font-weight: bold;color: darkblue">' + Project.Project_name + '</span>' + ' <div>' + txtDateS + ' ' + txtDateE + '</div>' +
                                                      ' <div>' + txtCount + '</div>' +
                                                      ' <div>' + txtType + '</div>',
                                                  full_Name2: Project.Project_name,
                                                  Owner: false
                                                })
                                              }
                                            }
                                          } else {
                                            var RoundDump = this.ProjectRound.filter(roundI => roundI.Project_code == Project.Project_code)
                                            if (RoundDump.length > 0) {
                                              RoundDump.map(RoundI => {
                                                txtDateS = ''
                                                txtDateE = ''
                                                txtCount = ''
                                                txtType = Project.Approve == '1' ? '<span style="font-weight: bold;color: #FF80AB">(ผ่านการเสนอแผนขอตั้งงบประมาณประจำปี)</span>' : '<span style="font-weight: bold;color: #EA80FC">(ไม่ผ่านการเสนอแผนขอตั้งงบประมาณประจำปี)</span>'
                                                if (RoundI.DateS_Reg != null && RoundI.DateS_Reg != '0000-00-00') {
                                                  txtDateS = '<span style="font-weight: bold;color: #ff6d81">วันที่เปิดรับสมัคร ' + Vue.filter('DateToThai')(RoundI.DateS_Reg) + '</span>'
                                                } else {
                                                  txtDateS = '<span style="font-weight: bold;color: #ff6d81">วันที่เปิดรับสมัคร - </span>'
                                                }
                                                if (RoundI.DateE_Reg != null && RoundI.DateE_Reg != '0000-00-00') {
                                                  txtDateE = '<span style="font-weight: bold;color: #ff6d81">วันที่ปิดรับสมัคร ' + Vue.filter('DateToThai')(RoundI.DateE_Reg) + '</span>'
                                                } else {
                                                  txtDateE = '<span style="font-weight: bold;color: #ff6d81">วันที่ปิดรับสมัคร - </span>'
                                                }
                                                if (RoundI.Status_Count_Reg == '1') {
                                                  txtCount = '<span style="font-weight: bold;color: #42b983">จำนวนที่เปิดรับ ไม่จำกัด </span>'
                                                } else {
                                                  if (RoundI.Count_Reg != null && RoundI.Count_Reg != '') {
                                                    txtCount = '<span style="font-weight: bold;color: #42b983">จำนวนที่เปิดรับ ' + RoundI.Count_Reg + '</span>'
                                                  } else {
                                                    txtCount = '<span style="font-weight: bold;color: #42b983">จำนวนที่เปิดรับ - </span>'
                                                  }
                                                }
                                                if (this.projectDataToTable.length > 0) {
                                                  if (this.projectDataToTable.filter(project_i => project_i.Project_code == RoundI.Project_code && RoundI.id == project_i.Ref_id).length == 0) {
                                                    this.projectDataToTable.push({
                                                      ...RoundI,
                                                      idx: this.projectDataToTable.length,
                                                      Ref_id: RoundI.id,
                                                      full_Name: '<span style="font-weight: bold;color: darkblue">' + RoundI.Project_name + '</span>'
                                                          + '<span style="font-weight: bold;color: magenta;margin-left: 10px">( รุ่น ' + RoundI.Round + ' ' + RoundI.Round_name + ')</span>'
                                                          + ' <div>' + txtDateS + ' ' + txtDateE + '</div>' +
                                                          ' <div>' + txtCount + '</div>' +
                                                          ' <div>' + txtType + '</div>',
                                                      full_Name2: RoundI.Project_name + ' -> ( รุ่น ' + RoundI.Round + ' ' + RoundI.Round_name + ' )',
                                                      Owner: false
                                                    })
                                                  }
                                                } else {
                                                  this.projectDataToTable.push({
                                                    ...RoundI,
                                                    idx: this.projectDataToTable.length,
                                                    Ref_id: RoundI.id,
                                                    full_Name: '<span style="font-weight: bold;color: darkblue">' + RoundI.Project_name + '</span>'
                                                        + '<span style="font-weight: bold;color: magenta;margin-left: 10px">( รุ่น ' + RoundI.Round + ' ' + RoundI.Round_name + ')</span>'
                                                        + ' <div>' + txtDateS + ' ' + txtDateE + '</div>' +
                                                        ' <div>' + txtCount + '</div>' +
                                                        ' <div>' + txtType + '</div>',
                                                    full_Name2: RoundI.Project_name + ' -> ( รุ่น ' + RoundI.Round + ' ' + RoundI.Round_name + ' )',
                                                    Owner: false
                                                  })
                                                }
                                              })
                                            }
                                          }
                                        }
                                      }
                                    })
                                  }
                                })
                              }
                            }
                          })

                          // /!***  เงื่อนไข โครงการที่ผู้อื่นจัดให้เห็นข้อมูลโครงการนั้นด้วย ***!/
                          this.projectForApprove.map(Project => {
                            if (Project.Status_Reg == '0' && (Project.Status_Type_Reg == '0' || Project.Status_Type_Reg == '1')) {
                              if (this.projectDataToTable.filter(ProjectToTabel_i => ProjectToTabel_i.Project_code == Project.Project_code).length == 0) {
                                if (Project.IsRoundStatus == '0') {
                                  txtDateS = ''
                                  txtDateE = ''
                                  txtCount = ''
                                  txtType = Project.Approve == '1' ? '<span style="font-weight: bold;color: #FF80AB">(ผ่านการเสนอแผนขอตั้งงบประมาณประจำปี)</span>' : '<span style="font-weight: bold;color: #EA80FC">(ไม่ผ่านการเสนอแผนขอตั้งงบประมาณประจำปี)</span>'
                                  if (Project.DateS_Reg != null && Project.DateS_Reg != '0000-00-00') {
                                    txtDateS = '<span style="font-weight: bold;color: #ff6d81">วันที่เปิดรับสมัคร ' + Vue.filter('DateToThai')(Project.DateS_Reg) + '</span>'
                                  } else {
                                    txtDateS = '<span style="font-weight: bold;color: #ff6d81">วันที่เปิดรับสมัคร - </span>'
                                  }
                                  if (Project.DateE_Reg != null && Project.DateE_Reg != '0000-00-00') {
                                    txtDateE = '<span style="font-weight: bold;color: #ff6d81">วันที่ปิดรับสมัคร ' + Vue.filter('DateToThai')(Project.DateE_Reg) + '</span>'
                                  } else {
                                    txtDateE = '<span style="font-weight: bold;color: #ff6d81">วันที่ปิดรับสมัคร - </span>'
                                  }
                                  if (Project.Status_Count_Reg == '1') {
                                    txtCount = '<span style="font-weight: bold;color: #42b983">จำนวนที่เปิดรับ ไม่จำกัด </span>'
                                  } else {
                                    if (Project.Count_Reg != null && Project.Count_Reg != '') {
                                      txtCount = '<span style="font-weight: bold;color: #42b983">จำนวนที่เปิดรับ ' + Project.Count_Reg + '</span>'
                                    } else {
                                      txtCount = '<span style="font-weight: bold;color: #42b983">จำนวนที่เปิดรับ - </span>'
                                    }
                                  }
                                  if (this.projectDataToTable.length > 0) {
                                    if (this.projectDataToTable.filter(project_i => project_i.Project_code == Project.Project_code).length == 0) {
                                      this.projectDataToTable.push({
                                        ...Project,
                                        idx: this.projectDataToTable.length,
                                        Ref_id: this.projectDataToTable.length,
                                        full_Name: '<span style="font-weight: bold;color: darkblue">' + Project.Project_name + '</span>' + ' <div>' + txtDateS + ' ' + txtDateE + '</div>' +
                                            ' <div>' + txtCount + '</div>' +
                                            ' <div>' + txtType + '</div>',
                                        full_Name2: Project.Project_name,
                                        Owner: false
                                      })
                                    }
                                  }
                                } else {
                                  var RoundDump = this.ProjectRound.filter(roundI => roundI.Project_code == Project.Project_code)
                                  if (RoundDump.length > 0) {
                                    RoundDump.map(RoundI => {
                                      txtDateS = ''
                                      txtDateE = ''
                                      txtCount = ''
                                      txtType = Project.Approve == '1' ? '<span style="font-weight: bold;color: #FF80AB">(ผ่านการเสนอแผนขอตั้งงบประมาณประจำปี)</span>' : '<span style="font-weight: bold;color: #EA80FC">(ไม่ผ่านการเสนอแผนขอตั้งงบประมาณประจำปี)</span>'
                                      if (RoundI.DateS_Reg != null && RoundI.DateS_Reg != '0000-00-00') {
                                        txtDateS = '<span style="font-weight: bold;color: #ff6d81">วันที่เปิดรับสมัคร ' + Vue.filter('DateToThai')(RoundI.DateS_Reg) + '</span>'
                                      } else {
                                        txtDateS = '<span style="font-weight: bold;color: #ff6d81">วันที่เปิดรับสมัคร - </span>'
                                      }
                                      if (RoundI.DateE_Reg != null && RoundI.DateE_Reg != '0000-00-00') {
                                        txtDateE = '<span style="font-weight: bold;color: #ff6d81">วันที่ปิดรับสมัคร ' + Vue.filter('DateToThai')(RoundI.DateE_Reg) + '</span>'
                                      } else {
                                        txtDateE = '<span style="font-weight: bold;color: #ff6d81">วันที่ปิดรับสมัคร - </span>'
                                      }
                                      if (RoundI.Status_Count_Reg == '1') {
                                        txtCount = '<span style="font-weight: bold;color: #42b983">จำนวนที่เปิดรับ ไม่จำกัด </span>'
                                      } else {
                                        if (RoundI.Count_Reg != null && RoundI.Count_Reg != '') {
                                          txtCount = '<span style="font-weight: bold;color: #42b983">จำนวนที่เปิดรับ ' + RoundI.Count_Reg + '</span>'
                                        } else {
                                          txtCount = '<span style="font-weight: bold;color: #42b983">จำนวนที่เปิดรับ - </span>'
                                        }
                                      }
                                      if (this.projectDataToTable.length > 0) {
                                        if (this.projectDataToTable.filter(project_i => project_i.Project_code == RoundI.Project_code && RoundI.id == project_i.Ref_id).length == 0) {
                                          this.projectDataToTable.push({
                                            ...RoundI,
                                            idx: this.projectDataToTable.length,
                                            Ref_id: RoundI.id,
                                            full_Name: '<span style="font-weight: bold;color: darkblue">' + RoundI.Project_name + '</span>'
                                                + '<span style="font-weight: bold;color: magenta;margin-left: 10px">( รุ่น ' + RoundI.Round + ' ' + RoundI.Round_name + ')</span>'
                                                + ' <div>' + txtDateS + ' ' + txtDateE + '</div>' +
                                                ' <div>' + txtCount + '</div>' +
                                                ' <div>' + txtType + '</div>',
                                            full_Name2: RoundI.Project_name + ' -> ( รุ่น ' + RoundI.Round + ' ' + RoundI.Round_name + ' )',
                                            Owner: false
                                          })
                                        }
                                      } else {
                                        this.projectDataToTable.push({
                                          ...RoundI,
                                          idx: this.projectDataToTable.length,
                                          Ref_id: RoundI.id,
                                          full_Name: '<span style="font-weight: bold;color: darkblue">' + RoundI.Project_name + '</span>'
                                              + '<span style="font-weight: bold;color: magenta;margin-left: 10px">( รุ่น ' + RoundI.Round + ' ' + RoundI.Round_name + ')</span>'
                                              + ' <div>' + txtDateS + ' ' + txtDateE + '</div>' +
                                              ' <div>' + txtCount + '</div>' +
                                              ' <div>' + txtType + '</div>',
                                          full_Name2: RoundI.Project_name + ' -> ( รุ่น ' + RoundI.Round + ' ' + RoundI.Round_name + ' )',
                                          Owner: false
                                        })
                                      }
                                    })
                                  }
                                }
                              }
                            }
                          })
                          // /!***  -------------------------------- ***!/
                        }
                      }
                    })
                  }

                  this.dialogLoading = false
                  this.ChooseTypeRequest()
                } else {
                  this.dialogLoading = false
                  this.ChooseTypeRequest()
                }
              })
            } else {
              this.dialogLoading = false
            }
          })
        } else if (this.CheckSubAdmin) {
          this.getPermissionDepUserData({
            perid: this.MeData[0].perid
          }).then(resDep => {
            if (resDep) {
              this.projectForApprove.map(Project => {
                if (Project.IsRoundStatus == '0') {
                  var DepData = this.Permission_Dep_User.filter(Dep => Project.Dep_Code == Dep.dep_id || Project.dep_id == Dep.dep_id)
                  txtDateS = ''
                  txtDateE = ''
                  txtCount = ''
                  txtType = Project.Approve == '1' ? '<span style="font-weight: bold;color: #FF80AB">(ผ่านการเสนอแผนขอตั้งงบประมาณประจำปี)</span>' : '<span style="font-weight: bold;color: #EA80FC">(ไม่ผ่านการเสนอแผนขอตั้งงบประมาณประจำปี)</span>'
                  if (DepData.length > 0) {
                    if (Project.DateS_Reg != null && Project.DateS_Reg != '0000-00-00') {
                      txtDateS = '<span style="font-weight: bold;color: #ff6d81">วันที่เปิดรับสมัคร ' + Vue.filter('DateToThai')(Project.DateS_Reg) + '</span>'
                    } else {
                      txtDateS = '<span style="font-weight: bold;color: #ff6d81">วันที่เปิดรับสมัคร - </span>'
                    }
                    if (Project.DateE_Reg != null && Project.DateE_Reg != '0000-00-00') {
                      txtDateE = '<span style="font-weight: bold;color: #ff6d81">วันที่ปิดรับสมัคร ' + Vue.filter('DateToThai')(Project.DateE_Reg) + '</span>'
                    } else {
                      txtDateE = '<span style="font-weight: bold;color: #ff6d81">วันที่ปิดรับสมัคร - </span>'
                    }
                    if (Project.Status_Count_Reg == '1') {
                      txtCount = '<span style="font-weight: bold;color: #42b983">จำนวนที่เปิดรับ ไม่จำกัด </span>'
                    } else {
                      if (Project.Count_Reg != null && Project.Count_Reg != '') {
                        txtCount = '<span style="font-weight: bold;color: #42b983">จำนวนที่เปิดรับ ' + Project.Count_Reg + '</span>'
                      } else {
                        txtCount = '<span style="font-weight: bold;color: #42b983">จำนวนที่เปิดรับ - </span>'
                      }
                    }

                    this.projectDataToTable.push({
                      ...Project,
                      idx: this.projectDataToTable.length,
                      Ref_id: this.projectDataToTable.length,
                      full_Name: '<span style="font-weight: bold;color: darkblue">' + Project.Project_name + '</span>' + ' <div>' + txtDateS + ' ' + txtDateE + '</div>' +
                          ' <div>' + txtCount + '</div>' +
                          ' <div>' + txtType + '</div>',
                      full_Name2: Project.Project_name,
                      Owner: true
                    })
                  }
                } else {
                  //
                  var RoundDump = this.ProjectRound.filter(roundI => roundI.Project_code == Project.Project_code)
                  if (RoundDump.length > 0) {
                    RoundDump.map(RoundI => {
                      DepData = this.Permission_Dep_User.filter(Dep => RoundI.Dep_Code == Dep.dep_id || RoundI.dep_id == Dep.dep_id)
                      txtDateS = ''
                      txtDateE = ''
                      txtCount = ''
                      txtType = Project.Approve == '1' ? '<span style="font-weight: bold;color: #FF80AB">(ผ่านการเสนอแผนขอตั้งงบประมาณประจำปี)</span>' : '<span style="font-weight: bold;color: #EA80FC">(ไม่ผ่านการเสนอแผนขอตั้งงบประมาณประจำปี)</span>'
                      if (DepData.length > 0) {
                        if (RoundI.DateS_Reg != null && RoundI.DateS_Reg != '0000-00-00') {
                          txtDateS = '<span style="font-weight: bold;color: #ff6d81">วันที่เปิดรับสมัคร ' + Vue.filter('DateToThai')(RoundI.DateS_Reg) + '</span>'
                        } else {
                          txtDateS = '<span style="font-weight: bold;color: #ff6d81">วันที่เปิดรับสมัคร - </span>'
                        }
                        if (RoundI.DateE_Reg != null && RoundI.DateE_Reg != '0000-00-00') {
                          txtDateE = '<span style="font-weight: bold;color: #ff6d81">วันที่ปิดรับสมัคร ' + Vue.filter('DateToThai')(RoundI.DateE_Reg) + '</span>'
                        } else {
                          txtDateE = '<span style="font-weight: bold;color: #ff6d81">วันที่ปิดรับสมัคร - </span>'
                        }
                        if (RoundI.Status_Count_Reg == '1') {
                          txtCount = '<span style="font-weight: bold;color: #42b983">จำนวนที่เปิดรับ ไม่จำกัด </span>'
                        } else {
                          if (RoundI.Count_Reg != null && RoundI.Count_Reg != '') {
                            txtCount = '<span style="font-weight: bold;color: #42b983">จำนวนที่เปิดรับ ' + RoundI.Count_Reg + '</span>'
                          } else {
                            txtCount = '<span style="font-weight: bold;color: #42b983">จำนวนที่เปิดรับ - </span>'
                          }
                        }

                        this.projectDataToTable.push({
                          ...RoundI,
                          idx: this.projectDataToTable.length,
                          Ref_id: RoundI.id,
                          full_Name: '<span style="font-weight: bold;color: darkblue">' + RoundI.Project_name + '</span>'
                              + '<span style="font-weight: bold;color: magenta;margin-left: 10px">( รุ่น ' + RoundI.Round + ' ' + RoundI.Round_name + ')</span>'
                              + ' <div>' + txtDateS + ' ' + txtDateE + '</div>' +
                              ' <div>' + txtCount + '</div>' +
                              ' <div>' + txtType + '</div>',
                          full_Name2: RoundI.Project_name + ' -> ( รุ่น ' + RoundI.Round + ' ' + RoundI.Round_name + ' )',
                          Owner: true
                        })
                      }
                    })
                  }
                }
              })

              this.Permission_Dep_User.map(Dep => {
                if (departDump.length > 0) {
                  if (departDump.filter(item => item.dep_id == Dep.dep_id).length == 0) {
                    departDump = departDump.concat(this.depart.filter(item => item.dep_id == Dep.dep_id))
                  }
                } else {
                  departDump = departDump.concat(this.depart.filter(item => item.dep_id == Dep.dep_id))
                }
              })

              // !***  เงื่อนไข filter บุคลากรให้เลือกเข้าร่วมโครงการ  ***!
              this.Permission_Dep_User.map(Dep => {
                this.staffDataDump = this.staffDataDump.concat(this.staffData.filter(staff_i => staff_i.dep_id == Dep.dep_id))
              })
              // /!***  -------------------------------- ***!/

              this.initQuotaDepartRegister().then(resQuotaDepReg => {
                if (resQuotaDepReg) {
                  departDump.map((Dep, idxDep) => {
                    if (departDump.length > 0) {
                      var QoutaDepDataDump = this.QuotaDepart.filter(item => item.dep_group_id == Dep.dep_group_id)
                      if (QoutaDepDataDump.length > 0) {
                        if (this.QoutaDepData.length > 0) {
                          if (this.QoutaDepData.filter(item => item.dep_group_id == Dep.dep_group_id).length == 0) {
                            this.QoutaDepData = this.QoutaDepData.concat(this.QuotaDepart);
                          }
                        } else {
                          this.QoutaDepData = this.QoutaDepData.concat(this.QuotaDepart);
                        }
                      }
                    }

                    if (idxDep == departDump.length - 1) {
                      if (this.QoutaDepData.length > 0) {
                        this.QoutaDepData.map(DepQ_i => {
                          if (DepQ_i.dep_type == '0') {
                            if (this.Permission_Dep_User.filter(item => item.dep_id == DepQ_i.dep_id).length > 0) {
                              this.projectForApprove.map(Project => {
                                if (Project.Project_code == DepQ_i.Project_code) {
                                  if (Project.IsRoundStatus == '0') {
                                    txtDateS = ''
                                    txtDateE = ''
                                    txtCount = ''
                                    txtType = Project.Approve == '1' ? '<span style="font-weight: bold;color: #FF80AB">(ผ่านการเสนอแผนขอตั้งงบประมาณประจำปี)</span>' : '<span style="font-weight: bold;color: #EA80FC">(ไม่ผ่านการเสนอแผนขอตั้งงบประมาณประจำปี)</span>'
                                    if (Project.DateS_Reg != null && Project.DateS_Reg != '0000-00-00') {
                                      txtDateS = '<span style="font-weight: bold;color: #ff6d81">วันที่เปิดรับสมัคร ' + Vue.filter('DateToThai')(Project.DateS_Reg) + '</span>'
                                    } else {
                                      txtDateS = '<span style="font-weight: bold;color: #ff6d81">วันที่เปิดรับสมัคร - </span>'
                                    }
                                    if (Project.DateE_Reg != null && Project.DateE_Reg != '0000-00-00') {
                                      txtDateE = '<span style="font-weight: bold;color: #ff6d81">วันที่ปิดรับสมัคร ' + Vue.filter('DateToThai')(Project.DateE_Reg) + '</span>'
                                    } else {
                                      txtDateE = '<span style="font-weight: bold;color: #ff6d81">วันที่ปิดรับสมัคร - </span>'
                                    }
                                    if (Project.Status_Count_Reg == '1') {
                                      txtCount = '<span style="font-weight: bold;color: #42b983">จำนวนที่เปิดรับ ไม่จำกัด </span>'
                                    } else {
                                      if (Project.Count_Reg != null && Project.Count_Reg != '') {
                                        txtCount = '<span style="font-weight: bold;color: #42b983">จำนวนที่เปิดรับ ' + Project.Count_Reg + '</span>'
                                      } else {
                                        txtCount = '<span style="font-weight: bold;color: #42b983">จำนวนที่เปิดรับ - </span>'
                                      }
                                    }
                                    if (this.projectDataToTable.length > 0) {
                                      if (this.projectDataToTable.filter(project_i => project_i.Project_code == Project.Project_code).length == 0) {
                                        this.projectDataToTable.push({
                                          ...Project,
                                          idx: this.projectDataToTable.length,
                                          Ref_id: this.projectDataToTable.length,
                                          full_Name: '<span style="font-weight: bold;color: darkblue">' + Project.Project_name + '</span>' + ' <div>' + txtDateS + ' ' + txtDateE + '</div>' +
                                              ' <div>' + txtCount + '</div>' +
                                              ' <div>' + txtType + '</div>',
                                          full_Name2: Project.Project_name,
                                          Owner: false
                                        })
                                      }
                                    }
                                  } else {
                                    var RoundDump = this.ProjectRound.filter(roundI => roundI.Project_code == Project.Project_code)
                                    if (RoundDump.length > 0) {
                                      RoundDump.map(RoundI => {
                                        txtDateS = ''
                                        txtDateE = ''
                                        txtCount = ''
                                        txtType = Project.Approve == '1' ? '<span style="font-weight: bold;color: #FF80AB">(ผ่านการเสนอแผนขอตั้งงบประมาณประจำปี)</span>' : '<span style="font-weight: bold;color: #EA80FC">(ไม่ผ่านการเสนอแผนขอตั้งงบประมาณประจำปี)</span>'
                                        if (RoundI.DateS_Reg != null && RoundI.DateS_Reg != '0000-00-00') {
                                          txtDateS = '<span style="font-weight: bold;color: #ff6d81">วันที่เปิดรับสมัคร ' + Vue.filter('DateToThai')(RoundI.DateS_Reg) + '</span>'
                                        } else {
                                          txtDateS = '<span style="font-weight: bold;color: #ff6d81">วันที่เปิดรับสมัคร - </span>'
                                        }
                                        if (RoundI.DateE_Reg != null && RoundI.DateE_Reg != '0000-00-00') {
                                          txtDateE = '<span style="font-weight: bold;color: #ff6d81">วันที่ปิดรับสมัคร ' + Vue.filter('DateToThai')(RoundI.DateE_Reg) + '</span>'
                                        } else {
                                          txtDateE = '<span style="font-weight: bold;color: #ff6d81">วันที่ปิดรับสมัคร - </span>'
                                        }
                                        if (RoundI.Status_Count_Reg == '1') {
                                          txtCount = '<span style="font-weight: bold;color: #42b983">จำนวนที่เปิดรับ ไม่จำกัด </span>'
                                        } else {
                                          if (RoundI.Count_Reg != null && RoundI.Count_Reg != '') {
                                            txtCount = '<span style="font-weight: bold;color: #42b983">จำนวนที่เปิดรับ ' + RoundI.Count_Reg + '</span>'
                                          } else {
                                            txtCount = '<span style="font-weight: bold;color: #42b983">จำนวนที่เปิดรับ - </span>'
                                          }
                                        }
                                        if (this.projectDataToTable.length > 0) {
                                          if (this.projectDataToTable.filter(project_i => project_i.Project_code == RoundI.Project_code && RoundI.id == project_i.Ref_id).length == 0) {
                                            this.projectDataToTable.push({
                                              ...RoundI,
                                              idx: this.projectDataToTable.length,
                                              Ref_id: RoundI.id,
                                              full_Name: '<span style="font-weight: bold;color: darkblue">' + RoundI.Project_name
                                                  + '<span style="font-weight: bold;color: magenta;margin-left: 10px">( รุ่น ' + RoundI.Round + ' ' + RoundI.Round_name + ')</span>'
                                                  + '</span>' + ' <div>' + txtDateS + ' ' + txtDateE + '</div>' +
                                                  ' <div>' + txtCount + '</div>' +
                                                  ' <div>' + txtType + '</div>',
                                              full_Name2: RoundI.Project_name + ' -> ( รุ่น ' + RoundI.Round + ' ' + RoundI.Round_name + ' )',
                                              Owner: false
                                            })
                                          }
                                        } else {
                                          this.projectDataToTable.push({
                                            ...RoundI,
                                            idx: this.projectDataToTable.length,
                                            Ref_id: RoundI.id,
                                            full_Name: '<span style="font-weight: bold;color: darkblue">' + RoundI.Project_name
                                                + '<span style="font-weight: bold;color: magenta;margin-left: 10px">( รุ่น ' + RoundI.Round + ' ' + RoundI.Round_name + ')</span>'
                                                + '</span>' + ' <div>' + txtDateS + ' ' + txtDateE + '</div>' +
                                                ' <div>' + txtCount + '</div>' +
                                                ' <div>' + txtType + '</div>',
                                            full_Name2: RoundI.Project_name + ' -> ( รุ่น ' + RoundI.Round + ' ' + RoundI.Round_name + ' )',
                                            Owner: false
                                          })
                                        }
                                      })
                                    }
                                  }
                                }
                              })
                            }
                          } else {
                            var DepGroupArr = this.depart.filter(Dep_i => Dep_i.dep_group_id == DepQ_i.dep_group_id)
                            if (DepGroupArr.length > 0) {
                              DepGroupArr.map(itemDep_arr => {
                                if (this.Permission_Dep_User.filter(item => item.dep_id == itemDep_arr.dep_id).length > 0) {
                                  this.projectForApprove.map(Project => {
                                    if (Project.Project_code == DepQ_i.Project_code) {
                                      if (this.projectDataToTable.filter(p_ToTable => p_ToTable.Project_code == DepQ_i.Project_code).length == 0) {
                                        if (Project.IsRoundStatus == '0') {
                                          txtDateS = ''
                                          txtDateE = ''
                                          txtCount = ''
                                          txtType = Project.Approve == '1' ? '<span style="font-weight: bold;color: #FF80AB">(ผ่านการเสนอแผนขอตั้งงบประมาณประจำปี)</span>' : '<span style="font-weight: bold;color: #EA80FC">(ไม่ผ่านการเสนอแผนขอตั้งงบประมาณประจำปี)</span>'
                                          if (Project.DateS_Reg != null && Project.DateS_Reg != '0000-00-00') {
                                            txtDateS = '<span style="font-weight: bold;color: #ff6d81">วันที่เปิดรับสมัคร ' + Vue.filter('DateToThai')(Project.DateS_Reg) + '</span>'
                                          } else {
                                            txtDateS = '<span style="font-weight: bold;color: #ff6d81">วันที่เปิดรับสมัคร - </span>'
                                          }
                                          if (Project.DateE_Reg != null && Project.DateE_Reg != '0000-00-00') {
                                            txtDateE = '<span style="font-weight: bold;color: #ff6d81">วันที่ปิดรับสมัคร ' + Vue.filter('DateToThai')(Project.DateE_Reg) + '</span>'
                                          } else {
                                            txtDateE = '<span style="font-weight: bold;color: #ff6d81">วันที่ปิดรับสมัคร - </span>'
                                          }
                                          if (Project.Status_Count_Reg == '1') {
                                            txtCount = '<span style="font-weight: bold;color: #42b983">จำนวนที่เปิดรับ ไม่จำกัด </span>'
                                          } else {
                                            if (Project.Count_Reg != null && Project.Count_Reg != '') {
                                              txtCount = '<span style="font-weight: bold;color: #42b983">จำนวนที่เปิดรับ ' + Project.Count_Reg + '</span>'
                                            } else {
                                              txtCount = '<span style="font-weight: bold;color: #42b983">จำนวนที่เปิดรับ - </span>'
                                            }
                                          }
                                          if (this.projectDataToTable.length > 0) {
                                            if (this.projectDataToTable.filter(project_i => project_i.Project_code == Project.Project_code).length == 0) {
                                              this.projectDataToTable.push({
                                                ...Project,
                                                idx: this.projectDataToTable.length,
                                                Ref_id: this.projectDataToTable.length,
                                                full_Name: '<span style="font-weight: bold;color: darkblue">' + Project.Project_name + '</span>' + ' <div>' + txtDateS + ' ' + txtDateE + '</div>' +
                                                    ' <div>' + txtCount + '</div>' +
                                                    ' <div>' + txtType + '</div>',
                                                full_Name2: Project.Project_name,
                                                Owner: false
                                              })
                                            }
                                          }
                                        } else {
                                          var RoundDump = this.ProjectRound.filter(roundI => roundI.Project_code == Project.Project_code)
                                          if (RoundDump.length > 0) {
                                            RoundDump.map(RoundI => {
                                              txtDateS = ''
                                              txtDateE = ''
                                              txtCount = ''
                                              txtType = Project.Approve == '1' ? '<span style="font-weight: bold;color: #FF80AB">(ผ่านการเสนอแผนขอตั้งงบประมาณประจำปี)</span>' : '<span style="font-weight: bold;color: #EA80FC">(ไม่ผ่านการเสนอแผนขอตั้งงบประมาณประจำปี)</span>'
                                              if (RoundI.DateS_Reg != null && RoundI.DateS_Reg != '0000-00-00') {
                                                txtDateS = '<span style="font-weight: bold;color: #ff6d81">วันที่เปิดรับสมัคร ' + Vue.filter('DateToThai')(RoundI.DateS_Reg) + '</span>'
                                              } else {
                                                txtDateS = '<span style="font-weight: bold;color: #ff6d81">วันที่เปิดรับสมัคร - </span>'
                                              }
                                              if (RoundI.DateE_Reg != null && RoundI.DateE_Reg != '0000-00-00') {
                                                txtDateE = '<span style="font-weight: bold;color: #ff6d81">วันที่ปิดรับสมัคร ' + Vue.filter('DateToThai')(RoundI.DateE_Reg) + '</span>'
                                              } else {
                                                txtDateE = '<span style="font-weight: bold;color: #ff6d81">วันที่ปิดรับสมัคร - </span>'
                                              }
                                              if (RoundI.Status_Count_Reg == '1') {
                                                txtCount = '<span style="font-weight: bold;color: #42b983">จำนวนที่เปิดรับ ไม่จำกัด </span>'
                                              } else {
                                                if (RoundI.Count_Reg != null && RoundI.Count_Reg != '') {
                                                  txtCount = '<span style="font-weight: bold;color: #42b983">จำนวนที่เปิดรับ ' + RoundI.Count_Reg + '</span>'
                                                } else {
                                                  txtCount = '<span style="font-weight: bold;color: #42b983">จำนวนที่เปิดรับ - </span>'
                                                }
                                              }
                                              if (this.projectDataToTable.length > 0) {
                                                if (this.projectDataToTable.filter(project_i => project_i.Project_code == RoundI.Project_code && RoundI.id == project_i.Ref_id).length == 0) {
                                                  this.projectDataToTable.push({
                                                    ...RoundI,
                                                    idx: this.projectDataToTable.length,
                                                    Ref_id: RoundI.id,
                                                    full_Name: '<span style="font-weight: bold;color: darkblue">' + RoundI.Project_name
                                                        + '<span style="font-weight: bold;color: magenta;margin-left: 10px">( รุ่น ' + RoundI.Round + ' ' + RoundI.Round_name + ')</span>'
                                                        + '</span>' + ' <div>' + txtDateS + ' ' + txtDateE + '</div>' +
                                                        ' <div>' + txtCount + '</div>' +
                                                        ' <div>' + txtType + '</div>',
                                                    full_Name2: RoundI.Project_name + ' -> ( รุ่น ' + RoundI.Round + ' ' + RoundI.Round_name + ' )',
                                                    Owner: false
                                                  })
                                                }
                                              } else {
                                                this.projectDataToTable.push({
                                                  ...RoundI,
                                                  idx: this.projectDataToTable.length,
                                                  Ref_id: RoundI.id,
                                                  full_Name: '<span style="font-weight: bold;color: darkblue">' + RoundI.Project_name
                                                      + '<span style="font-weight: bold;color: magenta;margin-left: 10px">( รุ่น ' + RoundI.Round + ' ' + RoundI.Round_name + ')</span>'
                                                      + '</span>' + ' <div>' + txtDateS + ' ' + txtDateE + '</div>' +
                                                      ' <div>' + txtCount + '</div>' +
                                                      ' <div>' + txtType + '</div>',
                                                  full_Name2: RoundI.Project_name + ' -> ( รุ่น ' + RoundI.Round + ' ' + RoundI.Round_name + ' )',
                                                  Owner: false
                                                })
                                              }
                                            })
                                          }
                                        }
                                      }
                                    }
                                  })
                                }
                              })
                            }
                          }
                        })

                        // /!***  เงื่อนไข โครงการที่ผู้อื่นจัดให้เห็นข้อมูลโครงการนั้นด้วย ***!/
                        this.projectForApprove.map(Project => {
                          if (Project.Status_Reg == '0' && (Project.Status_Type_Reg == '0' || Project.Status_Type_Reg == '1')) {
                            if (this.projectDataToTable.filter(ProjectToTabel_i => ProjectToTabel_i.Project_code == Project.Project_code).length == 0) {
                              if (Project.IsRoundStatus == '0') {
                                txtDateS = ''
                                txtDateE = ''
                                txtCount = ''
                                txtType = Project.Approve == '1' ? '<span style="font-weight: bold;color: #FF80AB">(ผ่านการเสนอแผนขอตั้งงบประมาณประจำปี)</span>' : '<span style="font-weight: bold;color: #EA80FC">(ไม่ผ่านการเสนอแผนขอตั้งงบประมาณประจำปี)</span>'
                                if (Project.DateS_Reg != null && Project.DateS_Reg != '0000-00-00') {
                                  txtDateS = '<span style="font-weight: bold;color: #ff6d81">วันที่เปิดรับสมัคร ' + Vue.filter('DateToThai')(Project.DateS_Reg) + '</span>'
                                } else {
                                  txtDateS = '<span style="font-weight: bold;color: #ff6d81">วันที่เปิดรับสมัคร - </span>'
                                }
                                if (Project.DateE_Reg != null && Project.DateE_Reg != '0000-00-00') {
                                  txtDateE = '<span style="font-weight: bold;color: #ff6d81">วันที่ปิดรับสมัคร ' + Vue.filter('DateToThai')(Project.DateE_Reg) + '</span>'
                                } else {
                                  txtDateE = '<span style="font-weight: bold;color: #ff6d81">วันที่ปิดรับสมัคร - </span>'
                                }
                                if (Project.Status_Count_Reg == '1') {
                                  txtCount = '<span style="font-weight: bold;color: #42b983">จำนวนที่เปิดรับ ไม่จำกัด </span>'
                                } else {
                                  if (Project.Count_Reg != null && Project.Count_Reg != '') {
                                    txtCount = '<span style="font-weight: bold;color: #42b983">จำนวนที่เปิดรับ ' + Project.Count_Reg + '</span>'
                                  } else {
                                    txtCount = '<span style="font-weight: bold;color: #42b983">จำนวนที่เปิดรับ - </span>'
                                  }
                                }
                                if (this.projectDataToTable.length > 0) {
                                  if (this.projectDataToTable.filter(project_i => project_i.Project_code == Project.Project_code).length == 0) {
                                    this.projectDataToTable.push({
                                      ...Project,
                                      idx: this.projectDataToTable.length,
                                      Ref_id: this.projectDataToTable.length,
                                      full_Name: '<span style="font-weight: bold;color: darkblue">' + Project.Project_name + '</span>' + ' <div>' + txtDateS + ' ' + txtDateE + '</div>' +
                                          ' <div>' + txtCount + '</div>' +
                                          ' <div>' + txtType + '</div>',
                                      full_Name2: Project.Project_name,
                                      Owner: false
                                    })
                                  }
                                }
                              } else {
                                var RoundDump = this.ProjectRound.filter(roundI => roundI.Project_code == Project.Project_code)
                                if (RoundDump.length > 0) {
                                  RoundDump.map(RoundI => {
                                    txtDateS = ''
                                    txtDateE = ''
                                    txtCount = ''
                                    txtType = Project.Approve == '1' ? '<span style="font-weight: bold;color: #FF80AB">(ผ่านการเสนอแผนขอตั้งงบประมาณประจำปี)</span>' : '<span style="font-weight: bold;color: #EA80FC">(ไม่ผ่านการเสนอแผนขอตั้งงบประมาณประจำปี)</span>'
                                    if (RoundI.DateS_Reg != null && RoundI.DateS_Reg != '0000-00-00') {
                                      txtDateS = '<span style="font-weight: bold;color: #ff6d81">วันที่เปิดรับสมัคร ' + Vue.filter('DateToThai')(RoundI.DateS_Reg) + '</span>'
                                    } else {
                                      txtDateS = '<span style="font-weight: bold;color: #ff6d81">วันที่เปิดรับสมัคร - </span>'
                                    }
                                    if (RoundI.DateE_Reg != null && RoundI.DateE_Reg != '0000-00-00') {
                                      txtDateE = '<span style="font-weight: bold;color: #ff6d81">วันที่ปิดรับสมัคร ' + Vue.filter('DateToThai')(RoundI.DateE_Reg) + '</span>'
                                    } else {
                                      txtDateE = '<span style="font-weight: bold;color: #ff6d81">วันที่ปิดรับสมัคร - </span>'
                                    }
                                    if (RoundI.Status_Count_Reg == '1') {
                                      txtCount = '<span style="font-weight: bold;color: #42b983">จำนวนที่เปิดรับ ไม่จำกัด </span>'
                                    } else {
                                      if (RoundI.Count_Reg != null && RoundI.Count_Reg != '') {
                                        txtCount = '<span style="font-weight: bold;color: #42b983">จำนวนที่เปิดรับ ' + RoundI.Count_Reg + '</span>'
                                      } else {
                                        txtCount = '<span style="font-weight: bold;color: #42b983">จำนวนที่เปิดรับ - </span>'
                                      }
                                    }
                                    if (this.projectDataToTable.length > 0) {
                                      if (this.projectDataToTable.filter(project_i => project_i.Project_code == RoundI.Project_code && RoundI.id == project_i.Ref_id).length == 0) {
                                        this.projectDataToTable.push({
                                          ...RoundI,
                                          idx: this.projectDataToTable.length,
                                          Ref_id: RoundI.id,
                                          full_Name: '<span style="font-weight: bold;color: darkblue">' + RoundI.Project_name
                                              + '<span style="font-weight: bold;color: magenta;margin-left: 10px">( รุ่น ' + RoundI.Round + ' ' + RoundI.Round_name + ')</span>'
                                              + '</span>' + ' <div>' + txtDateS + ' ' + txtDateE + '</div>' +
                                              ' <div>' + txtCount + '</div>' +
                                              ' <div>' + txtType + '</div>',
                                          full_Name2: RoundI.Project_name + ' -> ( รุ่น ' + RoundI.Round + ' ' + RoundI.Round_name + ' )',
                                          Owner: false
                                        })
                                      }
                                    } else {
                                      this.projectDataToTable.push({
                                        ...RoundI,
                                        idx: this.projectDataToTable.length,
                                        Ref_id: RoundI.id,
                                        full_Name: '<span style="font-weight: bold;color: darkblue">' + RoundI.Project_name
                                            + '<span style="font-weight: bold;color: magenta;margin-left: 10px">( รุ่น ' + RoundI.Round + ' ' + RoundI.Round_name + ')</span>'
                                            + '</span>' + ' <div>' + txtDateS + ' ' + txtDateE + '</div>' +
                                            ' <div>' + txtCount + '</div>' +
                                            ' <div>' + txtType + '</div>',
                                        full_Name2: RoundI.Project_name + ' -> ( รุ่น ' + RoundI.Round + ' ' + RoundI.Round_name + ' )',
                                        Owner: false
                                      })
                                    }
                                  })
                                }
                              }
                            }
                          }
                        })
                        // /!***  -------------------------------- ***!/
                      }
                    }
                  })
                  this.dialogLoading = false
                  this.ChooseTypeRequest()
                } else {
                  this.dialogLoading = false
                  this.ChooseTypeRequest()
                }
              })
            } else {
              this.dialogLoading = false
            }
          })
        }
      }

      this.initDepartData()

      this.initlevelData()

      this.initCardData()

    },
    CheckPermissFunc(permiss) {
      var CheckPermiss = false
      return new Promise(resolve => {
        if (this.PermissionAdmin.length > 0) {
          this.PermissionAdmin.map((Per_i, idx) => {
            if (Per_i.permission_id == permiss) {
              CheckPermiss = true
              resolve(true)
            } else {
              if (!CheckPermiss && idx == this.PermissionAdmin.length - 1) {
                resolve(false)
              }
            }
          })
        } else {
          this.Permission.map((Per_i, idx) => {
            if (Per_i.permission_id == permiss) {
              CheckPermiss = true
              resolve(true)
            } else {
              if (!CheckPermiss && idx == this.Permission.length - 1) {
                resolve(false)
              }
            }
          })
        }
      })
    },
    checkShowData(item) {
      if (item.File_name.indexOf('.rar') >= 0) {
        return false;
      } else if (item.File_type == 'application/x-zip-compressed') {
        return false;
      } else {
        switch (item.File_type) {
          case 'image/jpg':
          case 'image/jpeg':
          case 'image/gif':
          case 'image/bmp':
          case 'image/png':
            return true;
          case 'application/pdf':
            return true;
          default:
            return false;
        }
      }
    },
    downloadFiles(item) {
      var link = document.createElement("a");
      // If you don't know the name or want to use
      // the webserver default set name = ''
      link.setAttribute('download', item.File_name);
      link.href = this.Openfile + item.File_path;
      document.body.appendChild(link);
      link.click();
      link.remove();
    },
    ShowData(dataUrl) {
      window.open(
          dataUrl,
          '_blank' // <- This is what makes it open in a new window.
      );
    },
    ShowFile(item) {
      this.personObj = null
      this.personObj = item
      this.dialogFile = true
    },
    FileSelect() {
      // var count = 0
      this.txtAlertP = []
      this.FilePerson = []
      this.alertP = false
      if (this.filesP.length > 0) {
        this.filesP.map((item) => {
          var Checkfile = false;
          if (item.name.indexOf('.rar') >= 0) {
            Checkfile = true;
          } else if (item.type == 'application/x-zip-compressed') {
            Checkfile = true;
          } else {
            switch (item.type) {
              case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
              case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
              case 'image/jpg':
              case 'image/jpeg':
              case 'image/gif':
              case 'image/bmp':
              case 'image/png':
                Checkfile = true;
                break
              case 'application/pdf':
                Checkfile = true;
                break
              default:
                Checkfile = false;
                break
            }
          }

          if (Checkfile) {
            if (item.size > 25000000) {
              this.txtAlertP.push({
                id: this.txtAlertP.length + 1,
                Detail: 'ไฟล์ ' + item.name + ' ขนาดเกิน 25 mb*'
              })
            }
          } else {
            this.txtAlertP.push({
              id: this.txtAlertP.length + 1,
              Detail: 'ไม่สนับสนุนนามสกุลไฟล์ ' + item.type + ' ( ' + item.name + ' ) '
            })
          }
        })
        // setTimeout(() => {
        //   this.alert = false
        // }, 3000)
      }

      if (this.txtAlertP.length == 0) {
        this.dialogLoading = true
        var idx = 0
        if (this.filesP.length > 0) {
          this.filesP.map(async (item) => {
            const fd = new FormData()
            fd.append('file', item, item.name)
            const headerAxios = {
              headers: {
                'Content-Type': 'multipart/form-data',
                'WithCredentials': true,
                "Access-Control-Allow-Origin": "*"
                // "Accept": 'multipart/form-data'
              }
            }

            await axios.post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/uploadfile', fd, headerAxios).then(res => {
              if (res.data.status) {
                if (item.name.indexOf('.rar') >= 0) {
                  this.FilePerson.push({
                    name: item.name,
                    src: URL.createObjectURL(item),
                    path: res.data.path,
                    type: 'rar',
                    type_Img: item.type,
                    File_name: item.name,
                    File_path: res.data.path,
                    File_type: item.type
                  })
                } else if (item.type == 'application/x-zip-compressed') {
                  this.FilePerson.push({
                    name: item.name,
                    src: URL.createObjectURL(item),
                    path: res.data.path,
                    type: 'zip',
                    type_Img: item.type,
                    File_name: item.name,
                    File_path: res.data.path,
                    File_type: item.type
                  })
                } else if (item.type == 'application/vnd.openxmlformats-officedocument.presentationml.presentation') {
                  this.FilePerson.push({
                    name: item.name,
                    src: URL.createObjectURL(item),
                    path: res.data.path,
                    type: 'ppt',
                    type_Img: item.type
                  })
                } else if (item.type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
                  this.FilePerson.push({
                    name: item.name,
                    src: URL.createObjectURL(item),
                    path: res.data.path,
                    type: 'word',
                    type_Img: item.type
                  })
                } else {
                  switch (item.type) {
                    case 'image/jpg':
                    case 'image/jpeg':
                    case 'image/gif':
                    case 'image/bmp':
                    case 'image/png':
                      this.FilePerson.push({
                        name: item.name,
                        src: URL.createObjectURL(item),
                        path: res.data.path,
                        type: 'image',
                        type_Img: item.type,
                        File_name: item.name,
                        File_path: res.data.path,
                        File_type: item.type
                      })
                      break
                    case 'application/pdf':
                      this.FilePerson.push({
                        name: item.name,
                        src: URL.createObjectURL(item),
                        path: res.data.path,
                        type: 'pdf',
                        type_Img: item.type,
                        File_name: item.name,
                        File_path: res.data.path,
                        File_type: item.type
                      })
                      break
                    default:
                      break
                  }
                }
              }
              idx++
              if (idx == this.filesP.length) {
                this.dialogLoading = false
              }
            })
          })
        } else {
          this.dialogLoading = false
        }
      } else {
        this.$swal.fire({
          icon: 'error',
          title: 'ไม่สามารถอัพโหลดไฟล์ได้ เนื่องจากพบไฟล์ ไม่เข้าเงื่อนไขการอัพโหลด โปรดตรวจสอบข้อความข้อผิดพลาดพร้อมแก้ไขและลองอีกครั้ง!!'
        })
        this.alertP = true
      }

    },
    ChooseTypeStatus() {
      if (this.projectDataToTableDump2.length == 0) {
        this.projectDataToTableDump2 = this.projectDataToTable
      }
      this.projectDataToTable = []
      if (this.TypeStatus == '0') {
        this.projectDataToTable = this.projectDataToTableDump2
      } else {
        this.projectDataToTableDump2.map(item => {
          if ((item.DateS_Reg != '0000-00-00' && item.DateS_Reg != null) && (item.DateE_Reg != '0000-00-00' && item.DateE_Reg != null)) {
            if (item.DateE_Reg >= ALlFunc.getDateNow2(new Date())) {
              this.projectDataToTable.push(item)
            }
          } else if ((item.DateS_Reg != '0000-00-00' && item.DateS_Reg != null) && (item.DateE_Reg == '0000-00-00' || item.DateE_Reg == null)) {
            if (ALlFunc.getDateNow2(new Date()) >= item.DateS_Reg) {
              this.projectDataToTable.push(item)
            }
          } else if ((item.DateS_Reg == '0000-00-00' || item.DateS_Reg == null) && (item.DateE_Reg != '0000-00-00' && item.DateE_Reg != null)) {
            if (item.DateE_Reg <= ALlFunc.getDateNow2(new Date())) {
              this.projectDataToTable.push(item)
            }
          }
        })
      }
    },
    ChooseTypeRequest() {
      var DepData = []
      if (this.projectDataToTableDump.length == 0) {
        this.projectDataToTableDump = this.projectDataToTable
      }
      if (this.TypeRequest == '0') {
        this.projectDataToTable = this.projectDataToTableDump.filter(item => (item.IsPlanStatus == '2' || item.IsPlanStatus == '5' || item.IsPlanStatus == '6' || item.IsPlanStatus == '7') && item.Project_type == this.TypeProject)
      } else if (this.TypeRequest == '1') {
        this.projectDataToTable = []
        if (this.Permission_Dep.length > 0) {
          this.projectDataToTableDump.map(Project => {
            DepData = this.Permission_Dep.filter(Dep => (Project.Dep_Code == Dep.dep_id || Project.dep_id == Dep.dep_id) && (Project.IsPlanStatus == '2' || Project.IsPlanStatus == '5' || Project.IsPlanStatus == '6' || Project.IsPlanStatus == '7') && Project.Project_type == this.TypeProject)
            if (DepData.length > 0) {
              this.projectDataToTable.push(Project)
            }
          })
        } else if (this.Permission_Dep_User.length > 0) {
          this.projectDataToTableDump.map(Project => {
            DepData = this.Permission_Dep_User.filter(Dep => (Project.Dep_Code == Dep.dep_id || Project.dep_id == Dep.dep_id) && (Project.IsPlanStatus == '2' || Project.IsPlanStatus == '5' || Project.IsPlanStatus == '6' || Project.IsPlanStatus == '7') && Project.Project_type == this.TypeProject)
            if (DepData.length > 0) {
              this.projectDataToTable.push(Project)
            }
          })
        }
      } else {
        this.projectDataToTable = []
        this.projectDataToTable = this.projectDataToTableDump.filter(item => (item.IsPlanStatus == '2' || item.IsPlanStatus == '5' || item.IsPlanStatus == '6' || item.IsPlanStatus == '7') && item.Project_type == this.TypeProject && item.Status_Reg == '0' && (item.Status_Type_Reg == '0' || item.Status_Type_Reg == '1'))
        this.ChooseTypeStatus()
      }
    },
    approveType(param) {
      this.RequestPerson.map(item => {
        item.status_req = param
      })
    },
    clearData(ProjectObj) {
      if (ProjectObj != null) {
        // axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/request_project/Project_code/' + ProjectCode, {
        //   active: '0',
        //   Update_By: this.MeData[0].perid
        // })
        if (this.project.IsRoundStatus == '0') {
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/join_project/Project_code/' + ProjectObj.Project_code, {
            active: '0',
            Update_By: this.MeData[0].perid
          })
        } else {
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/join_project/Project_code/' + ProjectObj.Project_code + '/D_project_round_id/' + ProjectObj.D_project_round_id, {
            active: '0',
            Update_By: this.MeData[0].perid
          })
        }
        // axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Person_files/Project_code/' + ProjectCode, {
        //   active: '0',
        //   Update_By: this.MeData[0].perid
        // })
      }
    },
    ChangeStatusReq() {
      this.$swal.fire({
        title: 'ยืนยันการทำรายการ',
        text: "กรุณาตรวจสอบข้อมูลให้ถูกต้อง ก่อนทำการบันทึกข้อมูล",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          // var count = 0
          var RequestDump = this.RequestPerson.filter(item => item.status_req != '0')
          this.dialogLoading = true
          this.clearData(this.project == null ? null : this.project)
          this.CheckPermissFunc('7001').then(resPermiss => {
            if (resPermiss) {
              if (RequestDump.length > 0) {

                axios.post(ConstData.ConnectionHost + '/HrTrain2/serviceAPI.php', {
                  queryName: 'approveRequestJoinProject',
                  param: btoa(encodeURIComponent(JSON.stringify({
                    Project_code: this.project.Project_code,
                    Project_name: this.project.Project_name,
                    IsRound: this.project.IsRoundStatus,
                    D_project_round_id: this.project.id,
                    RequestProjectApprove: RequestDump,
                    Create_By: this.MeData[0].perid,
                  })))
                }).then(res => {
                  if (res.data.status) {
                    this.dialogLoading = false
                    this.updateRequestProject()
                    this.$swal.fire({
                      timer: 1500,
                      showConfirmButton: false,
                      icon: 'success',
                      title: 'บันทึกข้อมูลสำเร็จ'
                    })
                  } else {
                    this.dialogLoading = false
                    this.$swal.fire({
                      timer: 1500,
                      showConfirmButton: false,
                      icon: 'error',
                      title: 'ไม่สามารถบันทึกข้อมูลได้ โปรดลองอีกครั้ง'
                    })
                  }
                }).catch(err => {
                  console.log(err)
                  this.dialogLoading = false
                  this.$swal.fire({
                    timer: 1500,
                    showConfirmButton: false,
                    icon: 'error',
                    title: 'ไม่สามารถบันทึกข้อมูลได้ โปรดลองอีกครั้ง'
                  })
                })


                /*RequestDump.map(item => {
                  this.staffData.map((staff_I) => {
                    if (item.perid == staff_I.perid) {
                      this.insertJoinProject({
                        Project_code: this.project.Project_code,
                        D_project_round_id: this.project.id,
                        uid: staff_I.perid,
                        name: staff_I.name,
                        sname: staff_I.surname,
                        id_card: staff_I.citizen_id,
                        affiliation: staff_I.dep_name,
                        position: '',
                        phone: '',
                        registerType_id: 0,
                        Create_By: this.MeData[0].perid,
                        Create_Time: 'now()',
                      }, item.status_req).then(res => {
                        if (res) {
                          this.updateStatusReq(staff_I, item).then(itemReq => {
                            if (itemReq) {
                              count++
                              if (count == RequestDump.length) {
                                this.dialogLoading = false
                                this.updateRequestProject()
                                if (item.status_req != '0') {
                                  // this.sendMailApprove(staff_I, item)
                                }
                                this.$swal.fire({
                                  timer: 1500,
                                  showConfirmButton: false,
                                  icon: 'success',
                                  title: 'บันทึกข้อมูลสำเร็จ'
                                })
                              }
                            } else {
                              count++
                              if (count == RequestDump.length) {
                                this.dialogLoading = false
                                this.updateRequestProject()
                                if (item.status_req != '0') {
                                  // this.sendMailApprove(staff_I, item)
                                }
                                this.$swal.fire({
                                  timer: 1500,
                                  showConfirmButton: false,
                                  icon: 'success',
                                  title: 'บันทึกข้อมูลสำเร็จ'
                                })
                              }
                            }
                          })
                        } else {
                          count++
                          if (count == RequestDump.length) {
                            this.dialogLoading = false
                            this.updateRequestProject()
                            if (item.status_req != '0') {
                              // this.sendMailApprove(staff_I, item)
                            }
                            this.$swal.fire({
                              timer: 1500,
                              showConfirmButton: false,
                              icon: 'success',
                              title: 'บันทึกข้อมูลสำเร็จ'
                            })
                          }
                        }
                      })
                    }
                  })
                })*/
              } else {
                this.dialogLoading = false
                this.$swal.fire({
                  icon: 'error',
                  title: 'พิจารณาคัดเลือกผู้สมัครเข้าร่วม อย่างน้อย 1 ท่านก่อนทำการบันทึกข้อมูล'
                })
              }
            } else {
              this.dialogLoading = false
              this.$swal.fire({
                icon: 'error',
                title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
              })
            }
          })
        }
      })
    },
    insertJoinProject(item, status) {
      const headerAxiosPUT = {
        headers: {
          'Content-Type': 'application/json',
          'X-REST-METHOD': 'PUT'
        }
      }
      const headerAxiosDEL = {
        headers: {
          'Content-Type': 'application/json',
          // 'X-REST-METHOD': 'DELETE'
        }
      }
      return new Promise(resolve => {
        var url = ''
        if (this.project.IsRoundStatus == '0') {
          url = ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/join_project/Project_code/' + this.project.Project_code + '/uid/' + item.uid + '/?sort=id_Desc&limit=1'
        } else {
          url = ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/join_project/Project_code/' + this.project.Project_code + '/uid/' + item.uid + '/D_project_round_id/' + this.project.D_project_round_id + '/?sort=id_Desc&limit=1'
        }

        if (status == '1') {
          axios.get(url, '', {
            headers: {
              'Content-Type': 'application/json',
            }
          }).then(resGet => {
            if (resGet.data) {
              if (resGet.data.active == '0') {
                axios.post(url, {
                  active: '1',
                }, headerAxiosDEL).then(resDel => {
                  if (resDel.data.status) {
                    resolve(true)
                  } else {
                    resolve(false)
                  }
                })
              } else {
                resolve(true)
              }
            } else {
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/join_project', item, headerAxiosPUT).then(res => {
                if (res.data.status) {
                  resolve(true)
                } else {
                  resolve(false)
                }
              })
            }
          })
        } else {
          axios.post(url, {
            active: '0',
          }, headerAxiosDEL).then(resDel => {
            if (resDel.data.status) {
              resolve(true)
            } else {
              resolve(false)
            }
          })
        }
      })
    },
    updateStatusReq(staff_I, item) {
      return new Promise(resolve => {
        var reqProject = this.RequestProject.filter(itemReq => itemReq.id == item.id)
        const headerAxiosPUT = {
          headers: {
            'Content-Type': 'application/json',
          }
        }
        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/request_project/id/' + item.id, {
          status_req: item.status_req,
          remark: item.remark,
          status_active: '1',
          Update_By: this.MeData[0].perid
        }, headerAxiosPUT).then(res => {
          if (res.data.status) {
            if (reqProject[0].status_req != item.status_req) {
              this.sendMailApprove(staff_I, item)
            }
            resolve(true)
          } else {
            resolve(false)
          }
        })
      })
    },
    async updateRequestProject() {
      this.JoinPerson = []
      this.RequestPerson = []

      await this.initPersonFileData({
        Project_code: this.project.Project_code
      }).catch(res => {
        if (res) {
          console.log('no files in project')
        }
      })

      this.initJoinProject({
        Project_code: this.project.Project_code
      }).then(resJoin => {
        if (resJoin) {
          if (this.project.IsRoundStatus == '0') {
            this.JoinProject.map(Join_i => {
              this.JoinPerson.unshift({
                ...Join_i,
                full_Name: Join_i.name + ' ' + Join_i.sname,
                idCard: Join_i.id_card,
                status_reg_person: '0',
                files: (this.PersonFiles.length > 0 ? this.PersonFiles.filter(itemP => itemP.Project_code == this.project.Project_code && (itemP.D_project_round_id == '' || itemP.D_project_round_id == null) && itemP.perid == Join_i.uid) : [])
              })
            })
          } else {
            var JoinDump = this.JoinProject.filter(Join_i => Join_i.D_project_round_id == this.project.id)
            if (JoinDump.length > 0) {
              JoinDump.map(Join_i => {
                this.JoinPerson.unshift({
                  ...Join_i,
                  full_Name: Join_i.name + ' ' + Join_i.sname,
                  idCard: Join_i.id_card,
                  status_reg_person: '0',
                  files: (this.PersonFiles.length > 0 ? this.PersonFiles.filter(itemP => itemP.Project_code == this.project.Project_code && itemP.perid == Join_i.uid) : [])
                })
              })
            }
          }
        }
      })

      this.initRequestProject({
        Project_code: this.project.Project_code
      }).then(res => {
        if (res) {
          var Del = false
          if (this.project.IsRoundStatus == '0') {
            if (this.RequestProject.length > 0) {
              this.staffData.map((staff_I) => {
                Del = false
                this.RequestProject.map(itemReq => {
                  if (staff_I.perid == itemReq.perid) {
                    var CheckPermissDel = []
                    if (this.Permission_Dep.length > 0) {
                      CheckPermissDel = this.Permission_Dep.filter(Dep_i => Dep_i.dep_id == staff_I.dep_id)
                    } else if(this.Permission_Dep_User.length > 0) {
                      CheckPermissDel = this.Permission_Dep_User.filter(Dep_i => Dep_i.dep_id == staff_I.dep_id)
                    }
                    if (CheckPermissDel.length > 0) {
                      Del = true
                    } else {
                      Del = false
                    }
                    this.RequestPerson.unshift({
                      ...staff_I,
                      id: itemReq.id,
                      uid: staff_I.perid,
                      name: staff_I.name,
                      sname: staff_I.surname,
                      idCard: staff_I.citizen_id,
                      affiliation: staff_I.dep_name,
                      status_req: itemReq.status_req,
                      status_active: itemReq.status_active,
                      position: '',
                      phone: '',
                      remark: itemReq.remark,
                      registerType_id: 0,
                      Del: Del,
                      files: (this.PersonFiles.length > 0 ? this.PersonFiles.filter(itemP => itemP.Project_code == this.project.Project_code && itemP.perid == staff_I.perid) : [])
                    })
                  }
                })
              })
            }
          } else {
            if (this.RequestProject.length > 0) {
              var RequestDump = this.RequestProject.filter(RequestI => RequestI.D_project_round_id == this.project.id)
              if (RequestDump.length > 0) {
                this.staffData.map((staff_I) => {
                  Del = false
                  RequestDump.map(itemReq => {
                    if (staff_I.perid == itemReq.perid) {
                      var CheckPermissDel = []
                      if (this.Permission_Dep.length > 0) {
                        CheckPermissDel = this.Permission_Dep.filter(Dep_i => Dep_i.dep_id == staff_I.dep_id)
                      } else if(this.Permission_Dep_User.length > 0) {
                        CheckPermissDel = this.Permission_Dep_User.filter(Dep_i => Dep_i.dep_id == staff_I.dep_id)
                      }
                      if (CheckPermissDel.length > 0) {
                        Del = true
                      } else {
                        Del = false
                      }
                      this.RequestPerson.unshift({
                        ...staff_I,
                        id: itemReq.id,
                        uid: staff_I.perid,
                        name: staff_I.name,
                        sname: staff_I.surname,
                        idCard: staff_I.citizen_id,
                        affiliation: staff_I.dep_name,
                        status_req: itemReq.status_req,
                        status_active: itemReq.status_active,
                        position: '',
                        phone: '',
                        remark: itemReq.remark,
                        registerType_id: 0,
                        Del: Del,
                        files: (this.PersonFiles.length > 0 ? this.PersonFiles.filter(itemP => itemP.Project_code == this.project.Project_code && itemP.perid == staff_I.perid) : [])
                      })
                    }
                  })
                })
              }
            }
          }
        }
      })
    },
    sendMailApprove(staff ,param) {
      axios.post(ConstData.ConnectionHost + '/sendMail/SendMailData.php', queryString.stringify({
        perid_admin: staff.perid,
        perid: this.MeData[0].perid,
        headerName: 'ผลการพิจารณาสมัครเข้าร่วมงาน ' + this.project.Project_name,
        header: this.project.Project_name,
        body: '<p style="font-size: 25px;color: #ff6d81;font-weight: bold">คำขอสมัครเข้าร่วมงาน ' + this.project.Project_name + ' ' + (param.status_req == '1' ? 'ถูกอนุมัติแล้ว' : 'ไม่ถูกอนุมัติ') + '</p>' +
            '<p style="margin-top: 25px;font-size: 16px;"> หมายเหตุ </p>' + param.remark + '' +
            '<hr style="margin-top: 50px;">' +
            '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
            '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>',

      }), {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
    },
    insertRegisterProject(item) {
      const headerAxiosPUT = {
        headers: {
          'Content-Type': 'application/json',
          'X-REST-METHOD': 'PUT'
        }
      }
      const headerAxios = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      return new Promise(resolve => {
        if (this.JoinPerson.length > 0) {
          axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/register_project/D_Project_Register_id/' + this.project.D_Project_Register_id + '/uid/' + item.uid, '', headerAxios).then(res => {
            if (res.data) {
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/register_project/D_Project_Register_id/' + this.project.D_Project_Register_id + '/uid/' + item.uid, {
                status_reg: item.status_reg,
                Update_By: this.MeData[0].perid
              }, headerAxios).then(res => {
                if (res.data.status) {
                  resolve(true)
                } else {
                  resolve(false)
                }
              })
            } else {
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/register_project/D_Project_Register_id/' + this.project.D_Project_Register_id + '/uid/' + item.uid, {
                uid: item.uid,
                status_reg: item.status_reg,
                D_Project_Register_id: this.project.D_Project_Register_id,
                Create_BY: this.MeData[0].perid,
                Create_Time: 'now()',
              }, headerAxiosPUT).then(res => {
                if (res.data.status) {
                  resolve(true)
                } else {
                  resolve(false)
                }
              })
            }
          })

        }
      })
    },
    UniqueArraybyId(collection, keyname) {
      var output = [],
          keys = [];

      collection.map((item) => {
        var key = item[keyname];
        if (keys.indexOf(key) === -1) {
          keys.push(key);
          output.push(item);
        }
      });
      return output;
    },
    insertPersonUni() {
      var CheckDupe = false
      var CheckPermiss = false
      if (this.PermissionAdmin.length > 0) {
        this.PermissionAdmin.map((Per_i, idx) => {
          if (Per_i.permission_id == '7001') {
            CheckPermiss = true
            this.personalMedData.map(value => {
              if (this.IdPersonal == value.STAFF_ID) {
                if (this.JoinPerson.filter(item => item.uid == value.STAFF_ID).length > 0) {
                  CheckDupe = true
                }
                if (!CheckDupe) {
                  this.JoinPerson.unshift({
                    ...value,
                    uid: value.STAFF_ID,
                    full_Name: value.STAFF_NAME_THAI + ' ' + value.STAFF_SNAME_THAI,
                    name: value.STAFF_NAME_THAI,
                    sname: value.STAFF_SNAME_THAI,
                    idCard: value.STAFF_PERS_ID,
                    affiliation: value.FAC_NAME_THAI,
                    position: '',
                    phone: '',
                    registerType_id: 2,
                  })
                  this.IdPersonal = ''
                  this.insertDataToDB({
                    Project_code: this.project.Project_code,
                    uid: value.STAFF_ID,
                    name: value.STAFF_NAME_THAI,
                    sname: value.STAFF_SNAME_THAI,
                    id_card: value.STAFF_PERS_ID,
                    affiliation: value.FAC_NAME_THAI,
                    position: '',
                    phone: '',
                    registerType_id: 2,
                    Create_By: this.MeData[0].perid,
                    Create_Time: 'now()',
                  })
                  this.$swal.fire({
                    timer: 1500,
                    showConfirmButton: false,
                    icon: 'success',
                    title: 'บันทึกข้อมูลผู้เข้าร่วม ' + value.STAFF_NAME_THAI + ' ' + value.STAFF_SNAME_THAI + ' สำเร็จ!!'
                  })
                } else {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                  })
                }
              }
            })
          } else {
            if (!CheckPermiss && idx == this.PermissionAdmin.length - 1) {
              this.$swal.fire({
                icon: 'error',
                title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
              })
            }
          }
        })
      } else {
        this.Permission.map((Per_i, idx) => {
          if (Per_i.permission_id == '7001') {
            CheckPermiss = true
            this.personalMedData.map(value => {
              if (this.IdPersonal == value.STAFF_ID) {
                if (this.JoinPerson.filter(item => item.uid == value.STAFF_ID).length > 0) {
                  CheckDupe = true
                }
                if (!CheckDupe) {
                  this.JoinPerson.unshift({
                    ...value,
                    uid: value.STAFF_ID,
                    full_Name: value.STAFF_NAME_THAI + ' ' + value.STAFF_SNAME_THAI,
                    name: value.STAFF_NAME_THAI,
                    sname: value.STAFF_SNAME_THAI,
                    idCard: value.STAFF_PERS_ID,
                    affiliation: value.FAC_NAME_THAI,
                    position: '',
                    phone: '',
                    registerType_id: 2,
                  })
                  this.IdPersonal = ''
                  this.insertDataToDB({
                    Project_code: this.project.Project_code,
                    uid: value.STAFF_ID,
                    name: value.STAFF_NAME_THAI,
                    sname: value.STAFF_SNAME_THAI,
                    id_card: value.STAFF_PERS_ID,
                    affiliation: value.FAC_NAME_THAI,
                    position: '',
                    phone: '',
                    registerType_id: 2,
                    Create_By: this.MeData[0].perid,
                    Create_Time: 'now()',
                  })
                  this.$swal.fire({
                    timer: 1500,
                    showConfirmButton: false,
                    icon: 'success',
                    title: 'บันทึกข้อมูลผู้เข้าร่วม ' + value.STAFF_NAME_THAI + ' ' + value.STAFF_SNAME_THAI + ' สำเร็จ!!'
                  })
                } else {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                  })
                }
              }
            })
          } else {
            if (!CheckPermiss && idx == this.Permission.length - 1) {
              this.$swal.fire({
                icon: 'error',
                title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
              })
            }
          }
        })
      }
    },
    insertStd(msg) {
      var CheckDupe = false
      var CheckPermiss = false
      if (this.PermissionAdmin.length > 0) {
        this.PermissionAdmin.map((Per_i, idx) => {
          if (Per_i.permission_id == '7001') {
            CheckPermiss = true
            if (msg == 'med') {
              this.studentData.map(value => {
                if (this.Idstudent == value.STUDENT_ID) {
                  if (this.JoinPerson.filter(item => item.uid == value.STUDENT_ID).length > 0) {
                    CheckDupe = true
                  }
                  if (!CheckDupe) {
                    this.JoinPerson.unshift({
                      ...value,
                      uid: value.STUDENT_ID,
                      full_Name: value.STUD_NAME_THAI + ' ' + value.STUD_SNAME_THAI,
                      name: value.STUD_NAME_THAI,
                      sname: value.STUD_SNAME_THAI,
                      idCard: value.CITIZEN_ID,
                      affiliation: 'คณะแพทยศาสตร์',
                      position: '',
                      phone: '',
                      registerType_id: 1,
                    })
                    this.Idstudent = ''
                    this.insertDataToDB({
                      Project_code: this.project.Project_code,
                      uid: value.STUDENT_ID,
                      name: value.STUD_NAME_THAI,
                      sname: value.STUD_SNAME_THAI,
                      id_card: value.CITIZEN_ID,
                      affiliation: 'คณะแพทยศาสตร์',
                      position: '',
                      phone: '',
                      registerType_id: 1,
                      Create_By: this.MeData[0].perid,
                      Create_Time: 'now()',
                    })
                    this.$swal.fire({
                      timer: 1500,
                      showConfirmButton: false,
                      icon: 'success',
                      title: 'บันทึกข้อมูลผู้เข้าร่วม ' + value.STUD_NAME_THAI + ' ' + value.STUD_SNAME_THAI + ' สำเร็จ!!'
                    })
                  } else {
                    this.$swal.fire({
                      icon: 'error',
                      title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                    })
                  }
                }
              })
            } else {
              this.studentUniData.map(value => {
                if (this.IdstudentUni == value.STUDENT_ID) {
                  if (this.JoinPerson.filter(item => item.uid == value.STUDENT_ID).length > 0) {
                    CheckDupe = true
                  }
                  if (!CheckDupe) {
                    this.JoinPerson.unshift({
                      ...value,
                      uid: value.STUDENT_ID,
                      full_Name: value.STUD_NAME_THAI + ' ' + value.STUD_SNAME_THAI,
                      name: value.STUD_NAME_THAI,
                      sname: value.STUD_SNAME_THAI,
                      idCard: value.CITIZEN_ID,
                      affiliation: value.FAC_NAME_THAI,
                      position: '',
                      phone: '',
                      registerType_id: 3,
                    })
                    this.IdstudentUni = ''
                    this.insertDataToDB({
                      Project_code: this.project.Project_code,
                      uid: value.STUDENT_ID,
                      name: value.STUD_NAME_THAI,
                      sname: value.STUD_SNAME_THAI,
                      id_card: value.CITIZEN_ID,
                      affiliation: value.FAC_NAME_THAI,
                      position: '',
                      phone: '',
                      registerType_id: 3,
                      Create_By: this.MeData[0].perid,
                      Create_Time: 'now()',
                    })
                    this.$swal.fire({
                      timer: 1500,
                      showConfirmButton: false,
                      icon: 'success',
                      title: 'บันทึกข้อมูลผู้เข้าร่วม ' + value.STUD_NAME_THAI + ' ' + value.STUD_SNAME_THAI + ' สำเร็จ!!'
                    })
                  } else {
                    this.$swal.fire({
                      icon: 'error',
                      title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                    })
                  }

                }
              })
            }
          } else {
            if (!CheckPermiss && idx == this.PermissionAdmin.length - 1) {
              this.$swal.fire({
                icon: 'error',
                title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
              })
            }
          }
        })
      } else {
        this.Permission.map((Per_i, idx) => {
          if (Per_i.permission_id == '7001') {
            CheckPermiss = true
            if (msg == 'med') {
              this.studentData.map(value => {
                if (this.Idstudent == value.STUDENT_ID) {
                  if (this.JoinPerson.filter(item => item.uid == value.STUDENT_ID).length > 0) {
                    CheckDupe = true
                  }
                  if (!CheckDupe) {
                    this.JoinPerson.unshift({
                      ...value,
                      uid: value.STUDENT_ID,
                      full_Name: value.STUD_NAME_THAI + ' ' + value.STUD_SNAME_THAI,
                      name: value.STUD_NAME_THAI,
                      sname: value.STUD_SNAME_THAI,
                      idCard: value.CITIZEN_ID,
                      affiliation: 'คณะแพทยศาสตร์',
                      position: '',
                      phone: '',
                      registerType_id: 1,
                    })
                    this.Idstudent = ''
                    this.insertDataToDB({
                      Project_code: this.project.Project_code,
                      uid: value.STUDENT_ID,
                      name: value.STUD_NAME_THAI,
                      sname: value.STUD_SNAME_THAI,
                      id_card: value.CITIZEN_ID,
                      affiliation: 'คณะแพทยศาสตร์',
                      position: '',
                      phone: '',
                      registerType_id: 1,
                      Create_By: this.MeData[0].perid,
                      Create_Time: 'now()',
                    })
                    this.$swal.fire({
                      timer: 1500,
                      showConfirmButton: false,
                      icon: 'success',
                      title: 'บันทึกข้อมูลผู้เข้าร่วม ' + value.STUD_NAME_THAI + ' ' + value.STUD_SNAME_THAI + ' สำเร็จ!!'
                    })
                  } else {
                    this.$swal.fire({
                      icon: 'error',
                      title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                    })
                  }
                }
              })
            } else {
              this.studentUniData.map(value => {
                if (this.IdstudentUni == value.STUDENT_ID) {
                  if (this.JoinPerson.filter(item => item.uid == value.STUDENT_ID).length > 0) {
                    CheckDupe = true
                  }
                  if (!CheckDupe) {
                    this.JoinPerson.unshift({
                      ...value,
                      uid: value.STUDENT_ID,
                      full_Name: value.STUD_NAME_THAI + ' ' + value.STUD_SNAME_THAI,
                      name: value.STUD_NAME_THAI,
                      sname: value.STUD_SNAME_THAI,
                      idCard: value.CITIZEN_ID,
                      affiliation: value.FAC_NAME_THAI,
                      position: '',
                      phone: '',
                      registerType_id: 3,
                    })
                    this.IdstudentUni = ''
                    this.insertDataToDB({
                      Project_code: this.project.Project_code,
                      uid: value.STUDENT_ID,
                      name: value.STUD_NAME_THAI,
                      sname: value.STUD_SNAME_THAI,
                      id_card: value.CITIZEN_ID,
                      affiliation: value.FAC_NAME_THAI,
                      position: '',
                      phone: '',
                      registerType_id: 3,
                      Create_By: this.MeData[0].perid,
                      Create_Time: 'now()',
                    })
                    this.$swal.fire({
                      timer: 1500,
                      showConfirmButton: false,
                      icon: 'success',
                      title: 'บันทึกข้อมูลผู้เข้าร่วม ' + value.STUD_NAME_THAI + ' ' + value.STUD_SNAME_THAI + ' สำเร็จ!!'
                    })
                  } else {
                    this.$swal.fire({
                      icon: 'error',
                      title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                    })
                  }

                }
              })
            }
          } else {
            if (!CheckPermiss && idx == this.Permission.length - 1) {
              this.$swal.fire({
                icon: 'error',
                title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
              })
            }
          }
        })
      }

    },
    Del_item(item) {
      this.CheckPermissFunc('7001').then(resPermiss => {
        if (resPermiss) {
          const headerAxios = {
            headers: {
              'Content-Type': 'application/json',
              // 'X-REST-METHOD': 'DELETE'
            }
          }
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/request_project/id/' + item.id, {
            active: '0'
          }, headerAxios).then(res => {
            if (res.data.status) {
              this.updateRequestProject()
              this.$swal.fire({
                timer: 1500,
                showConfirmButton: false,
                icon: 'success',
                title: 'ลบข้อมูลผู้เข้าร่วม ' + item.full_Name + ' สำเร็จ!!'
              })
            }
          })
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
          })
        }
      })
    },
    GetStdPSU() {
      this.studentUniData = []
      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/stdMed/STUDENT2_view/FAC_ID/' + this.IdDepartStd + '/?sort=STUDENT_ID_ASC&limit=99999').then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            res.data.map(item => {
              this.studentUniData.push({
                ...item,
                fullName: 'รหัสนักศึกษา : ' + item.STUDENT_ID + ' ชื่อ-สกุล ' + item.STUD_NAME_THAI + ' ' + item.STUD_SNAME_THAI
              })
            })
          } else {
            this.studentUniData.push({
              ...res.data,
              fullName: 'รหัสนักศึกษา : ' + res.data[0].STUDENT_ID + ' ชื่อ-สกุล ' + res.data[0].STUD_NAME_THAI + ' ' + res.data[0].STUD_SNAME_THAI
            })
          }
        } else {
          this.studentUniData = []
        }
      })
    },
    GetPersonalPSU() {
      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrstd/V_STAFF/FAC_ID/' + this.IdDepart + '/?sort=STAFF_ID_ASC&limit=99999').then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            res.data.map(item => {
              this.personalMedData.push({
                ...item,
                FULL_NAME: item.STAFF_NAME_THAI + ' ' + item.STAFF_SNAME_THAI
              })
            })
          } else {
            this.personalMedData.push(res.data)
          }
        } else {
          this.personalMedData = []
        }
      })
    },
    ChooseEmp(item) {
      if (!item.switch) {
        item.switch = true
        if (item.header) {
          if (item.children.length > 0) {
            item.children.map((child_i) => {
              if (item.switch) {
                child_i.switch = true
              } else {
                child_i.switch = false
              }
              this.EmpData.push(child_i)
            })
          }
        } else {
          this.EmpData.push(item)

        }
      } else {
        item.switch = false
        if (item.header) {
          this.EmpData = []
          if (item.children.length > 0) {
            item.children.map((child_i) => {
              child_i.switch = false
            })
          }
        } else {
          if (this.EmpData.length > 0) {
            this.EmpData.map((Emp_i, idx) => {
              if (Emp_i.perid == item.perid) {
                this.EmpData.splice(idx, 1)
              }
            })
          }
        }
      }
    },
    checkKeyEnter(event) {
      if (event.key == "Enter") {
        this.ChooseEmpolyee_s()
      }
    },
    checkKeyEnterOwner(event) {
      if (event.key == "Enter") {
        this.ChooseEmpolyee_s_owner()
      }
    },
    DaysInMonth(anyDateInMonth) {
      return new Date(anyDateInMonth.getFullYear(),
          anyDateInMonth.getMonth() + 1,
          0).getDate()
    },
    getAge(date_1, date_2) {
      //convert to UTC
      var arrayWorkSummary = [];
      var date2_UTC = new Date(Date.UTC(date_2.getUTCFullYear(), date_2.getUTCMonth(), date_2.getUTCDate()));
      var date1_UTC = new Date(Date.UTC(date_1.getUTCFullYear(), date_1.getUTCMonth(), date_1.getUTCDate()));


      //--------------------------------------------------------------
      var days = date2_UTC.getDate() - date1_UTC.getDate();
      if (days < 0) {

        date2_UTC.setMonth(date2_UTC.getMonth() - 1);
        days += this.DaysInMonth(date2_UTC);
      }
      //--------------------------------------------------------------
      var months = date2_UTC.getMonth() - date1_UTC.getMonth();
      if (months < 0) {
        date2_UTC.setFullYear(date2_UTC.getFullYear() - 1);
        months += 12;
      }
      //--------------------------------------------------------------
      var years = date2_UTC.getFullYear() - date1_UTC.getFullYear();

      arrayWorkSummary.push(years);
      arrayWorkSummary.push(months);
      arrayWorkSummary.push(days);

      return arrayWorkSummary;
    },
    ChooseEmpolyee_c(event) {
      var GetData = []
      var CheckDupe = false
      var checkPermiss = false
      if (this.PermissionAdmin.length > 0) {
        if (event.key == "Enter") {
          this.PermissionAdmin.map((Per_i, idx) => {
            if (Per_i.permission_id == '7001') {
              checkPermiss = true
              GetData = this.CardData.filter(value => value.CARD_NO == this.cardSel)
              if (GetData.length > 0) {
                if (this.JoinPerson.filter(item => item.uid == GetData[0].PERID).length > 0) {
                  CheckDupe = true
                }
                if (!CheckDupe) {
                  GetData = this.staffData.filter(value => value.perid == GetData[0].PERID)
                  this.JoinPerson.unshift({
                    ...GetData[0],
                    uid: GetData[0].perid,
                    name: GetData[0].name,
                    sname: GetData[0].surname,
                    idCard: GetData[0].citizen_id,
                    affiliation: GetData[0].dep_name,
                    position: '',
                    phone: '',
                    registerType_id: 0,
                  })
                  this.cardSel = ''
                  this.insertDataToDB({
                    Project_code: this.project.Project_code,
                    uid: GetData[0].perid,
                    name: GetData[0].name,
                    sname: GetData[0].surname,
                    id_card: GetData[0].citizen_id,
                    affiliation: GetData[0].dep_name,
                    position: '',
                    phone: '',
                    registerType_id: 0,
                    Create_By: this.MeData[0].perid,
                    Create_Time: 'now()',
                  })
                  this.$swal.fire({
                    timer: 1500,
                    showConfirmButton: false,
                    icon: 'success',
                    title: 'บันทึกข้อมูล ' + GetData[0].full_Name + ' รหัส (' + GetData[0].perid + ') สำเร็จ!!'
                  })
                } else {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                  })
                }

              }
            } else {
              if (!checkPermiss && idx == this.PermissionAdmin.length - 1) {
                this.$swal.fire({
                  icon: 'error',
                  title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
                })
              }
            }
          })
        }
      } else {
        if (event.key == "Enter") {
          this.Permission.map((Per_i, idx) => {
            if (Per_i.permission_id == '7001') {
              checkPermiss = true
              GetData = this.CardData.filter(value => value.CARD_NO == this.cardSel)
              if (GetData.length > 0) {
                if (this.JoinPerson.filter(item => item.uid == GetData[0].PERID).length > 0) {
                  CheckDupe = true
                }
                if (!CheckDupe) {
                  GetData = this.staffData.filter(value => value.perid == GetData[0].PERID)
                  this.JoinPerson.unshift({
                    ...GetData[0],
                    uid: GetData[0].perid,
                    name: GetData[0].name,
                    sname: GetData[0].surname,
                    idCard: GetData[0].citizen_id,
                    affiliation: GetData[0].dep_name,
                    position: '',
                    phone: '',
                    registerType_id: 0,
                  })
                  this.cardSel = ''
                  this.insertDataToDB({
                    Project_code: this.project.Project_code,
                    uid: GetData[0].perid,
                    name: GetData[0].name,
                    sname: GetData[0].surname,
                    id_card: GetData[0].citizen_id,
                    affiliation: GetData[0].dep_name,
                    position: '',
                    phone: '',
                    registerType_id: 0,
                    Create_By: this.MeData[0].perid,
                    Create_Time: 'now()',
                  })
                  this.$swal.fire({
                    icon: 'success',
                    title: 'บันทึกข้อมูล ' + GetData[0].full_Name + ' รหัส (' + GetData[0].perid + ') สำเร็จ!!'
                  })
                } else {
                  this.$swal.fire({
                    timer: 1500,
                    showConfirmButton: false,
                    icon: 'error',
                    title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                  })
                }
              }
            } else {
              if (!checkPermiss && idx == this.Permission.length - 1) {
                this.$swal.fire({
                  icon: 'error',
                  title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
                })
              }
            }
          })
        }
      }
    },
    ChooseEmpolyee_s() {
      var CheckDupe = false
      var CheckDepMatch = false
      // var CheckQuotaProject = false
      var countPerson = 0
      var CheckGroupExample = []
      if (this.project.Status_Count_Reg == '0' && this.RequestPerson.length >= parseInt(this.project.Count_Reg)) {
        this.$swal.fire({
          icon: 'error',
          title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากจำนวนผู้เข้าร่วมเกินจำนวนที่กำหนด'
        })
      } else if (this.JoinPerson.filter(item => item.uid == this.staffSel).length > 0) {
        this.$swal.fire({
          icon: 'error',
          title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากพบรายชื่อในผู้เข้าร่วมอยู่แล้ว'
        })
      } else {
        this.staffData.map((staff_I) => {
          if (staff_I.perid == this.staffSel) {
            if (this.GroupExamData.length > 0) {
              CheckGroupExample = this.GroupExamData.filter(item => item.PosCode == staff_I.pos_id && this.getAge(new Date(staff_I.date_in), new Date())[0] >= item.WSYear && this.getAge(new Date(staff_I.date_in), new Date())[0] <= item.WEYear)

              if (CheckGroupExample.length > 0) {
                if (this.DepQuotaData.length > 0) {
                  this.DepQuotaData.map((dep_quota, idx) => {
                    if (dep_quota.dep_type == '0' && !CheckDepMatch) {
                      if (staff_I.dep_id == dep_quota.dep_id) {
                        CheckDepMatch = true
                        if (this.RequestPerson.length > 0) {
                          if (this.RequestPerson.filter(item => item.dep_id == staff_I.dep_id).length < parseInt(dep_quota.count)) {
                            if (this.RequestPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                              CheckDupe = true
                            }

                            if (!CheckDupe) {
                              this.insertDataToDB({
                                Project_code: this.project.Project_code,
                                perid: staff_I.perid,
                                status_req: '0',
                                D_project_round_id: this.project.id,
                                Create_By: this.MeData[0].perid,
                                Create_Time: 'now()',
                              }).then(res => {
                                if (res.status) {
                                  this.RequestPerson.unshift({
                                    ...staff_I,
                                    id: res.data.id,
                                    uid: staff_I.perid,
                                    name: staff_I.name,
                                    sname: staff_I.surname,
                                    idCard: staff_I.citizen_id,
                                    affiliation: staff_I.dep_name,
                                    status_req: res.data.status_req,
                                    status_active: res.data.status_active,
                                    position: '',
                                    phone: '',
                                    remark: '',
                                    registerType_id: 0,
                                    Del: true,
                                    files: (this.FilePerson.length > 0 ? this.FilePerson : [])
                                  })
                                  this.staffSel = ''
                                  if (this.FilePerson.length > 0) {
                                    this.UploadFilesToDb(this.project.Project_code, (this.ProjectRound.length > 0 ? this.project.id : ''), staff_I.perid)
                                  }
                                  this.$swal.fire({
                                    timer: 1500,
                                    showConfirmButton: false,
                                    icon: 'success',
                                    title: 'บันทึกข้อมูลผู้เข้าร่วม ' + staff_I.full_Name + ' สำเร็จ!!'
                                  })
                                } else {
                                  this.$swal.fire({
                                    icon: 'error',
                                    title: 'พบข้อผืดพลาด ไม่สามารถบันทึกข้อมูลได้'
                                  })
                                }
                              })
                            } else {
                              this.staffSel = ''
                              this.$swal.fire({
                                icon: 'error',
                                title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                              })
                            }
                          } else {
                            this.staffSel = ''
                            this.$swal.fire({
                              icon: 'error',
                              title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากจำนวนผู้เข้าร่วมของหน่วยงาน ' + staff_I.dep_name + ' เกินกำหนดที่ตั้งไว้'
                            })
                          }
                        } else {
                          if (this.RequestPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                            CheckDupe = true
                          }
                          if (!CheckDupe) {
                            this.insertDataToDB({
                              Project_code: this.project.Project_code,
                              perid: staff_I.perid,
                              status_req: '0',
                              D_project_round_id: this.project.id,
                              Create_By: this.MeData[0].perid,
                              Create_Time: 'now()',
                            }).then(res => {
                              if (res.status) {
                                this.RequestPerson.unshift({
                                  ...staff_I,
                                  id: res.data.id,
                                  uid: staff_I.perid,
                                  name: staff_I.name,
                                  sname: staff_I.surname,
                                  idCard: staff_I.citizen_id,
                                  affiliation: staff_I.dep_name,
                                  status_req: res.data.status_req,
                                  status_active: res.data.status_active,
                                  position: '',
                                  phone: '',
                                  remark: '',
                                  registerType_id: 0,
                                  Del: true,
                                  files: (this.FilePerson.length > 0 ? this.FilePerson : [])
                                })
                                this.staffSel = ''
                                if (this.FilePerson.length > 0) {
                                  this.UploadFilesToDb(this.project.Project_code, (this.ProjectRound.length > 0 ? this.project.id : ''), staff_I.perid)
                                }
                                this.$swal.fire({
                                  timer: 1500,
                                  showConfirmButton: false,
                                  icon: 'success',
                                  title: 'บันทึกข้อมูลผู้เข้าร่วม ' + staff_I.full_Name + ' สำเร็จ!!'
                                })
                              } else {
                                this.$swal.fire({
                                  icon: 'error',
                                  title: 'พบข้อผืดพลาด ไม่สามารถบันทึกข้อมูลได้'
                                })
                              }
                            })
                          } else {
                            this.staffSel = ''
                            this.$swal.fire({
                              icon: 'error',
                              title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                            })
                          }
                        }
                      } else {
                        if (!CheckDepMatch && idx == this.DepQuotaData.length - 1) {
                          if (this.project.Status_Count_Reg == '1') {
                            if (this.RequestPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                              CheckDupe = true
                            }
                            if (!CheckDupe) {
                              this.insertDataToDB({
                                Project_code: this.project.Project_code,
                                perid: staff_I.perid,
                                status_req: '0',
                                D_project_round_id: this.project.id,
                                Create_By: this.MeData[0].perid,
                                Create_Time: 'now()',
                              }).then(res => {
                                if (res.status) {
                                  this.RequestPerson.unshift({
                                    ...staff_I,
                                    id: res.data.id,
                                    uid: staff_I.perid,
                                    name: staff_I.name,
                                    sname: staff_I.surname,
                                    idCard: staff_I.citizen_id,
                                    affiliation: staff_I.dep_name,
                                    status_req: res.data.status_req,
                                    status_active: res.data.status_active,
                                    position: '',
                                    phone: '',
                                    remark: '',
                                    registerType_id: 0,
                                    Del: true,
                                    files: (this.FilePerson.length > 0 ? this.FilePerson : [])
                                  })
                                  this.staffSel = ''
                                  if (this.FilePerson.length > 0) {
                                    this.UploadFilesToDb(this.project.Project_code, (this.ProjectRound.length > 0 ? this.project.id : ''), staff_I.perid)
                                  }
                                  this.$swal.fire({
                                    timer: 1500,
                                    showConfirmButton: false,
                                    icon: 'success',
                                    title: 'บันทึกข้อมูลผู้เข้าร่วม ' + staff_I.full_Name + ' สำเร็จ!!'
                                  })
                                } else {
                                  this.$swal.fire({
                                    icon: 'error',
                                    title: 'พบข้อผืดพลาด ไม่สามารถบันทึกข้อมูลได้'
                                  })
                                }
                              })
                            } else {
                              this.staffSel = ''
                              this.$swal.fire({
                                icon: 'error',
                                title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                              })
                            }
                          } else {

                            countPerson = 0
                            this.RequestPerson.map(reqP => {
                              if (dep_quota.dep_id == reqP.dep_id) {
                                countPerson++
                              }
                            })

                            if ((this.RequestPerson.length + (parseInt(this.ProjectQuotaDepCount) - countPerson)) < parseInt(this.project.Count_Reg)) {
                              if (this.RequestPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                                CheckDupe = true
                              }
                              if (!CheckDupe) {
                                this.insertDataToDB({
                                  Project_code: this.project.Project_code,
                                  perid: staff_I.perid,
                                  status_req: '0',
                                  D_project_round_id: this.project.id,
                                  Create_By: this.MeData[0].perid,
                                  Create_Time: 'now()',
                                }).then(res => {
                                  if (res.status) {
                                    this.RequestPerson.unshift({
                                      ...staff_I,
                                      id: res.data.id,
                                      uid: staff_I.perid,
                                      name: staff_I.name,
                                      sname: staff_I.surname,
                                      idCard: staff_I.citizen_id,
                                      affiliation: staff_I.dep_name,
                                      status_req: res.data.status_req,
                                      status_active: res.data.status_active,
                                      position: '',
                                      phone: '',
                                      remark: '',
                                      registerType_id: 0,
                                      Del: true,
                                      files: (this.FilePerson.length > 0 ? this.FilePerson : [])
                                    })
                                    this.staffSel = ''
                                    if (this.FilePerson.length > 0) {
                                      this.UploadFilesToDb(this.project.Project_code, (this.ProjectRound.length > 0 ? this.project.id : ''), staff_I.perid)
                                    }
                                    this.$swal.fire({
                                      timer: 1500,
                                      showConfirmButton: false,
                                      icon: 'success',
                                      title: 'บันทึกข้อมูลผู้เข้าร่วม ' + staff_I.full_Name + ' สำเร็จ!!'
                                    })
                                  } else {
                                    this.$swal.fire({
                                      icon: 'error',
                                      title: 'พบข้อผืดพลาด ไม่สามารถบันทึกข้อมูลได้'
                                    })
                                  }
                                })
                              } else {
                                this.staffSel = ''
                                this.$swal.fire({
                                  icon: 'error',
                                  title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                                })
                              }
                            } else {
                              this.staffSel = ''
                              this.$swal.fire({
                                icon: 'error',
                                title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากหมดโควต้าบุคคลกรทั่วไปที่ไม่อยู่ภายใต้เงื่อนไข'
                              })
                            }
                          }
                        }
                      }
                    } else {
                      //// ตรงนี้ต้องเช็ค
                      if (!CheckDepMatch) {
                        var DepGroup = this.depart.filter(item => item.dep_group_id == dep_quota.dep_id)
                        if (DepGroup.length > 0) {
                          if (DepGroup.filter(item => item.dep_id == staff_I.dep_id).length > 0) {
                            CheckDepMatch = true
                            if (this.RequestPerson.length > 0) {
                              if (this.RequestPerson.filter(item => item.dep_group_id == staff_I.dep_group_id).length < parseInt(dep_quota.count)) {
                                if (this.RequestPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                                  CheckDupe = true
                                }
                                if (!CheckDupe) {
                                  this.insertDataToDB({
                                    Project_code: this.project.Project_code,
                                    perid: staff_I.perid,
                                    status_req: '0',
                                    D_project_round_id: this.project.id,
                                    Create_By: this.MeData[0].perid,
                                    Create_Time: 'now()',
                                  }).then(res => {
                                    if (res.status) {
                                      this.RequestPerson.unshift({
                                        ...staff_I,
                                        id: res.data.id,
                                        uid: staff_I.perid,
                                        name: staff_I.name,
                                        sname: staff_I.surname,
                                        idCard: staff_I.citizen_id,
                                        affiliation: staff_I.dep_name,
                                        status_req: res.data.status_req,
                                        status_active: res.data.status_active,
                                        position: '',
                                        phone: '',
                                        remark: '',
                                        registerType_id: 0,
                                        Del: true,
                                        files: (this.FilePerson.length > 0 ? this.FilePerson : [])
                                      })
                                      this.staffSel = ''
                                      if (this.FilePerson.length > 0) {
                                        this.UploadFilesToDb(this.project.Project_code, (this.ProjectRound.length > 0 ? this.project.id : ''), staff_I.perid)
                                      }
                                      this.$swal.fire({
                                        timer: 1500,
                                        showConfirmButton: false,
                                        icon: 'success',
                                        title: 'บันทึกข้อมูลผู้เข้าร่วม ' + staff_I.full_Name + ' สำเร็จ!!'
                                      })
                                    } else {
                                      this.$swal.fire({
                                        icon: 'error',
                                        title: 'พบข้อผืดพลาด ไม่สามารถบันทึกข้อมูลได้'
                                      })
                                    }
                                  })
                                } else {
                                  this.staffSel = ''
                                  this.$swal.fire({
                                    icon: 'error',
                                    title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                                  })
                                }
                              } else {
                                this.staffSel = ''
                                this.$swal.fire({
                                  icon: 'error',
                                  title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากจำนวนผู้เข้าร่วมของ(กลุ่มหน่วยงาน/กลุ่มภาควิชา) ' + staff_I.dep_name + ' เกินกำหนดที่ตั้งไว้'
                                })
                              }
                            } else {
                              this.insertDataToDB({
                                Project_code: this.project.Project_code,
                                perid: staff_I.perid,
                                status_req: '0',
                                D_project_round_id: this.project.id,
                                Create_By: this.MeData[0].perid,
                                Create_Time: 'now()',
                              }).then(res => {
                                if (res.status) {
                                  this.RequestPerson.unshift({
                                    ...staff_I,
                                    id: res.data.id,
                                    uid: staff_I.perid,
                                    name: staff_I.name,
                                    sname: staff_I.surname,
                                    idCard: staff_I.citizen_id,
                                    affiliation: staff_I.dep_name,
                                    status_req: res.data.status_req,
                                    status_active: res.data.status_active,
                                    position: '',
                                    phone: '',
                                    remark: '',
                                    registerType_id: 0,
                                    Del: true,
                                    files: (this.FilePerson.length > 0 ? this.FilePerson : [])
                                  })
                                  this.staffSel = ''
                                  if (this.FilePerson.length > 0) {
                                    this.UploadFilesToDb(this.project.Project_code, (this.ProjectRound.length > 0 ? this.project.id : ''), staff_I.perid)
                                  }
                                  this.$swal.fire({
                                    timer: 1500,
                                    showConfirmButton: false,
                                    icon: 'success',
                                    title: 'บันทึกข้อมูลผู้เข้าร่วม ' + staff_I.full_Name + ' สำเร็จ!!'
                                  })
                                } else {
                                  this.$swal.fire({
                                    icon: 'error',
                                    title: 'พบข้อผืดพลาด ไม่สามารถบันทึกข้อมูลได้'
                                  })
                                }
                              })
                            }
                          } else {
                            if (!CheckDepMatch && idx == this.DepQuotaData.length - 1) {
                              countPerson = 0
                              this.RequestPerson.map(reqP => {
                                if (DepGroup.filter(item => item.dep_id == reqP.dep_id).length > 0) {
                                  countPerson++
                                }
                              })

                              if ((this.RequestPerson.length + (parseInt(this.ProjectQuotaDepCount) - countPerson)) < parseInt(this.project.Count_Reg)) {
                                if (this.RequestPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                                  CheckDupe = true
                                }
                                if (!CheckDupe) {
                                  this.insertDataToDB({
                                    Project_code: this.project.Project_code,
                                    perid: staff_I.perid,
                                    status_req: '0',
                                    D_project_round_id: this.project.id,
                                    Create_By: this.MeData[0].perid,
                                    Create_Time: 'now()',
                                  }).then(res => {
                                    if (res.status) {
                                      this.RequestPerson.unshift({
                                        ...staff_I,
                                        id: res.data.id,
                                        uid: staff_I.perid,
                                        name: staff_I.name,
                                        sname: staff_I.surname,
                                        idCard: staff_I.citizen_id,
                                        affiliation: staff_I.dep_name,
                                        status_req: res.data.status_req,
                                        status_active: res.data.status_active,
                                        position: '',
                                        phone: '',
                                        remark: '',
                                        registerType_id: 0,
                                        Del: true,
                                        files: (this.FilePerson.length > 0 ? this.FilePerson : [])
                                      })
                                      this.staffSel = ''
                                      if (this.FilePerson.length > 0) {
                                        this.UploadFilesToDb(this.project.Project_code, (this.ProjectRound.length > 0 ? this.project.id : ''), staff_I.perid)
                                      }
                                      this.$swal.fire({
                                        timer: 1500,
                                        showConfirmButton: false,
                                        icon: 'success',
                                        title: 'บันทึกข้อมูลผู้เข้าร่วม ' + staff_I.full_Name + ' สำเร็จ!!'
                                      })
                                    } else {
                                      this.$swal.fire({
                                        icon: 'error',
                                        title: 'พบข้อผืดพลาด ไม่สามารถบันทึกข้อมูลได้'
                                      })
                                    }
                                  })
                                } else {
                                  this.staffSel = ''
                                  this.$swal.fire({
                                    icon: 'error',
                                    title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                                  })
                                }
                              } else {
                                this.staffSel = ''
                                this.$swal.fire({
                                  icon: 'error',
                                  title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากหมดโควต้าบุคคลกรทั่วไปที่ไม่อยู่ภายใต้เงื่อนไข'
                                })
                              }
                            }
                          }
                        }
                      }
                    }
                  })
                } else {
                  if (this.RequestPerson.length < parseInt(this.project.Count_Reg)) {
                    if (this.RequestPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                      CheckDupe = true
                    }
                    if (!CheckDupe) {
                      this.insertDataToDB({
                        Project_code: this.project.Project_code,
                        perid: staff_I.perid,
                        status_req: '0',
                        D_project_round_id: this.project.id,
                        Create_By: this.MeData[0].perid,
                        Create_Time: 'now()',
                      }).then(res => {
                        if (res.status) {
                          this.RequestPerson.unshift({
                            ...staff_I,
                            id: res.data.id,
                            uid: staff_I.perid,
                            name: staff_I.name,
                            sname: staff_I.surname,
                            idCard: staff_I.citizen_id,
                            affiliation: staff_I.dep_name,
                            status_req: res.data.status_req,
                            status_active: res.data.status_active,
                            position: '',
                            phone: '',
                            remark: '',
                            registerType_id: 0,
                            Del: true,
                            files: (this.FilePerson.length > 0 ? this.FilePerson : [])
                          })
                          this.staffSel = ''
                          if (this.FilePerson.length > 0) {
                            this.UploadFilesToDb(this.project.Project_code, (this.ProjectRound.length > 0 ? this.project.id : ''), staff_I.perid)
                          }
                          this.$swal.fire({
                            timer: 1500,
                            showConfirmButton: false,
                            icon: 'success',
                            title: 'บันทึกข้อมูลผู้เข้าร่วม ' + staff_I.full_Name + ' สำเร็จ!!'
                          })
                        } else {
                          this.$swal.fire({
                            icon: 'error',
                            title: 'พบข้อผืดพลาด ไม่สามารถบันทึกข้อมูลได้'
                          })
                        }
                      })
                    } else {
                      this.staffSel = ''
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                      })
                    }
                  } else {
                    this.staffSel = ''
                    this.$swal.fire({
                      icon: 'error',
                      title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากจำนวนผู้เข้าร่วมเกินจำนวนที่กำหนด'
                    })
                  }
                }
              } else {
                this.$swal.fire({
                  icon: 'error',
                  title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากเงื่อนไขอายุงานกลุ่มตัวอย่าง ไม่ตรงกับอายุงานของบุคลากรที่เลือก'
                })
              }
            } else if (this.DepQuotaData.length > 0) {
              this.DepQuotaData.map((dep_quota, idx) => {
                if (dep_quota.dep_type == '0' && !CheckDepMatch) {
                  if (staff_I.dep_id == dep_quota.dep_id) {
                    CheckDepMatch = true
                    if (this.RequestPerson.length > 0) {
                      if (this.RequestPerson.filter(item => item.dep_id == staff_I.dep_id).length < parseInt(dep_quota.count)) {
                        if (this.RequestPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                          CheckDupe = true
                        }

                        if (!CheckDupe) {
                          this.insertDataToDB({
                            Project_code: this.project.Project_code,
                            perid: staff_I.perid,
                            status_req: '0',
                            D_project_round_id: this.project.id,
                            Create_By: this.MeData[0].perid,
                            Create_Time: 'now()',
                          }).then(res => {
                            if (res.status) {
                              this.RequestPerson.unshift({
                                ...staff_I,
                                id: res.data.id,
                                uid: staff_I.perid,
                                name: staff_I.name,
                                sname: staff_I.surname,
                                idCard: staff_I.citizen_id,
                                affiliation: staff_I.dep_name,
                                status_req: res.data.status_req,
                                status_active: res.data.status_active,
                                position: '',
                                phone: '',
                                remark: '',
                                registerType_id: 0,
                                Del: true,
                                files: (this.FilePerson.length > 0 ? this.FilePerson : [])
                              })
                              this.staffSel = ''
                              if (this.FilePerson.length > 0) {
                                this.UploadFilesToDb(this.project.Project_code, (this.ProjectRound.length > 0 ? this.project.id : ''), staff_I.perid)
                              }
                              this.$swal.fire({
                                timer: 1500,
                                showConfirmButton: false,
                                icon: 'success',
                                title: 'บันทึกข้อมูลผู้เข้าร่วม ' + staff_I.full_Name + ' สำเร็จ!!'
                              })
                            } else {
                              this.$swal.fire({
                                icon: 'error',
                                title: 'พบข้อผืดพลาด ไม่สามารถบันทึกข้อมูลได้'
                              })
                            }
                          })
                        } else {
                          this.staffSel = ''
                          this.$swal.fire({
                            icon: 'error',
                            title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                          })
                        }
                      } else {
                        this.staffSel = ''
                        this.$swal.fire({
                          icon: 'error',
                          title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากจำนวนผู้เข้าร่วมของหน่วยงาน ' + staff_I.dep_name + ' เกินกำหนดที่ตั้งไว้'
                        })
                      }
                    } else {
                      if (this.RequestPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                        CheckDupe = true
                      }
                      if (!CheckDupe) {
                        this.insertDataToDB({
                          Project_code: this.project.Project_code,
                          perid: staff_I.perid,
                          status_req: '0',
                          D_project_round_id: this.project.id,
                          Create_By: this.MeData[0].perid,
                          Create_Time: 'now()',
                        }).then(res => {
                          if (res.status) {
                            this.RequestPerson.unshift({
                              ...staff_I,
                              id: res.data.id,
                              uid: staff_I.perid,
                              name: staff_I.name,
                              sname: staff_I.surname,
                              idCard: staff_I.citizen_id,
                              affiliation: staff_I.dep_name,
                              status_req: res.data.status_req,
                              status_active: res.data.status_active,
                              position: '',
                              phone: '',
                              remark: '',
                              registerType_id: 0,
                              Del: true,
                              files: (this.FilePerson.length > 0 ? this.FilePerson : [])
                            })
                            this.staffSel = ''
                            if (this.FilePerson.length > 0) {
                              this.UploadFilesToDb(this.project.Project_code, (this.ProjectRound.length > 0 ? this.project.id : ''), staff_I.perid)
                            }
                            this.$swal.fire({
                              timer: 1500,
                              showConfirmButton: false,
                              icon: 'success',
                              title: 'บันทึกข้อมูลผู้เข้าร่วม ' + staff_I.full_Name + ' สำเร็จ!!'
                            })
                          } else {
                            this.$swal.fire({
                              icon: 'error',
                              title: 'พบข้อผืดพลาด ไม่สามารถบันทึกข้อมูลได้'
                            })
                          }
                        })
                      } else {
                        this.staffSel = ''
                        this.$swal.fire({
                          icon: 'error',
                          title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                        })
                      }
                    }
                  } else {
                    if (!CheckDepMatch && idx == this.DepQuotaData.length - 1) {
                      if (this.project.Status_Count_Reg == '1') {
                        if (this.RequestPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                          CheckDupe = true
                        }
                        if (!CheckDupe) {
                          this.insertDataToDB({
                            Project_code: this.project.Project_code,
                            perid: staff_I.perid,
                            status_req: '0',
                            D_project_round_id: this.project.id,
                            Create_By: this.MeData[0].perid,
                            Create_Time: 'now()',
                          }).then(res => {
                            if (res.status) {
                              this.RequestPerson.unshift({
                                ...staff_I,
                                id: res.data.id,
                                uid: staff_I.perid,
                                name: staff_I.name,
                                sname: staff_I.surname,
                                idCard: staff_I.citizen_id,
                                affiliation: staff_I.dep_name,
                                status_req: res.data.status_req,
                                status_active: res.data.status_active,
                                position: '',
                                phone: '',
                                remark: '',
                                registerType_id: 0,
                                Del: true,
                                files: (this.FilePerson.length > 0 ? this.FilePerson : [])
                              })
                              this.staffSel = ''
                              if (this.FilePerson.length > 0) {
                                this.UploadFilesToDb(this.project.Project_code, (this.ProjectRound.length > 0 ? this.project.id : ''), staff_I.perid)
                              }
                              this.$swal.fire({
                                timer: 1500,
                                showConfirmButton: false,
                                icon: 'success',
                                title: 'บันทึกข้อมูลผู้เข้าร่วม ' + staff_I.full_Name + ' สำเร็จ!!'
                              })
                            } else {
                              this.$swal.fire({
                                icon: 'error',
                                title: 'พบข้อผืดพลาด ไม่สามารถบันทึกข้อมูลได้'
                              })
                            }
                          })
                        } else {
                          this.staffSel = ''
                          this.$swal.fire({
                            icon: 'error',
                            title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                          })
                        }
                      } else {

                        countPerson = 0
                        this.RequestPerson.map(reqP => {
                          if (dep_quota.dep_id == reqP.dep_id) {
                            countPerson++
                          }
                        })

                        if ((this.RequestPerson.length + (parseInt(this.ProjectQuotaDepCount) - countPerson)) < parseInt(this.project.Count_Reg)) {
                          if (this.RequestPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                            CheckDupe = true
                          }
                          if (!CheckDupe) {
                            this.insertDataToDB({
                              Project_code: this.project.Project_code,
                              perid: staff_I.perid,
                              status_req: '0',
                              D_project_round_id: this.project.id,
                              Create_By: this.MeData[0].perid,
                              Create_Time: 'now()',
                            }).then(res => {
                              if (res.status) {
                                this.RequestPerson.unshift({
                                  ...staff_I,
                                  id: res.data.id,
                                  uid: staff_I.perid,
                                  name: staff_I.name,
                                  sname: staff_I.surname,
                                  idCard: staff_I.citizen_id,
                                  affiliation: staff_I.dep_name,
                                  status_req: res.data.status_req,
                                  status_active: res.data.status_active,
                                  position: '',
                                  phone: '',
                                  remark: '',
                                  registerType_id: 0,
                                  Del: true,
                                  files: (this.FilePerson.length > 0 ? this.FilePerson : [])
                                })
                                this.staffSel = ''
                                if (this.FilePerson.length > 0) {
                                  this.UploadFilesToDb(this.project.Project_code, (this.ProjectRound.length > 0 ? this.project.id : ''), staff_I.perid)
                                }
                                this.$swal.fire({
                                  timer: 1500,
                                  showConfirmButton: false,
                                  icon: 'success',
                                  title: 'บันทึกข้อมูลผู้เข้าร่วม ' + staff_I.full_Name + ' สำเร็จ!!'
                                })
                              } else {
                                this.$swal.fire({
                                  icon: 'error',
                                  title: 'พบข้อผืดพลาด ไม่สามารถบันทึกข้อมูลได้'
                                })
                              }
                            })
                          } else {
                            this.staffSel = ''
                            this.$swal.fire({
                              icon: 'error',
                              title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                            })
                          }
                        } else {
                          this.staffSel = ''
                          this.$swal.fire({
                            icon: 'error',
                            title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากหมดโควต้าบุคคลกรทั่วไปที่ไม่อยู่ภายใต้เงื่อนไข'
                          })
                        }
                      }
                    }
                  }
                } else {
                  //// ตรงนี้ต้องเช็ค
                  if (!CheckDepMatch) {
                    var DepGroup = this.depart.filter(item => item.dep_group_id == dep_quota.dep_id)
                    if (DepGroup.length > 0) {
                      if (DepGroup.filter(item => item.dep_id == staff_I.dep_id).length > 0) {
                        CheckDepMatch = true
                        if (this.RequestPerson.length > 0) {
                          if (this.RequestPerson.filter(item => item.dep_group_id == staff_I.dep_group_id).length < parseInt(dep_quota.count)) {
                            if (this.RequestPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                              CheckDupe = true
                            }
                            if (!CheckDupe) {
                              this.insertDataToDB({
                                Project_code: this.project.Project_code,
                                perid: staff_I.perid,
                                status_req: '0',
                                D_project_round_id: this.project.id,
                                Create_By: this.MeData[0].perid,
                                Create_Time: 'now()',
                              }).then(res => {
                                if (res.status) {
                                  this.RequestPerson.unshift({
                                    ...staff_I,
                                    id: res.data.id,
                                    uid: staff_I.perid,
                                    name: staff_I.name,
                                    sname: staff_I.surname,
                                    idCard: staff_I.citizen_id,
                                    affiliation: staff_I.dep_name,
                                    status_req: res.data.status_req,
                                    status_active: res.data.status_active,
                                    position: '',
                                    phone: '',
                                    remark: '',
                                    registerType_id: 0,
                                    Del: true,
                                    files: (this.FilePerson.length > 0 ? this.FilePerson : [])
                                  })
                                  this.staffSel = ''
                                  if (this.FilePerson.length > 0) {
                                    this.UploadFilesToDb(this.project.Project_code, (this.ProjectRound.length > 0 ? this.project.id : ''), staff_I.perid)
                                  }
                                  this.$swal.fire({
                                    timer: 1500,
                                    showConfirmButton: false,
                                    icon: 'success',
                                    title: 'บันทึกข้อมูลผู้เข้าร่วม ' + staff_I.full_Name + ' สำเร็จ!!'
                                  })
                                } else {
                                  this.$swal.fire({
                                    icon: 'error',
                                    title: 'พบข้อผืดพลาด ไม่สามารถบันทึกข้อมูลได้'
                                  })
                                }
                              })
                            } else {
                              this.staffSel = ''
                              this.$swal.fire({
                                icon: 'error',
                                title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                              })
                            }
                          } else {
                            this.staffSel = ''
                            this.$swal.fire({
                              icon: 'error',
                              title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากจำนวนผู้เข้าร่วมของ(กลุ่มหน่วยงาน/กลุ่มภาควิชา) ' + staff_I.dep_name + ' เกินกำหนดที่ตั้งไว้'
                            })
                          }
                        } else {
                          this.insertDataToDB({
                            Project_code: this.project.Project_code,
                            perid: staff_I.perid,
                            status_req: '0',
                            D_project_round_id: this.project.id,
                            Create_By: this.MeData[0].perid,
                            Create_Time: 'now()',
                          }).then(res => {
                            if (res.status) {
                              this.RequestPerson.unshift({
                                ...staff_I,
                                id: res.data.id,
                                uid: staff_I.perid,
                                name: staff_I.name,
                                sname: staff_I.surname,
                                idCard: staff_I.citizen_id,
                                affiliation: staff_I.dep_name,
                                status_req: res.data.status_req,
                                status_active: res.data.status_active,
                                position: '',
                                phone: '',
                                remark: '',
                                registerType_id: 0,
                                Del: true,
                                files: (this.FilePerson.length > 0 ? this.FilePerson : [])
                              })
                              this.staffSel = ''
                              if (this.FilePerson.length > 0) {
                                this.UploadFilesToDb(this.project.Project_code, (this.ProjectRound.length > 0 ? this.project.id : ''), staff_I.perid)
                              }
                              this.$swal.fire({
                                timer: 1500,
                                showConfirmButton: false,
                                icon: 'success',
                                title: 'บันทึกข้อมูลผู้เข้าร่วม ' + staff_I.full_Name + ' สำเร็จ!!'
                              })
                            } else {
                              this.$swal.fire({
                                icon: 'error',
                                title: 'พบข้อผืดพลาด ไม่สามารถบันทึกข้อมูลได้'
                              })
                            }
                          })
                        }
                      } else {
                        if (!CheckDepMatch && idx == this.DepQuotaData.length - 1) {
                          countPerson = 0
                          this.RequestPerson.map(reqP => {
                            if (DepGroup.filter(item => item.dep_id == reqP.dep_id).length > 0) {
                              countPerson++
                            }
                          })

                          if ((this.RequestPerson.length + (parseInt(this.ProjectQuotaDepCount) - countPerson)) < parseInt(this.project.Count_Reg)) {
                            if (this.RequestPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                              CheckDupe = true
                            }
                            if (!CheckDupe) {
                              this.insertDataToDB({
                                Project_code: this.project.Project_code,
                                perid: staff_I.perid,
                                status_req: '0',
                                D_project_round_id: this.project.id,
                                Create_By: this.MeData[0].perid,
                                Create_Time: 'now()',
                              }).then(res => {
                                if (res.status) {
                                  this.RequestPerson.unshift({
                                    ...staff_I,
                                    id: res.data.id,
                                    uid: staff_I.perid,
                                    name: staff_I.name,
                                    sname: staff_I.surname,
                                    idCard: staff_I.citizen_id,
                                    affiliation: staff_I.dep_name,
                                    status_req: res.data.status_req,
                                    status_active: res.data.status_active,
                                    position: '',
                                    phone: '',
                                    remark: '',
                                    registerType_id: 0,
                                    Del: true,
                                    files: (this.FilePerson.length > 0 ? this.FilePerson : [])
                                  })
                                  this.staffSel = ''
                                  if (this.FilePerson.length > 0) {
                                    this.UploadFilesToDb(this.project.Project_code, (this.ProjectRound.length > 0 ? this.project.id : ''), staff_I.perid)
                                  }
                                  this.$swal.fire({
                                    timer: 1500,
                                    showConfirmButton: false,
                                    icon: 'success',
                                    title: 'บันทึกข้อมูลผู้เข้าร่วม ' + staff_I.full_Name + ' สำเร็จ!!'
                                  })
                                } else {
                                  this.$swal.fire({
                                    icon: 'error',
                                    title: 'พบข้อผืดพลาด ไม่สามารถบันทึกข้อมูลได้'
                                  })
                                }
                              })
                            } else {
                              this.staffSel = ''
                              this.$swal.fire({
                                icon: 'error',
                                title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                              })
                            }
                          } else {
                            this.staffSel = ''
                            this.$swal.fire({
                              icon: 'error',
                              title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากหมดโควต้าบุคคลกรทั่วไปที่ไม่อยู่ภายใต้เงื่อนไข'
                            })
                          }
                        }
                      }
                    }
                  }
                }
              })
            } else {
              if (this.RequestPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                CheckDupe = true
              }
              if (!CheckDupe) {
                this.insertDataToDB({
                  Project_code: this.project.Project_code,
                  perid: staff_I.perid,
                  status_req: '0',
                  D_project_round_id: this.project.id,
                  Create_By: this.MeData[0].perid,
                  Create_Time: 'now()',
                }).then(res => {
                  if (res.status) {
                    this.RequestPerson.unshift({
                      ...staff_I,
                      id: res.data.id,
                      uid: staff_I.perid,
                      name: staff_I.name,
                      sname: staff_I.surname,
                      idCard: staff_I.citizen_id,
                      affiliation: staff_I.dep_name,
                      status_req: res.data.status_req,
                      status_active: res.data.status_active,
                      position: '',
                      phone: '',
                      remark: '',
                      registerType_id: 0,
                      Del: true,
                      files: (this.FilePerson.length > 0 ? this.FilePerson : [])
                    })
                    this.staffSel = ''
                    if (this.FilePerson.length > 0) {
                      this.UploadFilesToDb(this.project.Project_code, (this.ProjectRound.length > 0 ? this.project.id : ''), staff_I.perid)
                    }
                    this.$swal.fire({
                      timer: 1500,
                      showConfirmButton: false,
                      icon: 'success',
                      title: 'บันทึกข้อมูลผู้เข้าร่วม ' + staff_I.full_Name + ' สำเร็จ!!'
                    })
                  } else {
                    this.$swal.fire({
                      icon: 'error',
                      title: 'พบข้อผืดพลาด ไม่สามารถบันทึกข้อมูลได้'
                    })
                  }
                })
              } else {
                this.staffSel = ''
                this.$swal.fire({
                  icon: 'error',
                  title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                })
              }
            }
          }
        })
      }
    },
    ChooseEmpolyee_s_owner() {
      var CheckDupe = false
      this.CheckPermissFunc('7001').then(resPermiss => {
        if (resPermiss) {
          if (this.JoinPerson.filter(item => item.uid == this.staffSel).length > 0) {
            this.$swal.fire({
              icon: 'error',
              title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากพบรายชื่อในผู้เข้าร่วมอยู่แล้ว'
            })
          } else {
            this.staffData.map((staff_I) => {
              if (staff_I.perid == this.staffSel) {
                if (this.RequestPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                  CheckDupe = true
                }
                if (!CheckDupe) {
                  this.insertDataToDB({
                    Project_code: this.project.Project_code,
                    perid: staff_I.perid,
                    status_req: '0',
                    D_project_round_id: this.project.id,
                    Create_By: this.MeData[0].perid,
                    Create_Time: 'now()',
                  }).then(res => {
                    if (res.status) {
                      this.RequestPerson.unshift({
                        ...staff_I,
                        id: res.data.id,
                        uid: staff_I.perid,
                        name: staff_I.name,
                        sname: staff_I.surname,
                        idCard: staff_I.citizen_id,
                        affiliation: staff_I.dep_name,
                        status_req: res.data.status_req,
                        status_active: res.data.status_active,
                        position: '',
                        phone: '',
                        remark: '',
                        registerType_id: 0,
                        Del: true,
                        files: (this.FilePerson.length > 0 ? this.FilePerson : [])
                      })
                      this.staffSel = ''
                      if (this.FilePerson.length > 0) {
                        this.UploadFilesToDb(this.project.Project_code, (this.ProjectRound.length > 0 ? this.project.id : ''), staff_I.perid)
                      }
                      this.$swal.fire({
                        timer: 1500,
                        showConfirmButton: false,
                        icon: 'success',
                        title: 'บันทึกข้อมูลผู้เข้าร่วม ' + staff_I.full_Name + ' สำเร็จ!!'
                      })
                    } else {
                      this.$swal.fire({
                        icon: 'error',
                        title: 'พบข้อผืดพลาด ไม่สามารถบันทึกข้อมูลได้'
                      })
                    }
                  })
                } else {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                  })
                }
              }
            })
          }
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
          })
        }
      })
    },
    ChooseEmpolyee() {
      this.items = []
      this.AutoMateitems()
    },
    AutoMateitems() {
      var children = []
      if (this.depart.length > 0) {
        this.depart.map((depart_i) => {
          if (depart_i.dep_id == this.departSel) {
            if (this.staffData.length > 0) {
              this.staffData.map((staff_i, idx) => {
                if (staff_i.dep_id == this.departSel) {
                  children.push(
                      {
                        ...staff_i,
                        header: false,
                        switch: false,
                        id: parseInt(idx + 1),
                        name: staff_i.full_Name
                      })
                }
              })
            }
            children.sort((a, b) => {
              return a.perid > b.perid ? 1 : -1
            })
            this.items = [{
              id: 1,
              name: depart_i.dep_name,
              header: true,
              switch: false,
              children,
            }]
          }
        })
      }
    },
    UploadFilesToDb(Project_code, Round_id, perid) {
      var countFilePerson = 0
      this.FilePerson.map((item) => {
        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Person_files', {
          Project_code: Project_code,
          D_project_round_id: Round_id,
          perid: perid,
          File_name: item.name,
          File_path: item.path,
          File_type: item.type_Img,
          Create_By: this.MeData[0].perid,
          Create_Time: 'now()',
        }, {
          headers: {
            'Content-Type': 'application/json',
            'X-REST-METHOD': 'PUT'
          }
        }).then(res => {
          if (res.data.status) {
            countFilePerson++
            if (countFilePerson == this.FilePerson.length) {
              this.FilePerson = []
              this.filesP = []
              this.txtAlertP = []
              this.alertP = false
            }
          }
        })
      })
    },
    insertDataPerson(type) {
      var CheckDupe = false
      var CheckPermiss = false
      if (this.PermissionAdmin.length > 0) {
        this.PermissionAdmin.map((Per_i, idx) => {
          if (Per_i.permission_id == '7001') {
            CheckPermiss = true
            if (type == 'person') {
              if (this.JoinPerson.filter(item => item.uid == ('P_' + this.JoinPerson.length)).length > 0) {
                CheckDupe = true
              }
              if (!CheckDupe) {
                this.JoinPerson.unshift({
                  uid: 'P_' + this.JoinPerson.length,
                  full_Name: this.NameP + ' ' + this.SurNameP,
                  name: this.NameP,
                  sname: this.SurNameP,
                  idCard: this.idCard,
                  affiliation: this.affiliation,
                  position: this.position,
                  phone: this.phoneOther,
                  registerType_id: 4,
                })
                this.insertDataToDB({
                  Project_code: this.project.Project_code,
                  uid: 'P_' + this.JoinPerson.length,
                  name: this.NameP,
                  sname: this.SurNameP,
                  id_card: this.idCard,
                  affiliation: this.affiliation,
                  position: this.position,
                  phone: this.phoneOther,
                  registerType_id: 4,
                  Create_By: this.MeData[0].perid,
                  Create_Time: 'now()',
                })
                this.$swal.fire({
                  timer: 1500,
                  showConfirmButton: false,
                  icon: 'success',
                  title: 'บันทึกข้อมูลผู้เข้าร่วม ' + this.NameP + ' ' + this.SurNameP + ' สำเร็จ!!'
                })
                this.NameP = ''
                this.SurNameP = ''
                this.idCard = ''
                this.affiliation = ''
                this.position = ''
                this.phoneOther = ''
              } else {
                this.$swal.fire({
                  icon: 'error',
                  title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                })
              }
            } else {
              if (this.JoinPerson.filter(item => item.uid == ('S_' + this.JoinPerson.length)).length > 0) {
                CheckDupe = true
              }
              if (!CheckDupe) {
                this.JoinPerson.unshift({
                  uid: 'S_' + this.JoinPerson.length,
                  full_Name: this.NameStd + ' ' + this.SurNameStd,
                  name: this.NameStd,
                  sname: this.SurNameStd,
                  idCard: this.idCardStd,
                  affiliation: this.affiliationStd,
                  position: '',
                  phone: this.phoneOther,
                  registerType_id: 5,
                })
                this.insertDataToDB({
                  Project_code: this.project.Project_code,
                  uid: 'S_' + this.JoinPerson.length,
                  name: this.NameStd,
                  sname: this.SurNameStd,
                  id_card: this.idCardStd,
                  affiliation: this.affiliationStd,
                  position: '',
                  phone: this.phoneOther,
                  registerType_id: 5,
                  Create_By: this.MeData[0].perid,
                  Create_Time: 'now()',
                })
                this.$swal.fire({
                  timer: 1500,
                  showConfirmButton: false,
                  icon: 'success',
                  title: 'บันทึกข้อมูลผู้เข้าร่วม ' + this.NameStd + ' ' + this.SurNameStd + ' สำเร็จ!!'
                })
                this.NameStd = ''
                this.SurNameStd = ''
                this.idCardStd = ''
                this.affiliationStd = ''
                this.phoneOther = ''
              } else {
                this.$swal.fire({
                  icon: 'error',
                  title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                })
              }

            }
          } else {
            if (!CheckPermiss && idx == this.PermissionAdmin.length - 1) {
              this.$swal.fire({
                icon: 'error',
                title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
              })
            }
          }
        })
      } else {
        this.Permission.map((Per_i, idx) => {
          if (Per_i.permission_id == '7001') {
            CheckPermiss = true
            if (type == 'person') {
              if (this.JoinPerson.filter(item => item.uid == ('P_' + this.JoinPerson.length)).length > 0) {
                CheckDupe = true
              }
              if (!CheckDupe) {
                this.JoinPerson.unshift({
                  uid: 'P_' + this.JoinPerson.length,
                  full_Name: this.NameP + ' ' + this.SurNameP,
                  name: this.NameP,
                  sname: this.SurNameP,
                  idCard: this.idCard,
                  affiliation: this.affiliation,
                  position: this.position,
                  phone: this.phoneOther,
                  registerType_id: 4,
                })
                this.insertDataToDB({
                  Project_code: this.project.Project_code,
                  uid: 'P_' + this.JoinPerson.length,
                  name: this.NameP,
                  sname: this.SurNameP,
                  id_card: this.idCard,
                  affiliation: this.affiliation,
                  position: this.position,
                  phone: this.phoneOther,
                  registerType_id: 4,
                  Create_By: this.MeData[0].perid,
                  Create_Time: 'now()',
                })
                this.$swal.fire({
                  timer: 1500,
                  showConfirmButton: false,
                  icon: 'success',
                  title: 'บันทึกข้อมูลผู้เข้าร่วม ' + this.NameP + ' ' + this.SurNameP + ' สำเร็จ!!'
                })
                this.NameP = ''
                this.SurNameP = ''
                this.idCard = ''
                this.affiliation = ''
                this.position = ''
                this.phoneOther = ''
              } else {
                this.$swal.fire({
                  icon: 'error',
                  title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                })
              }
            } else {
              if (this.JoinPerson.filter(item => item.uid == ('S_' + this.JoinPerson.length)).length > 0) {
                CheckDupe = true
              }
              if (!CheckDupe) {
                this.JoinPerson.unshift({
                  uid: 'S_' + this.JoinPerson.length,
                  full_Name: this.NameStd + ' ' + this.SurNameStd,
                  name: this.NameStd,
                  sname: this.SurNameStd,
                  idCard: this.idCardStd,
                  affiliation: this.affiliationStd,
                  position: '',
                  phone: this.phoneOther,
                  registerType_id: 5,
                })
                this.insertDataToDB({
                  Project_code: this.project.Project_code,
                  uid: 'S_' + this.JoinPerson.length,
                  name: this.NameStd,
                  sname: this.SurNameStd,
                  id_card: this.idCardStd,
                  affiliation: this.affiliationStd,
                  position: '',
                  phone: this.phoneOther,
                  registerType_id: 5,
                  Create_By: this.MeData[0].perid,
                  Create_Time: 'now()',
                })
                this.$swal.fire({
                  timer: 1500,
                  showConfirmButton: false,
                  icon: 'success',
                  title: 'บันทึกข้อมูลผู้เข้าร่วม ' + this.NameStd + ' ' + this.SurNameStd + ' สำเร็จ!!'
                })
                this.NameStd = ''
                this.SurNameStd = ''
                this.idCardStd = ''
                this.affiliationStd = ''
                this.phoneOther = ''
              } else {
                this.$swal.fire({
                  icon: 'error',
                  title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                })
              }

            }
          } else {
            if (!CheckPermiss && idx == this.Permission.length - 1) {
              this.$swal.fire({
                icon: 'error',
                title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
              })
            }
          }
        })
      }
    },
    SaveToTable() {
      var CheckDupe = false
      var CheckDepMatch = false
      var countPerson = 0
      var CheckGroupExample = []
      this.ShowAlertSuc = false
      this.ShowAlertErr = false
      this.MessageSuc = ''
      this.MessageError = ''
      this.CheckPermissFunc('7001').then(resPermiss => {
        if (resPermiss) {
          if (this.project.Status_Count_Reg == '0' && this.RequestPerson.length >= parseInt(this.project.Count_Reg)) {
            this.$swal.fire({
              icon: 'error',
              title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากจำนวนผู้เข้าร่วมเกินจำนวนที่กำหนด'
            })
          } else {
            this.EmpData.map((item, EmpIdx) => {
              CheckDupe = false
              CheckDepMatch = false
              CheckGroupExample = []
              if (this.JoinPerson.filter(itemj => itemj.uid == item.perid).length > 0) {
                this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                this.ShowAlertErr = true
              } else if (this.RequestPerson.filter(itemr => itemr.perid == item.perid).length > 0) {
                this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                this.ShowAlertErr = true
              } else {
                this.staffData.map((staff_I) => {
                  if (staff_I.perid == item.perid) {
                    if (this.GroupExamData.length > 0) {
                      CheckGroupExample = this.GroupExamData.filter(item => item.PosCode == staff_I.pos_id && this.getAge(new Date(staff_I.date_in), new Date())[0] >= item.WSYear && this.getAge(new Date(staff_I.date_in), new Date())[0] <= item.WEYear)

                      if (CheckGroupExample.length > 0) {
                        if (this.DepQuotaData.length > 0) {
                          this.DepQuotaData.map((dep_quota, idx) => {
                            if (dep_quota.dep_type == '0' && !CheckDepMatch) {
                              if (staff_I.dep_id == dep_quota.dep_id) {
                                CheckDepMatch = true
                                if (this.RequestPerson.length > 0) {
                                  if (this.RequestPerson.filter(item => item.dep_id == staff_I.dep_id).length < parseInt(dep_quota.count)) {
                                    if (this.RequestPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                                      CheckDupe = true
                                    }

                                    if (!CheckDupe) {

                                      this.insertDataToDB({
                                        Project_code: this.project.Project_code,
                                        perid: staff_I.perid,
                                        status_req: '0',
                                        D_project_round_id: this.project.id,
                                        Create_By: this.MeData[0].perid,
                                        Create_Time: 'now()',
                                      }).then(res => {
                                        if (res.status) {
                                          this.RequestPerson.unshift({
                                            ...staff_I,
                                            id: res.data.id,
                                            uid: staff_I.perid,
                                            name: staff_I.name,
                                            sname: staff_I.surname,
                                            idCard: staff_I.citizen_id,
                                            affiliation: staff_I.dep_name,
                                            status_req: res.data.status_req,
                                            status_active: res.data.status_active,
                                            position: '',
                                            phone: '',
                                            remark: '',
                                            registerType_id: 0,
                                            files: []
                                          })
                                          this.MessageSuc += '<p style="font-weight: bold;color: green">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                                          this.ShowAlertSuc = true
                                        } else {
                                          this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ !!</p>'
                                          this.ShowAlertErr = true
                                        }
                                      })

                                    } else {
                                      this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                                      this.ShowAlertErr = true
                                    }
                                  } else {
                                    this.MessageError += '<p style="font-weight: bold;color: chocolate">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ จำนวนผู้เข้าร่วมของหน่วยงาน ' + staff_I.dep_name + ' เกินกำหนดที่ตั้งไว้</p>'
                                    this.ShowAlertErr = true
                                  }
                                } else {
                                  if (this.RequestPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                                    CheckDupe = true
                                  }
                                  if (!CheckDupe) {
                                    this.insertDataToDB({
                                      Project_code: this.project.Project_code,
                                      perid: staff_I.perid,
                                      status_req: '0',
                                      D_project_round_id: this.project.id,
                                      Create_By: this.MeData[0].perid,
                                      Create_Time: 'now()',
                                    }).then(res => {
                                      if (res.status) {
                                        this.RequestPerson.unshift({
                                          ...staff_I,
                                          id: res.data.id,
                                          uid: staff_I.perid,
                                          name: staff_I.name,
                                          sname: staff_I.surname,
                                          idCard: staff_I.citizen_id,
                                          affiliation: staff_I.dep_name,
                                          status_req: res.data.status_req,
                                          status_active: res.data.status_active,
                                          position: '',
                                          phone: '',
                                          remark: '',
                                          registerType_id: 0,
                                          files: []
                                        })
                                        this.MessageSuc += '<p style="font-weight: bold;color: green">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                                        this.ShowAlertSuc = true
                                      } else {
                                        this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ !!</p>'
                                        this.ShowAlertErr = true
                                      }
                                    })
                                  } else {
                                    this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                                    this.ShowAlertErr = true
                                  }
                                }
                              } else {
                                if (!CheckDepMatch && idx == this.DepQuotaData.length - 1) {
                                  if (this.ChkRequestPerson) {
                                    if (this.RequestPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                                      CheckDupe = true
                                    }
                                    if (!CheckDupe) {
                                      this.insertDataToDB({
                                        Project_code: this.project.Project_code,
                                        perid: staff_I.perid,
                                        status_req: '0',
                                        D_project_round_id: this.project.id,
                                        Create_By: this.MeData[0].perid,
                                        Create_Time: 'now()',
                                      }).then(res => {
                                        if (res.status) {
                                          this.RequestPerson.unshift({
                                            ...staff_I,
                                            id: res.data.id,
                                            uid: staff_I.perid,
                                            name: staff_I.name,
                                            sname: staff_I.surname,
                                            idCard: staff_I.citizen_id,
                                            affiliation: staff_I.dep_name,
                                            status_req: res.data.status_req,
                                            status_active: res.data.status_active,
                                            position: '',
                                            phone: '',
                                            remark: '',
                                            registerType_id: 0,
                                            files: []
                                          })
                                          this.MessageSuc += '<p style="font-weight: bold;color: green">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                                          this.ShowAlertSuc = true
                                        } else {
                                          this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ !!</p>'
                                          this.ShowAlertErr = true
                                        }
                                      })
                                    } else {
                                      this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                                      this.ShowAlertErr = true
                                    }
                                  } else {
                                    countPerson = 0
                                    this.RequestProject.map(reqP => {
                                      if (dep_quota.dep_id == reqP.dep_id) {
                                        countPerson++
                                      }
                                    })

                                    if ((this.RequestProject.length + (parseInt(this.ProjectQuotaDepCount) - countPerson)) < parseInt(this.project.Count_Reg)) {
                                      if (this.RequestPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                                        CheckDupe = true
                                      }
                                      if (!CheckDupe) {
                                        this.insertDataToDB({
                                          Project_code: this.project.Project_code,
                                          perid: staff_I.perid,
                                          status_req: '0',
                                          D_project_round_id: this.project.id,
                                          Create_By: this.MeData[0].perid,
                                          Create_Time: 'now()',
                                        }).then(res => {
                                          if (res.status) {
                                            this.RequestPerson.unshift({
                                              ...staff_I,
                                              id: res.data.id,
                                              uid: staff_I.perid,
                                              name: staff_I.name,
                                              sname: staff_I.surname,
                                              idCard: staff_I.citizen_id,
                                              affiliation: staff_I.dep_name,
                                              status_req: res.data.status_req,
                                              status_active: res.data.status_active,
                                              position: '',
                                              phone: '',
                                              remark: '',
                                              registerType_id: 0,
                                              files: []
                                            })
                                            this.MessageSuc += '<p style="font-weight: bold;color: green">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                                            this.ShowAlertSuc = true
                                          } else {
                                            this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ !!</p>'
                                            this.ShowAlertErr = true
                                          }
                                        })
                                      } else {
                                        this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                                        this.ShowAlertErr = true
                                      }
                                    } else {
                                      this.MessageError += '<p style="font-weight: bold;color: blueviolet">' + item.full_Name + ' หมดโควต้าบุคคลกรทั่วไปที่ไม่อยู่ภายใต้เงื่อนไข !!</p>'
                                      this.ShowAlertErr = true
                                    }
                                  }
                                }
                              }
                            } else {
                              //// ตรงนี้ต้องเช็ค
                              if (!CheckDepMatch) {
                                var DepGroup = this.depart.filter(item => item.dep_group_id == dep_quota.dep_id)
                                if (DepGroup.length > 0) {
                                  if (DepGroup.filter(item => item.dep_id == staff_I.dep_id).length > 0) {
                                    CheckDepMatch = true
                                    if (this.RequestPerson.length > 0) {
                                      if (this.RequestPerson.filter(item => item.dep_group_id == staff_I.dep_group_id).length < parseInt(dep_quota.count)) {
                                        if (this.RequestPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                                          CheckDupe = true
                                        }
                                        if (!CheckDupe) {
                                          this.insertDataToDB({
                                            Project_code: this.project.Project_code,
                                            perid: staff_I.perid,
                                            status_req: '0',
                                            D_project_round_id: this.project.id,
                                            Create_By: this.MeData[0].perid,
                                            Create_Time: 'now()',
                                          }).then(res => {
                                            if (res.status) {
                                              this.RequestPerson.unshift({
                                                ...staff_I,
                                                id: res.data.id,
                                                uid: staff_I.perid,
                                                name: staff_I.name,
                                                sname: staff_I.surname,
                                                idCard: staff_I.citizen_id,
                                                affiliation: staff_I.dep_name,
                                                status_req: res.data.status_req,
                                                status_active: res.data.status_active,
                                                position: '',
                                                phone: '',
                                                remark: '',
                                                registerType_id: 0,
                                                files: []
                                              })
                                              this.MessageSuc += '<p style="font-weight: bold;color: green">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                                              this.ShowAlertSuc = true
                                            } else {
                                              this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ !!</p>'
                                              this.ShowAlertErr = true
                                            }
                                          })
                                        } else {
                                          this.MessageError += '<p style="font-weight: bold;color: red"">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                                          this.ShowAlertErr = true
                                        }
                                      } else {
                                        this.MessageError += '<p style="font-weight: bold;color: chocolate"">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ จำนวนผู้เข้าร่วมของหน่วยงาน ' + staff_I.dep_name + ' เกินกำหนดที่ตั้งไว้</p>'
                                        this.ShowAlertErr = true
                                      }
                                    } else {
                                      this.insertDataToDB({
                                        Project_code: this.project.Project_code,
                                        perid: staff_I.perid,
                                        status_req: '0',
                                        D_project_round_id: this.project.id,
                                        Create_By: this.MeData[0].perid,
                                        Create_Time: 'now()',
                                      }).then(res => {
                                        if (res.status) {
                                          this.RequestPerson.unshift({
                                            ...staff_I,
                                            id: res.data.id,
                                            uid: staff_I.perid,
                                            name: staff_I.name,
                                            sname: staff_I.surname,
                                            idCard: staff_I.citizen_id,
                                            affiliation: staff_I.dep_name,
                                            status_req: res.data.status_req,
                                            status_active: res.data.status_active,
                                            position: '',
                                            phone: '',
                                            remark: '',
                                            registerType_id: 0,
                                            files: []
                                          })
                                          this.MessageSuc += '<p style="font-weight: bold;color: green">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                                          this.ShowAlertSuc = true
                                        } else {
                                          this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ !!</p>'
                                          this.ShowAlertErr = true
                                        }
                                      })
                                    }
                                  } else {
                                    countPerson = 0
                                    this.RequestProject.map(reqP => {
                                      if (DepGroup.filter(item => item.dep_id == reqP.dep_id).length > 0) {
                                        countPerson++
                                      }
                                    })

                                    if ((this.RequestProject.length + (parseInt(this.ProjectQuotaDepCount) - countPerson)) < parseInt(this.project.Count_Reg)) {
                                      if (this.RequestPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                                        CheckDupe = true
                                      }
                                      if (!CheckDupe) {
                                        this.insertDataToDB({
                                          Project_code: this.project.Project_code,
                                          perid: staff_I.perid,
                                          status_req: '0',
                                          D_project_round_id: this.project.id,
                                          Create_By: this.MeData[0].perid,
                                          Create_Time: 'now()',
                                        }).then(res => {
                                          if (res.status) {
                                            this.RequestPerson.unshift({
                                              ...staff_I,
                                              id: res.data.id,
                                              uid: staff_I.perid,
                                              name: staff_I.name,
                                              sname: staff_I.surname,
                                              idCard: staff_I.citizen_id,
                                              affiliation: staff_I.dep_name,
                                              status_req: res.data.status_req,
                                              status_active: res.data.status_active,
                                              position: '',
                                              phone: '',
                                              remark: '',
                                              registerType_id: 0,
                                              files: []
                                            })
                                            this.MessageSuc += '<p style="font-weight: bold;color: green">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                                            this.ShowAlertSuc = true
                                          } else {
                                            this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ !!</p>'
                                            this.ShowAlertErr = true
                                          }
                                        })
                                      } else {
                                        this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                                        this.ShowAlertErr = true
                                      }
                                    } else {
                                      this.MessageError += '<p style="font-weight: bold;color: blueviolet">' + item.full_Name + ' หมดโควต้าบุคคลกรทั่วไปที่ไม่อยู่ภายใต้เงื่อนไข !!</p>'
                                      this.ShowAlertErr = true
                                    }
                                  }
                                }
                              }
                            }
                          })
                        } else {
                          if (this.RequestPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                            CheckDupe = true
                          }
                          if (!CheckDupe) {
                            this.insertDataToDB({
                              Project_code: this.project.Project_code,
                              perid: staff_I.perid,
                              status_req: '0',
                              D_project_round_id: this.project.id,
                              Create_By: this.MeData[0].perid,
                              Create_Time: 'now()',
                            }).then(res => {
                              if (res.status) {
                                this.RequestPerson.unshift({
                                  ...staff_I,
                                  id: res.data.id,
                                  uid: staff_I.perid,
                                  name: staff_I.name,
                                  sname: staff_I.surname,
                                  idCard: staff_I.citizen_id,
                                  affiliation: staff_I.dep_name,
                                  status_req: res.data.status_req,
                                  status_active: res.data.status_active,
                                  position: '',
                                  phone: '',
                                  remark: '',
                                  registerType_id: 0,
                                  files: []
                                })
                                this.MessageSuc += '<p style="font-weight: bold;color: green">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                                this.ShowAlertSuc = true
                              } else {
                                this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ !!</p>'
                                this.ShowAlertErr = true
                              }
                            })
                          } else {
                            this.MessageError += '<p style="font-weight: bold;color: red"">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                            this.ShowAlertErr = true
                          }
                        }
                      } else {
                        this.MessageError += '<p style="font-weight: bold;color: darkcyan">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ เงื่อนไขอายุงานกลุ่มตัวอย่าง ไม่ตรงกับอายุงานของบุคลากรที่เลือก</p>'
                        this.ShowAlertErr = true
                      }
                    } else if (this.DepQuotaData.length > 0) {
                      this.DepQuotaData.map((dep_quota, idx) => {
                        if (dep_quota.dep_type == '0' && !CheckDepMatch) {
                          if (staff_I.dep_id == dep_quota.dep_id) {
                            CheckDepMatch = true
                            if (this.RequestPerson.length > 0) {
                              if (this.RequestPerson.filter(item => item.dep_id == staff_I.dep_id).length < parseInt(dep_quota.count)) {
                                if (this.RequestPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                                  CheckDupe = true
                                }

                                if (!CheckDupe) {
                                  this.insertDataToDB({
                                    Project_code: this.project.Project_code,
                                    perid: staff_I.perid,
                                    status_req: '0',
                                    D_project_round_id: this.project.id,
                                    Create_By: this.MeData[0].perid,
                                    Create_Time: 'now()',
                                  }).then(res => {
                                    if (res.status) {
                                      this.RequestPerson.unshift({
                                        ...staff_I,
                                        id: res.data.id,
                                        uid: staff_I.perid,
                                        name: staff_I.name,
                                        sname: staff_I.surname,
                                        idCard: staff_I.citizen_id,
                                        affiliation: staff_I.dep_name,
                                        status_req: res.data.status_req,
                                        status_active: res.data.status_active,
                                        position: '',
                                        phone: '',
                                        remark: '',
                                        registerType_id: 0,
                                        files: [],
                                        Del: true,
                                      })
                                      this.MessageSuc += '<p style="font-weight: bold;color: green">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                                      this.ShowAlertSuc = true
                                    } else {
                                      this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ !!</p>'
                                      this.ShowAlertErr = true
                                    }
                                  })
                                } else {
                                  this.MessageError += '<p style="font-weight: bold;color: red"">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                                  this.ShowAlertErr = true
                                }
                              } else {
                                this.MessageError += '<p style="font-weight: bold;color: chocolate"">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ จำนวนผู้เข้าร่วมของหน่วยงาน ' + staff_I.dep_name + ' เกินกำหนดที่ตั้งไว้</p>'
                                this.ShowAlertErr = true
                              }
                            } else {
                              if (this.RequestPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                                CheckDupe = true
                              }
                              if (!CheckDupe) {
                                this.insertDataToDB({
                                  Project_code: this.project.Project_code,
                                  perid: staff_I.perid,
                                  status_req: '0',
                                  D_project_round_id: this.project.id,
                                  Create_By: this.MeData[0].perid,
                                  Create_Time: 'now()',
                                }).then(res => {
                                  if (res.status) {
                                    this.RequestPerson.unshift({
                                      ...staff_I,
                                      id: res.data.id,
                                      uid: staff_I.perid,
                                      name: staff_I.name,
                                      sname: staff_I.surname,
                                      idCard: staff_I.citizen_id,
                                      affiliation: staff_I.dep_name,
                                      status_req: res.data.status_req,
                                      status_active: res.data.status_active,
                                      position: '',
                                      phone: '',
                                      remark: '',
                                      registerType_id: 0,
                                      files: []
                                    })
                                    this.MessageSuc += '<p style="font-weight: bold;color: green">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                                    this.ShowAlertSuc = true
                                  } else {
                                    this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ !!</p>'
                                    this.ShowAlertErr = true
                                  }
                                })
                              } else {
                                this.MessageError += '<p style="font-weight: bold;color: red"">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                                this.ShowAlertErr = true
                              }
                            }
                          } else {
                            if (!CheckDepMatch && idx == this.DepQuotaData.length - 1) {
                              if (this.project.Status_Count_Reg == '1') {
                                if (this.RequestPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                                  CheckDupe = true
                                }
                                if (!CheckDupe) {
                                  this.insertDataToDB({
                                    Project_code: this.project.Project_code,
                                    perid: staff_I.perid,
                                    status_req: '0',
                                    D_project_round_id: this.project.id,
                                    Create_By: this.MeData[0].perid,
                                    Create_Time: 'now()',
                                  }).then(res => {
                                    if (res.status) {
                                      this.RequestPerson.unshift({
                                        ...staff_I,
                                        id: res.data.id,
                                        uid: staff_I.perid,
                                        name: staff_I.name,
                                        sname: staff_I.surname,
                                        idCard: staff_I.citizen_id,
                                        affiliation: staff_I.dep_name,
                                        status_req: res.data.status_req,
                                        status_active: res.data.status_active,
                                        position: '',
                                        phone: '',
                                        remark: '',
                                        registerType_id: 0,
                                        files: []
                                      })
                                      this.MessageSuc += '<p style="font-weight: bold;color: green">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                                      this.ShowAlertSuc = true
                                    } else {
                                      this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ !!</p>'
                                      this.ShowAlertErr = true
                                    }
                                  })
                                } else {
                                  this.MessageError += '<p style="font-weight: bold;color: red"">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                                  this.ShowAlertErr = true
                                }
                              } else {
                                countPerson = 0
                                this.RequestProject.map(reqP => {
                                  if (dep_quota.dep_id == reqP.dep_id) {
                                    countPerson++
                                  }
                                })

                                if ((this.RequestProject.length + (parseInt(this.ProjectQuotaDepCount) - countPerson)) < parseInt(this.project.Count_Reg)) {
                                  if (this.RequestPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                                    CheckDupe = true
                                  }
                                  if (!CheckDupe) {
                                    this.insertDataToDB({
                                      Project_code: this.project.Project_code,
                                      perid: staff_I.perid,
                                      status_req: '0',
                                      D_project_round_id: this.project.id,
                                      Create_By: this.MeData[0].perid,
                                      Create_Time: 'now()',
                                    }).then(res => {
                                      if (res.status) {
                                        this.RequestPerson.unshift({
                                          ...staff_I,
                                          id: res.data.id,
                                          uid: staff_I.perid,
                                          name: staff_I.name,
                                          sname: staff_I.surname,
                                          idCard: staff_I.citizen_id,
                                          affiliation: staff_I.dep_name,
                                          status_req: res.data.status_req,
                                          status_active: res.data.status_active,
                                          position: '',
                                          phone: '',
                                          remark: '',
                                          registerType_id: 0,
                                          files: []
                                        })
                                        this.MessageSuc += '<p style="font-weight: bold;color: green">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                                        this.ShowAlertSuc = true
                                      } else {
                                        this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ !!</p>'
                                        this.ShowAlertErr = true
                                      }
                                    })
                                  } else {
                                    this.MessageError += '<p style="font-weight: bold;color: red"">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                                    this.ShowAlertErr = true
                                  }
                                } else {
                                  this.MessageError += '<p style="font-weight: bold;color: blueviolet">' + item.full_Name + ' หมดโควต้าบุคคลกรทั่วไปที่ไม่อยู่ภายใต้เงื่อนไข !!</p>'
                                  this.ShowAlertErr = true
                                }
                              }
                            }
                          }
                        } else {
                          //// ตรงนี้ต้องเช็ค
                          if (!CheckDepMatch) {
                            var DepGroup = this.depart.filter(item => item.dep_group_id == dep_quota.dep_id)
                            if (DepGroup.length > 0) {
                              if (DepGroup.filter(item => item.dep_id == staff_I.dep_id).length > 0) {
                                CheckDepMatch = true
                                if (this.RequestPerson.length > 0) {
                                  if (this.RequestPerson.filter(item => item.dep_group_id == staff_I.dep_group_id).length < parseInt(dep_quota.count)) {
                                    if (this.RequestPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                                      CheckDupe = true
                                    }
                                    if (!CheckDupe) {
                                      this.insertDataToDB({
                                        Project_code: this.project.Project_code,
                                        perid: staff_I.perid,
                                        status_req: '0',
                                        D_project_round_id: this.project.id,
                                        Create_By: this.MeData[0].perid,
                                        Create_Time: 'now()',
                                      }).then(res => {
                                        if (res.status) {
                                          this.RequestPerson.unshift({
                                            ...staff_I,
                                            id: res.data.id,
                                            uid: staff_I.perid,
                                            name: staff_I.name,
                                            sname: staff_I.surname,
                                            idCard: staff_I.citizen_id,
                                            affiliation: staff_I.dep_name,
                                            status_req: res.data.status_req,
                                            status_active: res.data.status_active,
                                            position: '',
                                            phone: '',
                                            remark: '',
                                            registerType_id: 0,
                                            files: []
                                          })
                                          this.MessageSuc += '<p style="font-weight: bold;color: green">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                                          this.ShowAlertSuc = true
                                        } else {
                                          this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ !!</p>'
                                          this.ShowAlertErr = true
                                        }
                                      })
                                    } else {
                                      this.MessageError += '<p style="font-weight: bold;color: red"">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                                      this.ShowAlertErr = true
                                    }
                                  } else {
                                    this.MessageError += '<p style="font-weight: bold;color: chocolate"">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ จำนวนผู้เข้าร่วมของหน่วยงาน ' + staff_I.dep_name + ' เกินกำหนดที่ตั้งไว้</p>'
                                    this.ShowAlertErr = true
                                  }
                                } else {
                                  this.insertDataToDB({
                                    Project_code: this.project.Project_code,
                                    perid: staff_I.perid,
                                    status_req: '0',
                                    D_project_round_id: this.project.id,
                                    Create_By: this.MeData[0].perid,
                                    Create_Time: 'now()',
                                  }).then(res => {
                                    if (res.status) {
                                      this.RequestPerson.unshift({
                                        ...staff_I,
                                        id: res.data.id,
                                        uid: staff_I.perid,
                                        name: staff_I.name,
                                        sname: staff_I.surname,
                                        idCard: staff_I.citizen_id,
                                        affiliation: staff_I.dep_name,
                                        status_req: res.data.status_req,
                                        status_active: res.data.status_active,
                                        position: '',
                                        phone: '',
                                        remark: '',
                                        registerType_id: 0,
                                        files: []
                                      })
                                      this.MessageSuc += '<p style="font-weight: bold;color: green">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                                      this.ShowAlertSuc = true
                                    } else {
                                      this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ !!</p>'
                                      this.ShowAlertErr = true
                                    }
                                  })
                                }
                              } else {
                                countPerson = 0
                                this.RequestProject.map(reqP => {
                                  if (DepGroup.filter(item => item.dep_id == reqP.dep_id).length > 0) {
                                    countPerson++
                                  }
                                })

                                if ((this.RequestProject.length + (parseInt(this.ProjectQuotaDepCount) - countPerson)) < parseInt(this.project.Count_Reg)) {
                                  if (this.RequestPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                                    CheckDupe = true
                                  }
                                  if (!CheckDupe) {
                                    this.insertDataToDB({
                                      Project_code: this.project.Project_code,
                                      perid: staff_I.perid,
                                      status_req: '0',
                                      D_project_round_id: this.project.id,
                                      Create_By: this.MeData[0].perid,
                                      Create_Time: 'now()',
                                    }).then(res => {
                                      if (res.status) {
                                        this.RequestPerson.unshift({
                                          ...staff_I,
                                          id: res.data.id,
                                          uid: staff_I.perid,
                                          name: staff_I.name,
                                          sname: staff_I.surname,
                                          idCard: staff_I.citizen_id,
                                          affiliation: staff_I.dep_name,
                                          status_req: res.data.status_req,
                                          status_active: res.data.status_active,
                                          position: '',
                                          phone: '',
                                          remark: '',
                                          registerType_id: 0,
                                          files: []
                                        })
                                        this.MessageSuc += '<p style="font-weight: bold;color: green">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                                        this.ShowAlertSuc = true
                                      } else {
                                        this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ !!</p>'
                                        this.ShowAlertErr = true
                                      }
                                    })
                                  } else {
                                    this.MessageError += '<p style="font-weight: bold;color: red"">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                                    this.ShowAlertErr = true
                                  }
                                } else {
                                  this.MessageError += '<p style="font-weight: bold;color: blueviolet">' + item.full_Name + ' หมดโควต้าบุคคลกรทั่วไปที่ไม่อยู่ภายใต้เงื่อนไข !!</p>'
                                  this.ShowAlertErr = true
                                }
                              }
                            }
                          }
                        }
                      })
                    } else {
                      // backup โค๊ดเช็คจำนวนผู้เข้าร่วมทั่วไป รอดูผลกระทบ
                      // if (this.RequestPerson.length < parseInt(this.project.Count_Reg)) {
                      if (this.RequestPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                        CheckDupe = true
                      }
                      if (!CheckDupe) {
                        this.insertDataToDB({
                          Project_code: this.project.Project_code,
                          perid: staff_I.perid,
                          status_req: '0',
                          D_project_round_id: this.project.id,
                          Create_By: this.MeData[0].perid,
                          Create_Time: 'now()',
                        }).then(res => {
                          if (res.status) {
                            this.RequestPerson.unshift({
                              ...staff_I,
                              id: res.data.id,
                              uid: staff_I.perid,
                              name: staff_I.name,
                              sname: staff_I.surname,
                              idCard: staff_I.citizen_id,
                              affiliation: staff_I.dep_name,
                              status_req: res.data.status_req,
                              status_active: res.data.status_active,
                              position: '',
                              phone: '',
                              remark: '',
                              registerType_id: 0,
                              files: []
                            })
                            this.MessageSuc += '<p style="font-weight: bold;color: green">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                            this.ShowAlertSuc = true
                          } else {
                            this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ !!</p>'
                            this.ShowAlertErr = true
                          }
                        })
                      } else {
                        this.MessageError += '<p style="font-weight: bold;color: red"">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                        this.ShowAlertErr = true
                      }
                      // } else {
                      //   this.MessageError += '<p style="font-weight: bold;color: red"">' + item.full_Name + ' เนื่องจากหมดโควต้าบุคคลกรทั่วไปที่ไม่อยู่ภายใต้เงื่อนไข !!</p>'
                      //   this.ShowAlertErr = true
                      // }
                    }
                  }
                })
                if (EmpIdx == this.EmpData.length - 1) {
                  this.EmpData = []
                  this.items = []
                  this.departSel = ''
                }
              }
            })
          }
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
          })
        }
      })
    },
    SaveToTable_owner() {
      var CheckDupe = false
      this.MessageError = ''
      this.MessageSuc = ''
      this.CheckPermissFunc('7001').then(resPermiss => {
        if (resPermiss) {
          this.EmpData.map((item) => {
            CheckDupe = false
            if (this.JoinPerson.filter(itemj => itemj.uid == item.perid).length > 0) {
              this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
              this.ShowAlertErr = true
            } else if (this.RequestPerson.filter(itemr => itemr.perid == item.perid).length > 0) {
              this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
              this.ShowAlertErr = true
            } else {
              if (this.JoinPerson.filter(Join_I => Join_I.uid == item.perid).length > 0) {
                CheckDupe = true
              }
              if (!CheckDupe) {

                this.insertDataToDB({
                  Project_code: this.project.Project_code,
                  perid: item.perid,
                  status_req: '0',
                  D_project_round_id: this.project.id,
                  Create_By: this.MeData[0].perid,
                  Create_Time: 'now()',
                }).then(res => {
                  if (res.status) {
                    this.RequestPerson.unshift({
                      ...item,
                      id: res.data.id,
                      uid: item.perid,
                      name: item.name,
                      sname: item.surname,
                      idCard: item.citizen_id,
                      affiliation: item.dep_name,
                      status_req: res.data.status_req,
                      status_active: res.data.status_active,
                      position: '',
                      phone: '',
                      remark: '',
                      registerType_id: 0,
                      files: [],
                      Del: true,
                    })
                    this.MessageSuc += '<p style="font-weight: bold;color: green"">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                    this.ShowAlertSuc = true
                  } else {
                    this.MessageError += '<p style="font-weight: bold;color: red"">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                    this.ShowAlertErr = true
                  }
                })
              } else {
                this.MessageError += '<p style="font-weight: bold;color: red"">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                this.ShowAlertErr = true
              }
            }
          })
          this.EmpData = []
          this.items = []
          this.departSel = ''
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
          })
        }
      })
    },
    GetDateNow() {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();

      return yyyy + '-' + mm + '-' + dd;
    },
    showDetails: async function (item) {
      var CheckCordi = false
      var CheckCordi2 = '0'
      if (this.Details_Cordi) {
        this.project = null
        this.Details_Cordi = false
      } else {
        if (item.Owner) {
          this.project = item
          this.Details_Cordi = true;
          this.JoinPerson = []
          this.RequestPerson = []
          this.DepQuotaData = []
          this.departGroupDump = []
          this.ProjectQuotaDepCount = 0
          this.GroupExamData = []

          this.QoutaDepDataDump = this.UniqueArraybyId(this.QoutaDepData, 'id')
          if (item.IsRoundStatus == '0') {
            this.QoutaDepDataDump = this.QoutaDepDataDump.filter(item => item.Project_code == this.project.Project_code)
          } else {
            this.QoutaDepDataDump = this.QoutaDepDataDump.filter(item => item.Project_code == this.project.Project_code && item.D_project_round_id == this.project.id)
          }

          if (this.QoutaDepDataDump.length > 0) {
            this.QoutaDepDataDump.map(DepQ => {
              this.ProjectQuotaDepCount += parseInt(DepQ.count)
            })
            this.DepQuotaData = this.QoutaDepDataDump
          }

          if (this.Permission_Dep.length > 0) {
            this.Permission_Dep.map(per_i => {
              this.departGroupDump = this.departGroupDump.concat(this.depart.filter(dep_i => dep_i.dep_id == per_i.dep_id))
            })
          } else if (this.Permission_Dep_User.length > 0) {
            this.Permission_Dep_User.map(per_i => {
              this.departGroupDump = this.departGroupDump.concat(this.depart.filter(dep_i => dep_i.dep_id == per_i.dep_id))
            })
          }

          await this.initPersonFileData({
            Project_code: item.Project_code
          }).catch(res => {
            if (res) {
              console.log('no files in project')
            }
          })

          this.initGroupExamProject({
            Project_code: this.project.Project_code
          }).then(resGroup => {
            if (resGroup) {
              if (item.IsRoundStatus == '0') {
                this.GroupExamData = this.GroupExamProject
              } else {
                var GroupExDump = this.GroupExamProject.filter(GroupI => GroupI.D_project_round_id == item.id)
                if (GroupExDump.length > 0) {
                  this.GroupExamData = GroupExDump
                }
              }
            }
          })

          this.initJoinProject({
            Project_code: item.Project_code
          }).then(resJoin => {
            if (resJoin) {
              if (item.IsRoundStatus == '0') {
                this.JoinProject.map(Join_i => {
                  this.JoinPerson.unshift({
                    ...Join_i,
                    full_Name: Join_i.name + ' ' + Join_i.sname,
                    idCard: Join_i.id_card,
                    status_reg_person: '0',
                    files: (this.PersonFiles.length > 0 ? this.PersonFiles.filter(itemP => itemP.Project_code == item.Project_code && itemP.perid == Join_i.uid) : [])
                  })
                })
              } else {
                var JoinDump = this.JoinProject.filter(Join_i => Join_i.D_project_round_id == item.id)
                if (JoinDump.length > 0) {
                  JoinDump.map(Join_i => {
                    this.JoinPerson.unshift({
                      ...Join_i,
                      full_Name: Join_i.name + ' ' + Join_i.sname,
                      idCard: Join_i.id_card,
                      status_reg_person: '0',
                      files: (this.PersonFiles.length > 0 ? this.PersonFiles.filter(itemP => itemP.Project_code == item.Project_code && itemP.perid == Join_i.uid) : [])
                    })
                  })
                }
              }
            }
          })

          this.initRequestProject({
            Project_code: item.Project_code
          }).then(res => {
            if (res) {
              var Del = false
              if (item.IsRoundStatus == '0') {
                if (this.RequestProject.length > 0) {
                  this.staffData.map((staff_I) => {
                    Del = false
                    this.RequestProject.map(itemReq => {
                      if (staff_I.perid == itemReq.perid && (itemReq.D_project_round_id == '' || itemReq.D_project_round_id == null)) {
                        var CheckPermissDel = []
                        if (this.Permission_Dep.length > 0) {
                          CheckPermissDel = this.Permission_Dep.filter(Dep_i => Dep_i.dep_id == staff_I.dep_id)
                        } else if(this.Permission_Dep_User.length > 0) {
                          CheckPermissDel = this.Permission_Dep_User.filter(Dep_i => Dep_i.dep_id == staff_I.dep_id)
                        }
                        if (CheckPermissDel.length > 0) {
                          Del = true
                        } else {
                          Del = false
                        }
                        this.RequestPerson.unshift({
                          ...staff_I,
                          id: itemReq.id,
                          uid: staff_I.perid,
                          name: staff_I.name,
                          sname: staff_I.surname,
                          idCard: staff_I.citizen_id,
                          affiliation: staff_I.dep_name,
                          status_req: itemReq.status_req,
                          status_active: itemReq.status_active,
                          position: '',
                          phone: '',
                          remark: itemReq.remark,
                          registerType_id: 0,
                          Del: Del,
                          files: (this.PersonFiles.length > 0 ? this.PersonFiles.filter(itemP => itemP.Project_code == item.Project_code && itemP.perid == staff_I.perid) : [])
                        })
                      }
                    })
                  })
                }
              } else {
                if (this.RequestProject.length > 0) {
                  var RequestDump = this.RequestProject.filter(RequestI => RequestI.D_project_round_id == item.id)
                  if (RequestDump.length > 0) {
                    this.staffData.map((staff_I) => {
                      Del = false
                      RequestDump.map(itemReq => {
                        if (staff_I.perid == itemReq.perid) {
                          var CheckPermissDel = []
                          if (this.Permission_Dep.length > 0) {
                            CheckPermissDel = this.Permission_Dep.filter(Dep_i => Dep_i.dep_id == staff_I.dep_id)
                          } else if(this.Permission_Dep_User.length > 0) {
                            CheckPermissDel = this.Permission_Dep_User.filter(Dep_i => Dep_i.dep_id == staff_I.dep_id)
                          }
                          if (CheckPermissDel.length > 0) {
                            Del = true
                          } else {
                            Del = false
                          }
                          this.RequestPerson.unshift({
                            ...staff_I,
                            id: itemReq.id,
                            uid: staff_I.perid,
                            name: staff_I.name,
                            sname: staff_I.surname,
                            idCard: staff_I.citizen_id,
                            affiliation: staff_I.dep_name,
                            status_req: itemReq.status_req,
                            status_active: itemReq.status_active,
                            position: '',
                            phone: '',
                            remark: itemReq.remark,
                            registerType_id: 0,
                            Del: Del,
                            files: (this.PersonFiles.length > 0 ? this.PersonFiles.filter(itemP => itemP.Project_code == item.Project_code && itemP.perid == staff_I.perid) : [])
                          })
                        }
                      })
                    })
                  }
                }
              }
            }
          })
        } else {
          if ((item.DateS_Reg != null && item.DateS_Reg != '0000-00-00') && (item.DateE_Reg != null && item.DateE_Reg != '0000-00-00')) {
            if ((this.GetDateNow() >= item.DateS_Reg) && (this.GetDateNow() <= item.DateE_Reg)) {
              CheckCordi = true
            } else {
              CheckCordi = false
              CheckCordi2 = '1'
            }
          } else if ((item.DateS_Reg != null && item.DateS_Reg != '0000-00-00') && (item.DateE_Reg == null || item.DateE_Reg == '0000-00-00')) {
            if (this.GetDateNow() >= item.DateS_Reg) {
              CheckCordi = true
            } else {
              CheckCordi = false
              CheckCordi2 = '2'
            }
          } else if ((item.DateS_Reg == null || item.DateS_Reg == '0000-00-00') && (item.DateE_Reg != null && item.DateE_Reg != '0000-00-00')) {
            if (this.GetDateNow() <= item.DateE_Reg) {
              CheckCordi = true
            } else {
              CheckCordi = false
              CheckCordi2 = '3'
            }
          } else {
            CheckCordi = false
            CheckCordi2 = '4'
          }

          if (CheckCordi) {
            this.project = item
            this.Details_Cordi = true;
            this.JoinPerson = []
            this.RequestPerson = []
            this.departGroupDump = []
            this.DepQuotaData = []
            this.ProjectQuotaDepCount = 0
            this.GroupExamData = []

            this.QoutaDepDataDump = this.UniqueArraybyId(this.QoutaDepData, 'id')
            if (item.IsRoundStatus == '0') {
              this.QoutaDepDataDump = this.QoutaDepDataDump.filter(item => item.Project_code == this.project.Project_code)
            } else {
              this.QoutaDepDataDump = this.QoutaDepDataDump.filter(item => item.Project_code == this.project.Project_code && item.D_project_round_id == this.project.id)
            }

            if (this.QoutaDepDataDump.length > 0) {
              this.QoutaDepDataDump.map(DepQ => {
                this.ProjectQuotaDepCount += parseInt(DepQ.count)
              })
              this.DepQuotaData = this.QoutaDepDataDump
            }

            if (this.Permission_Dep.length > 0) {
              this.Permission_Dep.map(per_i => {
                this.departGroupDump = this.departGroupDump.concat(this.depart.filter(dep_i => dep_i.dep_id == per_i.dep_id))
              })
            } else if (this.Permission_Dep_User.length > 0) {
              this.Permission_Dep_User.map(per_i => {
                this.departGroupDump = this.departGroupDump.concat(this.depart.filter(dep_i => dep_i.dep_id == per_i.dep_id))
              })
            }

            await this.initPersonFileData({
              Project_code: this.projectData[0].Project_code
            }).catch(res => {
              if (res) {
                console.log('no files in project')
              }
            })

            this.initGroupExamProject({
              Project_code: this.project.Project_code
            }).then(resGroup => {
              if (resGroup) {
                if (item.IsRoundStatus == '0') {
                  this.GroupExamData = this.GroupExamProject
                } else {
                  var GroupExDump = this.GroupExamProject.filter(GroupI => GroupI.D_project_round_id == item.id)
                  if (GroupExDump.length > 0) {
                    this.GroupExamData = GroupExDump
                  }
                }
              }
            })


            this.initJoinProject({
              Project_code: item.Project_code
            }).then(resJoin => {
              if (resJoin) {
                if (item.IsRoundStatus == '0') {
                  this.JoinProject.map(Join_i => {
                    this.JoinPerson.unshift({
                      ...Join_i,
                      full_Name: Join_i.name + ' ' + Join_i.sname,
                      idCard: Join_i.id_card,
                      status_reg_person: '0',
                      files: (this.PersonFiles.length > 0 ? this.PersonFiles.filter(itemP => itemP.Project_code == item.Project_code && itemP.perid == Join_i.uid) : [])
                    })
                  })
                } else {
                  var JoinDump = this.JoinProject.filter(Join_i => Join_i.D_project_round_id == item.id)
                  if (JoinDump.length > 0) {
                    JoinDump.map(Join_i => {
                      this.JoinPerson.unshift({
                        ...Join_i,
                        full_Name: Join_i.name + ' ' + Join_i.sname,
                        idCard: Join_i.id_card,
                        status_reg_person: '0',
                        files: (this.PersonFiles.length > 0 ? this.PersonFiles.filter(itemP => itemP.Project_code == item.Project_code && itemP.perid == Join_i.uid) : [])
                      })
                    })
                  }
                }
              }
            })

            this.initRequestProject({
              Project_code: item.Project_code
            }).then(res => {
              if (res) {
                var Del = false
                if (item.IsRoundStatus == '0') {
                  if (this.RequestProject.length > 0) {
                    this.staffData.map((staff_I) => {
                      Del = false
                      this.RequestProject.map(itemReq => {
                        if (staff_I.perid == itemReq.perid) {
                          var CheckPermissDel = []
                          if (this.Permission_Dep.length > 0) {
                            CheckPermissDel = this.Permission_Dep.filter(Dep_i => Dep_i.dep_id == staff_I.dep_id)
                          } else if(this.Permission_Dep_User.length > 0) {
                            CheckPermissDel = this.Permission_Dep_User.filter(Dep_i => Dep_i.dep_id == staff_I.dep_id)
                          }
                          if (CheckPermissDel.length > 0) {
                            Del = true
                          } else {
                            Del = false
                          }
                          this.RequestPerson.unshift({
                            ...staff_I,
                            id: itemReq.id,
                            uid: staff_I.perid,
                            name: staff_I.name,
                            sname: staff_I.surname,
                            idCard: staff_I.citizen_id,
                            affiliation: staff_I.dep_name,
                            status_req: itemReq.status_req,
                            status_active: itemReq.status_active,
                            position: '',
                            phone: '',
                            remark: itemReq.remark,
                            registerType_id: 0,
                            Del: Del,
                            files: (this.PersonFiles.length > 0 ? this.PersonFiles.filter(itemP => itemP.Project_code == item.Project_code && itemP.perid == staff_I.perid) : [])
                          })
                        }
                      })
                    })
                  }
                } else {
                  if (this.RequestProject.length > 0) {
                    var RequestDump = this.RequestProject.filter(RequestI => RequestI.D_project_round_id == item.id)
                    if (RequestDump.length > 0) {
                      this.staffData.map((staff_I) => {
                        Del = false
                        RequestDump.map(itemReq => {
                          if (staff_I.perid == itemReq.perid) {
                            var CheckPermissDel = []
                            if (this.Permission_Dep.length > 0) {
                              CheckPermissDel = this.Permission_Dep.filter(Dep_i => Dep_i.dep_id == staff_I.dep_id)
                            } else if(this.Permission_Dep_User.length > 0) {
                              CheckPermissDel = this.Permission_Dep_User.filter(Dep_i => Dep_i.dep_id == staff_I.dep_id)
                            }
                            if (CheckPermissDel.length > 0) {
                              Del = true
                            } else {
                              Del = false
                            }
                            this.RequestPerson.unshift({
                              ...staff_I,
                              id: itemReq.id,
                              uid: staff_I.perid,
                              name: staff_I.name,
                              sname: staff_I.surname,
                              idCard: staff_I.citizen_id,
                              affiliation: staff_I.dep_name,
                              status_req: itemReq.status_req,
                              status_active: itemReq.status_active,
                              position: '',
                              phone: '',
                              remark: itemReq.remark,
                              registerType_id: 0,
                              Del: Del,
                              files: (this.PersonFiles.length > 0 ? this.PersonFiles.filter(itemP => itemP.Project_code == item.Project_code && itemP.perid == staff_I.perid) : [])
                            })
                          }
                        })
                      })
                    }
                  }
                }
              }
            })
          } else {
            switch (CheckCordi2) {
              case "1":
                this.$swal.fire({
                  icon: 'error',
                  title: 'ไม่สามารถสมัครเข้าร่วมได้ เนื่องจากไม่ได้อยู่ในช่วงรับที่เปิดรับสมัคร'
                })
                break
              case "2":
                this.$swal.fire({
                  icon: 'error',
                  title: 'ไม่สามารถสมัครเข้าร่วมได้ เนื่องจากยังไม่ถึงวันที่เปิดรับสมัคร'
                })
                break
              case "3":
                this.$swal.fire({
                  icon: 'error',
                  title: 'ไม่สามารถสมัครเข้าร่วมได้ หมดระยะเวลาการรับสมัคร'
                })
                break
              case "4":
                this.$swal.fire({
                  icon: 'error',
                  title: 'ไม่สามารถสมัครเข้าร่วมได้ เนื่องจากไม่ระบุวันที่ เปิด - ปิด การรับสมัคร'
                })
                break
              default:
                break
            }
          }
        }
      }
    },
    insertDataToDB(RegObj) {
      return new Promise(resolve => {
        const headerAxios = {
          headers: {
            'Content-Type': 'application/json',
            'X-REST-METHOD': 'PUT'
          }
        }
        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/request_project', RegObj, headerAxios).then(res => {
          if (res.data.status) {
            axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/request_project/Project_code/' + RegObj.Project_code + '/perid/' + RegObj.perid + '/?limit=1', '', headerAxios).then(resGet => {
              resolve({
                status: true,
                data: resGet.data
              })
            })
          } else {
            resolve({
              status: false,
              data: ''
            })
          }
        })
      })
    },
    GetDateTime() {
      var date;
      date = new Date();
      date = date.getUTCFullYear() + '-' +
          ('00' + (date.getUTCMonth() + 1)).slice(-2) + '-' +
          ('00' + date.getUTCDate()).slice(-2) + ' ' +
          ('00' + date.getUTCHours()).slice(-2) + ':' +
          ('00' + date.getUTCMinutes()).slice(-2) + ':' +
          ('00' + date.getUTCSeconds()).slice(-2);
      return date
    }
  },
  mounted() {
    this.dialogLoading = true
    this.changeHeaderPage({
      page: '2'
    })
    this.changeJoinProjectPage({
      page: '0'
    })
    this.initMeData().then(async res => {
      if (res) {
        await this.getIgnoreSubMenuPermissData({
          perid: this.MeData[0].perid,
          page_id: '10',
          page_sub_id: '8',
        })
        this.getPermissionData({
          perid: this.MeData[0].perid
        }).then(resAdmin => {
          if (resAdmin) {
            this.PermissionAdmin.map((Per_i, idx) => {
              if (Per_i.permission_id == '7000') {
                this.getSubMenuPermissData().then(res => {
                  if (res) {
                    if (this.SubMenuPermiss.length > 0 && this.SubMenuPermiss.filter(item => item.page_sub_id == '8' && item.page_status == '1').length > 0 || this.IgnoreSubMenuPermiss.filter(item => item.perid == this.MeData[0].perid).length > 0) {
                      this.maintain = false
                      this.init()
                    } else {
                      this.pageMessage = this.SubMenuPermiss.filter(item => item.page_sub_id == '8' && item.page_message != null).length > 0 ? this.SubMenuPermiss.filter(item => item.page_sub_id == '8')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
                      this.maintain = true
                      this.dialogLoading = false
                    }
                  }
                }).then(err => {
                  if (err) {
                    this.pageMessage = this.SubMenuPermiss.filter(item => item.page_sub_id == '8' && item.page_message != null).length > 0 ? this.SubMenuPermiss.filter(item => item.page_sub_id == '8')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
                    this.maintain = true
                    this.dialogLoading = false
                  }
                })
                this.CheckAdmin = true
              } else {
                if (!this.CheckAdmin && idx == this.PermissionAdmin.length - 1) {
                  this.dialogLoading = false
                  this.$router.push('/')
                }
              }
            })
          } else {
            this.getPermissionUserData({
              perid: this.MeData[0].perid
            }).then(resUser => {
              if (resUser) {
                this.Permission.map((Per_i, idx) => {
                  if (Per_i.permission_id == '7000') {
                    this.getSubMenuPermissData().then(res => {
                      if (res) {
                        if (this.SubMenuPermiss.length > 0 && this.SubMenuPermiss.filter(item => item.page_sub_id == '8' && item.page_status == '1').length > 0 || this.IgnoreSubMenuPermiss.filter(item => item.perid == this.MeData[0].perid).length > 0) {
                          this.maintain = false
                          this.init()
                        } else {
                          this.pageMessage = this.SubMenuPermiss.filter(item => item.page_sub_id == '8' && item.page_message != null).length > 0 ? this.SubMenuPermiss.filter(item => item.page_sub_id == '8')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
                          this.maintain = true
                          this.dialogLoading = false
                        }
                      }
                    }).then(err => {
                      if (err) {
                        this.pageMessage = this.SubMenuPermiss.filter(item => item.page_sub_id == '8' && item.page_message != null).length > 0 ? this.SubMenuPermiss.filter(item => item.page_sub_id == '8')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
                        this.maintain = true
                        this.dialogLoading = false
                      }
                    })
                    this.CheckSubAdmin = true
                  } else {
                    if (!this.CheckSubAdmin && idx == this.Permission.length - 1) {
                      this.dialogLoading = false
                      this.$router.push('/')
                    }
                  }
                })
              } else {
                this.dialogLoading = false
                this.CheckSubAdmin = false
                this.CheckAdmin = false
                this.$router.push('/')
              }
            })
          }
        })
      }
    }).catch(reason => {
      console.log('Reject = ' + reason)
    })
  }
}
</script>

<style scoped>
.v-label {
  color: black;
}

.v-card {
  border: 1px solid;
}

.v-text-field >>> input {
  color: black;
}

.v-text-field >>> label {
  color: black;
  font-weight: bold;
}

.v-text-field >>> button {
  font-size: 0.1em;
}
</style>
